import * as Yt from "vue";
import { openBlock as c, createElementBlock as m, createElementVNode as u, defineComponent as O, createVNode as V, unref as $, createCommentVNode as L, renderSlot as D, normalizeClass as W, computed as y, mergeProps as K, withDirectives as ce, vShow as qe, createBlock as M, withCtx as k, resolveDynamicComponent as Ve, toDisplayString as F, createTextVNode as ne, Fragment as le, renderList as de, shallowRef as wn, watch as te, triggerRef as Xt, onScopeDispose as xn, ref as _, onUnmounted as he, nextTick as me, watchEffect as pe, onMounted as re, cloneVNode as _n, h as se, inject as ge, provide as we, reactive as $n, toRaw as $e, getCurrentInstance as Sn, Teleport as kn, getCurrentScope as ml, Transition as Ft, normalizeStyle as hl, withModifiers as De, normalizeProps as Ue, guardReactiveProps as He, isRef as Se, vModelDynamic as St, vModelSelect as gl, withKeys as kt, vModelCheckbox as On, vModelText as Fe, isProxy as gt } from "vue";
import { Link as ye, router as Ot } from "@inertiajs/vue3";
function bl(e, n) {
  return c(), m("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    u("path", { d: "M6 12a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 1 1 1.5 0v7.5A.75.75 0 0 1 6 12ZM18 12a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5A.75.75 0 0 1 18 12ZM6.75 20.25v-1.5a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0ZM18.75 18.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 1.5 0ZM12.75 5.25v-1.5a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0ZM12 21a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5A.75.75 0 0 1 12 21ZM3.75 15a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0ZM12 11.25a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5ZM15.75 15a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0Z" })
  ]);
}
function yl(e, n) {
  return c(), m("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    u("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25a.75.75 0 0 1 .75.75v16.19l6.22-6.22a.75.75 0 1 1 1.06 1.06l-7.5 7.5a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 1 1 1.06-1.06l6.22 6.22V3a.75.75 0 0 1 .75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function wl(e, n) {
  return c(), m("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    u("path", {
      "fill-rule": "evenodd",
      d: "M11.47 2.47a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06l-6.22-6.22V21a.75.75 0 0 1-1.5 0V4.81l-6.22 6.22a.75.75 0 1 1-1.06-1.06l7.5-7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function xl(e, n) {
  return c(), m("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    u("path", {
      "fill-rule": "evenodd",
      d: "M6.97 2.47a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06L8.25 4.81V16.5a.75.75 0 0 1-1.5 0V4.81L3.53 8.03a.75.75 0 0 1-1.06-1.06l4.5-4.5Zm9.53 4.28a.75.75 0 0 1 .75.75v11.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.22 3.22V7.5a.75.75 0 0 1 .75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function _l(e, n) {
  return c(), m("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    u("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function $l(e, n) {
  return c(), m("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    u("path", {
      "fill-rule": "evenodd",
      d: "M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Lt(e, n) {
  return c(), m("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    u("path", {
      "fill-rule": "evenodd",
      d: "M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Jt(e, n) {
  return c(), m("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    u("path", {
      "fill-rule": "evenodd",
      d: "M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function dt(e, n) {
  return c(), m("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    u("path", {
      "fill-rule": "evenodd",
      d: "M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Sl(e, n) {
  return c(), m("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    u("path", {
      "fill-rule": "evenodd",
      d: "M11.47 4.72a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1-1.06 1.06L12 6.31 8.78 9.53a.75.75 0 0 1-1.06-1.06l3.75-3.75Zm-3.75 9.75a.75.75 0 0 1 1.06 0L12 17.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-3.75 3.75a.75.75 0 0 1-1.06 0l-3.75-3.75a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function kl(e, n) {
  return c(), m("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    u("path", {
      "fill-rule": "evenodd",
      d: "M10.5 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm0 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm0 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Ol(e, n) {
  return c(), m("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    u("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function El(e, n) {
  return c(), m("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    u("path", {
      "fill-rule": "evenodd",
      d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Cl(e, n) {
  return c(), m("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    u("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Il(e, n) {
  return c(), m("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    u("path", {
      "fill-rule": "evenodd",
      d: "M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Tl(e, n) {
  return c(), m("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    u("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Qe(e, n) {
  return c(), m("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    u("path", {
      "fill-rule": "evenodd",
      d: "M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const Pl = { class: "border-l-4 border-red-400 bg-red-50 p-4" }, Bl = { class: "flex" }, Rl = {
  key: 0,
  class: "shrink-0"
}, Ml = { class: "ml-3" }, Al = { class: "text-sm text-red-700" }, Vl = { class: "mt-4" }, Dl = { class: "-mx-2 -my-1.5 flex items-center space-x-3" }, Fl = { name: "DangerAlert" }, Yu = /* @__PURE__ */ O({
  ...Fl,
  props: {
    withoutIcon: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), m("div", Pl, [
      u("div", Bl, [
        n.withoutIcon ? L("", !0) : (c(), m("div", Rl, [
          V($(Ol), {
            class: "h-5 w-5 text-red-400",
            "aria-hidden": "true"
          })
        ])),
        u("div", Ml, [
          u("p", Al, [
            D(n.$slots, "default")
          ]),
          u("div", Vl, [
            u("div", Dl, [
              D(n.$slots, "actions")
            ])
          ])
        ])
      ])
    ]));
  }
}), Ll = { name: "Spinner" }, en = /* @__PURE__ */ O({
  ...Ll,
  props: {
    textClass: { default: "text-white" }
  },
  setup(e) {
    return (n, t) => (c(), m("svg", {
      class: W(["h-5 w-5 animate-spin", n.textClass]),
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24"
    }, t[0] || (t[0] = [
      u("circle", {
        class: "opacity-25",
        cx: "12",
        cy: "12",
        r: "10",
        stroke: "currentColor",
        "stroke-width": "4"
      }, null, -1),
      u("path", {
        class: "opacity-75",
        fill: "currentColor",
        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      }, null, -1)
    ]), 2));
  }
}), Nl = ["disabled", "type"], jl = ["href"], zl = { name: "Button" }, Le = /* @__PURE__ */ O({
  ...zl,
  props: {
    as: { default: "a" },
    external: { type: Boolean },
    href: { default: "" },
    loading: { type: Boolean },
    spinnerClass: { default: "text-white" },
    type: {}
  },
  setup(e) {
    const n = e, t = y(() => n.type !== void 0 && n.as !== "button" ? (console.warn(
      "Warning: The 'as' prop should be set to 'button' when using the 'type' prop. This will be an error in a future release."
    ), "button") : n.as), r = [
      "relative",
      "inline-flex",
      "items-center",
      "rounded-md",
      "border",
      "px-4",
      "py-2",
      "text-sm",
      "font-medium",
      "leading-5",
      "focus:outline-none",
      "focus-visible:outline-none"
    ];
    return (l, o) => t.value === "button" ? (c(), m("button", K({
      key: 0,
      class: r,
      disabled: l.loading,
      type: l.type
    }, l.$attrs), [
      D(l.$slots, "default"),
      ce(V(en, {
        class: "ml-3",
        "text-class": l.spinnerClass
      }, null, 8, ["text-class"]), [
        [qe, l.loading]
      ])
    ], 16, Nl)) : l.external ? (c(), m("a", K({
      key: 2,
      href: l.href,
      class: r
    }, l.$attrs), [
      D(l.$slots, "default")
    ], 16, jl)) : (c(), M($(ye), K({
      key: 1,
      as: l.as,
      href: l.href,
      disabled: l.loading,
      class: r
    }, l.$attrs), {
      default: k(() => [
        D(l.$slots, "default"),
        ce(V(en, {
          class: "ml-3",
          "text-class": l.spinnerClass
        }, null, 8, ["text-class"]), [
          [qe, l.loading]
        ])
      ]),
      _: 3
    }, 16, ["as", "href", "disabled"]));
  }
}), Ul = { name: "DangerAlertButton" }, Xu = /* @__PURE__ */ O({
  ...Ul,
  props: {
    as: {},
    external: { type: Boolean, default: !1 },
    href: {},
    loading: { type: Boolean },
    type: {}
  },
  setup(e) {
    const n = [
      "border-transparent",
      "bg-red-50",
      "text-red-800",
      "hover:bg-red-100",
      "focus:border-red-600",
      "active:bg-red-600",
      "!px-2"
    ];
    return (t, r) => (c(), M(Le, K({
      as: t.as,
      external: t.external,
      href: t.href,
      loading: t.loading,
      type: t.type,
      class: n
    }, t.$attrs), {
      default: k(() => [
        D(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["as", "external", "href", "loading", "type"]));
  }
}), Hl = { class: "border-l-4 border-blue-400 bg-blue-50 p-4" }, Wl = { class: "flex" }, Kl = {
  key: 0,
  class: "shrink-0"
}, Zl = { class: "ml-3" }, ql = { class: "text-sm text-blue-700" }, Gl = { class: "mt-4" }, Ql = { class: "-mx-2 -my-1.5 flex items-center space-x-3" }, Yl = { name: "InfoAlert" }, Ju = /* @__PURE__ */ O({
  ...Yl,
  props: {
    withoutIcon: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), m("div", Hl, [
      u("div", Wl, [
        n.withoutIcon ? L("", !0) : (c(), m("div", Kl, [
          V($(Cl), {
            class: "h-5 w-5 text-blue-500",
            "aria-hidden": "true"
          })
        ])),
        u("div", Zl, [
          u("p", ql, [
            D(n.$slots, "default")
          ]),
          u("div", Gl, [
            u("div", Ql, [
              D(n.$slots, "actions")
            ])
          ])
        ])
      ])
    ]));
  }
}), Xl = { name: "InfoAlertButton" }, ed = /* @__PURE__ */ O({
  ...Xl,
  props: {
    as: {},
    external: { type: Boolean, default: !1 },
    href: {},
    loading: { type: Boolean },
    type: {}
  },
  setup(e) {
    const n = [
      "border-transparent",
      "bg-blue-50",
      "text-blue-800",
      "hover:bg-blue-100",
      "focus:border-blue-600",
      "active:bg-blue-600",
      "!px-2"
    ];
    return (t, r) => (c(), M(Le, K({
      as: t.as,
      external: t.external,
      href: t.href,
      loading: t.loading,
      type: t.type,
      class: n
    }, t.$attrs), {
      default: k(() => [
        D(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["as", "external", "href", "loading", "type"]));
  }
}), Jl = { class: "border-l-4 border-green-400 bg-green-50 p-4" }, er = { class: "flex" }, tr = {
  key: 0,
  class: "shrink-0"
}, nr = { class: "ml-3" }, lr = { class: "text-sm text-green-700" }, rr = { class: "mt-4" }, or = { class: "-mx-2 -my-1.5 flex items-center space-x-3" }, ar = { name: "SuccessAlert" }, td = /* @__PURE__ */ O({
  ...ar,
  props: {
    withoutIcon: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), m("div", Jl, [
      u("div", er, [
        n.withoutIcon ? L("", !0) : (c(), m("div", tr, [
          V($(_l), {
            class: "h-5 w-5 text-green-400",
            "aria-hidden": "true"
          })
        ])),
        u("div", nr, [
          u("p", lr, [
            D(n.$slots, "default")
          ]),
          u("div", rr, [
            u("div", or, [
              D(n.$slots, "actions")
            ])
          ])
        ])
      ])
    ]));
  }
}), sr = { name: "SuccessAlertButton" }, nd = /* @__PURE__ */ O({
  ...sr,
  props: {
    as: {},
    external: { type: Boolean, default: !1 },
    href: {},
    loading: { type: Boolean },
    type: {}
  },
  setup(e) {
    const n = [
      "border-transparent",
      "bg-green-50",
      "text-green-800",
      "hover:bg-green-100",
      "focus:border-green-600",
      "active:bg-green-600",
      "!px-2"
    ];
    return (t, r) => (c(), M(Le, K({
      as: t.as,
      external: t.external,
      href: t.href,
      loading: t.loading,
      type: t.type,
      class: n
    }, t.$attrs), {
      default: k(() => [
        D(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["as", "external", "href", "loading", "type"]));
  }
}), ir = { class: "border-l-4 border-yellow-400 bg-yellow-50 p-4" }, ur = { class: "flex" }, dr = {
  key: 0,
  class: "shrink-0"
}, cr = { class: "ml-3" }, pr = { class: "text-sm text-yellow-700" }, fr = { class: "mt-4" }, vr = { class: "-mx-2 -my-1.5 flex items-center space-x-3" }, mr = { name: "WarningAlert" }, ld = /* @__PURE__ */ O({
  ...mr,
  props: {
    withoutIcon: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (c(), m("div", ir, [
      u("div", ur, [
        n.withoutIcon ? L("", !0) : (c(), m("div", dr, [
          V($(El), {
            class: "h-5 w-5 text-yellow-400",
            "aria-hidden": "true"
          })
        ])),
        u("div", cr, [
          u("p", pr, [
            D(n.$slots, "default")
          ]),
          u("div", fr, [
            u("div", vr, [
              D(n.$slots, "actions")
            ])
          ])
        ])
      ])
    ]));
  }
}), hr = { name: "WarningAlertButton" }, rd = /* @__PURE__ */ O({
  ...hr,
  props: {
    as: {},
    external: { type: Boolean, default: !1 },
    href: {},
    loading: { type: Boolean },
    type: {}
  },
  setup(e) {
    const n = [
      "border-transparent",
      "bg-yellow-50",
      "text-yellow-800",
      "hover:bg-yellow-100",
      "focus:border-yellow-600",
      "active:bg-yellow-600",
      "!px-2"
    ];
    return (t, r) => (c(), M(Le, K({
      as: t.as,
      external: t.external,
      href: t.href,
      loading: t.loading,
      type: t.type,
      class: n
    }, t.$attrs), {
      default: k(() => [
        D(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["as", "external", "href", "loading", "type"]));
  }
}), gr = { name: "Badge" }, Je = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [r, l] of n)
    t[r] = l;
  return t;
}, br = { class: "inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10" };
function yr(e, n, t, r, l, o) {
  return c(), m("span", br, [
    D(e.$slots, "default")
  ]);
}
const od = /* @__PURE__ */ Je(gr, [["render", yr]]), wr = { name: "DangerBadge" }, xr = { class: "inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10" };
function _r(e, n, t, r, l, o) {
  return c(), m("span", xr, [
    D(e.$slots, "default")
  ]);
}
const ad = /* @__PURE__ */ Je(wr, [["render", _r]]), $r = { name: "SuccessBadge" }, Sr = { class: "inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20" };
function kr(e, n, t, r, l, o) {
  return c(), m("span", Sr, [
    D(e.$slots, "default")
  ]);
}
const sd = /* @__PURE__ */ Je($r, [["render", kr]]), Or = { name: "WarningBadge" }, Er = { class: "inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20" };
function Cr(e, n, t, r, l, o) {
  return c(), m("span", Er, [
    D(e.$slots, "default")
  ]);
}
const id = /* @__PURE__ */ Je(Or, [["render", Cr]]), Ir = { name: "DangerButton" }, ud = /* @__PURE__ */ O({
  ...Ir,
  props: {
    as: {},
    external: { type: Boolean, default: !1 },
    href: {},
    loading: { type: Boolean },
    type: {}
  },
  setup(e) {
    const n = [
      "border-transparent",
      "bg-red-600",
      "text-white",
      "hover:bg-red-500",
      "focus:border-red-700",
      "active:bg-red-700"
    ];
    return (t, r) => (c(), M(Le, K({
      as: t.as,
      external: t.external,
      href: t.href,
      loading: t.loading,
      type: t.type,
      class: n
    }, t.$attrs), {
      default: k(() => [
        D(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["as", "external", "href", "loading", "type"]));
  }
}), Tr = { name: "PrimaryButton" }, tn = /* @__PURE__ */ O({
  ...Tr,
  props: {
    as: {},
    external: { type: Boolean, default: !1 },
    href: {},
    loading: { type: Boolean },
    type: {}
  },
  setup(e) {
    const n = [
      "border-transparent",
      "bg-primary-600",
      "text-white",
      "hover:bg-primary-500",
      "focus:border-primary-700",
      "active:bg-primary-700"
    ];
    return (t, r) => (c(), M(Le, K({
      as: t.as,
      external: t.external,
      href: t.href,
      loading: t.loading,
      type: t.type,
      class: n
    }, t.$attrs), {
      default: k(() => [
        D(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["as", "external", "href", "loading", "type"]));
  }
}), Pr = { name: "SecondaryButton" }, ze = /* @__PURE__ */ O({
  ...Pr,
  props: {
    as: {},
    external: { type: Boolean, default: !1 },
    href: {},
    loading: { type: Boolean },
    type: {}
  },
  setup(e) {
    const n = [
      "border-gray-300",
      "bg-white",
      "text-gray-700",
      "hover:bg-gray-50",
      "active:bg-gray-100"
    ];
    return (t, r) => (c(), M(Le, K({
      as: t.as,
      external: t.external,
      href: t.href,
      loading: t.loading,
      type: t.type,
      class: n,
      "spinner-class": "text-gray-400"
    }, t.$attrs), {
      default: k(() => [
        D(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["as", "external", "href", "loading", "type"]));
  }
}), Br = { class: "relative flex w-full flex-col space-y-2 overflow-hidden rounded-lg border-l-8 border-primary-500 bg-white shadow" }, Rr = { class: "grow p-2" }, Mr = { class: "flex" }, Ar = { class: "my-auto ml-2 w-full space-y-2" }, Vr = { class: "text-lg font-medium" }, Dr = {
  key: 0,
  class: "grid gap-2 md:grid-cols-2"
}, Fr = {
  key: 0,
  class: "w-full bg-gray-100 py-2 text-center"
}, Lr = { name: "KpiCard" }, dd = /* @__PURE__ */ O({
  ...Lr,
  props: {
    title: {},
    icon: {}
  },
  setup(e) {
    return (n, t) => (c(), m("div", Br, [
      u("div", Rr, [
        u("div", Mr, [
          (c(), M(Ve(n.icon), { class: "h-10 w-10 text-primary-600" })),
          u("div", Ar, [
            u("div", null, [
              u("p", {
                class: W(["mt-1 font-normal", {
                  "text-sm text-gray-500": !n.$slots.default,
                  "text-base text-black": n.$slots.default
                }])
              }, F(n.title), 3),
              u("p", Vr, [
                D(n.$slots, "subtitle")
              ])
            ]),
            n.$slots.default ? (c(), m("div", Dr, [
              D(n.$slots, "default")
            ])) : L("", !0)
          ])
        ])
      ]),
      n.$slots.actions ? (c(), m("div", Fr, [
        D(n.$slots, "actions")
      ])) : L("", !0)
    ]));
  }
});
function Nr(e, n) {
  return c(), m("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    u("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3"
    })
  ]);
}
function jr(e, n) {
  return c(), m("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    u("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18"
    })
  ]);
}
function zr(e, n) {
  return c(), m("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    u("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function nn(e, n) {
  return c(), m("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    u("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
    })
  ]);
}
function Ur(e, n) {
  return c(), m("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    u("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
    })
  ]);
}
const Hr = { class: "text-sm text-gray-400" }, Wr = { class: "flex font-medium text-black" }, Kr = { class: "text-lg" }, Zr = { name: "KpiElement" }, cd = /* @__PURE__ */ O({
  ...Zr,
  props: {
    value: { default: "" },
    percentage: { default: 0 }
  },
  setup(e) {
    const n = e, t = y(() => n.percentage > 0);
    return (r, l) => (c(), m("div", null, [
      u("div", Hr, [
        D(r.$slots, "title")
      ]),
      u("div", Wr, [
        u("div", Kr, F(r.value), 1),
        u("div", {
          class: W(["ml-1 mt-auto flex text-sm text-red-500", { "!text-green-500": t.value }])
        }, [
          t.value ? L("", !0) : (c(), M($(Nr), {
            key: 0,
            class: "mt-0.5 h-3 w-3 text-red-500"
          })),
          t.value ? (c(), M($(jr), {
            key: 1,
            class: "mt-0.5 h-3 w-3 text-green-500"
          })) : L("", !0),
          ne(" " + F(Math.abs(r.percentage)) + "% ", 1)
        ], 2)
      ])
    ]));
  }
}), qr = {
  class: "flex",
  "aria-label": "Breadcrumb"
}, Gr = {
  role: "list",
  class: "flex list-none items-center space-x-4"
}, Qr = { class: "flex items-center" }, Yr = {
  name: "Breadcrumbs"
}, pd = /* @__PURE__ */ O({
  ...Yr,
  props: {
    pages: {}
  },
  setup(e) {
    return (n, t) => (c(), m("nav", qr, [
      u("ol", Gr, [
        (c(!0), m(le, null, de(n.pages, (r, l) => (c(), m("li", {
          key: r.name
        }, [
          u("div", Qr, [
            l > 0 ? (c(), M($(dt), {
              key: 0,
              class: "mr-4 h-5 w-5 shrink-0 text-gray-400",
              "aria-hidden": "true"
            })) : L("", !0),
            V($(ye), {
              href: r.href,
              class: "text-sm font-medium text-gray-500 hover:text-gray-700",
              "aria-current": r.current ? "page" : void 0
            }, {
              default: k(() => [
                ne(F(r.name), 1)
              ]),
              _: 2
            }, 1032, ["href", "aria-current"])
          ])
        ]))), 128))
      ])
    ]));
  }
}), Xr = { name: "Container" }, fd = /* @__PURE__ */ O({
  ...Xr,
  props: {
    compact: { type: Boolean }
  },
  setup(e) {
    return (n, t) => (c(), m("div", {
      class: W(["mx-auto px-2 py-4 sm:px-8", { "max-w-7xl": !n.compact, "max-w-4xl": n.compact }])
    }, [
      D(n.$slots, "default")
    ], 2));
  }
});
function je(e, n, t) {
  var o;
  let r = (o = t.initialDeps) != null ? o : [], l;
  return () => {
    var s, a, i, p;
    let d;
    t.key && ((s = t.debug) == null ? void 0 : s.call(t)) && (d = Date.now());
    const v = e();
    if (!(v.length !== r.length || v.some((g, w) => r[w] !== g)))
      return l;
    r = v;
    let h;
    if (t.key && ((a = t.debug) == null ? void 0 : a.call(t)) && (h = Date.now()), l = n(...v), t.key && ((i = t.debug) == null ? void 0 : i.call(t))) {
      const g = Math.round((Date.now() - d) * 100) / 100, w = Math.round((Date.now() - h) * 100) / 100, T = w / 16, N = (B, j) => {
        for (B = String(B); B.length < j; )
          B = " " + B;
        return B;
      };
      console.info(
        `%c\u23F1 ${N(w, 5)} /${N(g, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * T, 120)
        )}deg 100% 31%);`,
        t == null ? void 0 : t.key
      );
    }
    return (p = t == null ? void 0 : t.onChange) == null || p.call(t, l), l;
  };
}
function bt(e, n) {
  if (e === void 0)
    throw new Error(`Unexpected undefined${n ? `: ${n}` : ""}`);
  return e;
}
const Jr = (e, n) => Math.abs(e - n) < 1, eo = (e, n, t) => {
  let r;
  return function(...l) {
    e.clearTimeout(r), r = e.setTimeout(() => n.apply(this, l), t);
  };
}, to = (e) => e, no = (e) => {
  const n = Math.max(e.startIndex - e.overscan, 0), t = Math.min(e.endIndex + e.overscan, e.count - 1), r = [];
  for (let l = n; l <= t; l++)
    r.push(l);
  return r;
}, lo = (e, n) => {
  const t = e.scrollElement;
  if (!t)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  const l = (s) => {
    const { width: a, height: i } = s;
    n({ width: Math.round(a), height: Math.round(i) });
  };
  if (l(t.getBoundingClientRect()), !r.ResizeObserver)
    return () => {
    };
  const o = new r.ResizeObserver((s) => {
    const a = s[0];
    if (a != null && a.borderBoxSize) {
      const i = a.borderBoxSize[0];
      if (i) {
        l({ width: i.inlineSize, height: i.blockSize });
        return;
      }
    }
    l(t.getBoundingClientRect());
  });
  return o.observe(t, { box: "border-box" }), () => {
    o.unobserve(t);
  };
}, ln = {
  passive: !0
}, ro = typeof window > "u" ? !0 : "onscrollend" in window, oo = (e, n) => {
  const t = e.scrollElement;
  if (!t)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  let l = 0;
  const o = ro ? () => {
  } : eo(
    r,
    () => {
      n(l, !1);
    },
    e.options.isScrollingResetDelay
  ), s = (p) => () => {
    const { horizontal: d, isRtl: v } = e.options;
    l = d ? t.scrollLeft * (v && -1 || 1) : t.scrollTop, o(), n(l, p);
  }, a = s(!0), i = s(!1);
  return i(), t.addEventListener("scroll", a, ln), t.addEventListener("scrollend", i, ln), () => {
    t.removeEventListener("scroll", a), t.removeEventListener("scrollend", i);
  };
}, ao = (e, n, t) => {
  if (n != null && n.borderBoxSize) {
    const r = n.borderBoxSize[0];
    if (r)
      return Math.round(
        r[t.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    e.getBoundingClientRect()[t.options.horizontal ? "width" : "height"]
  );
}, so = (e, {
  adjustments: n = 0,
  behavior: t
}, r) => {
  var l, o;
  const s = e + n;
  (o = (l = r.scrollElement) == null ? void 0 : l.scrollTo) == null || o.call(l, {
    [r.options.horizontal ? "left" : "top"]: s,
    behavior: t
  });
};
class io {
  constructor(n) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let t = null;
      const r = () => t || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : t = new this.targetWindow.ResizeObserver((l) => {
        l.forEach((o) => {
          this._measureElement(o.target, o);
        });
      }));
      return {
        disconnect: () => {
          var l;
          (l = r()) == null || l.disconnect(), t = null;
        },
        observe: (l) => {
          var o;
          return (o = r()) == null ? void 0 : o.observe(l, { box: "border-box" });
        },
        unobserve: (l) => {
          var o;
          return (o = r()) == null ? void 0 : o.unobserve(l);
        }
      };
    })(), this.range = null, this.setOptions = (t) => {
      Object.entries(t).forEach(([r, l]) => {
        typeof l > "u" && delete t[r];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: to,
        rangeExtractor: no,
        onChange: () => {
        },
        measureElement: ao,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        ...t
      };
    }, this.notify = (t) => {
      var r, l;
      (l = (r = this.options).onChange) == null || l.call(r, this, t);
    }, this.maybeNotify = je(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (t) => {
        this.notify(t);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((t) => t()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var l;
      var t;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = (l = (t = this.scrollElement) == null ? void 0 : t.window) != null ? l : null, this.elementsCache.forEach((o) => {
          this.observer.observe(o);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (o) => {
            this.scrollRect = o, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (o, s) => {
            this.scrollAdjustments = 0, this.scrollDirection = s ? this.getScrollOffset() < o ? "forward" : "backward" : null, this.scrollOffset = o, this.isScrolling = s, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => {
      var t;
      return this.options.enabled ? (this.scrollRect = (t = this.scrollRect) != null ? t : this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0);
    }, this.getScrollOffset = () => {
      var t;
      return this.options.enabled ? (this.scrollOffset = (t = this.scrollOffset) != null ? t : typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset, this.scrollOffset) : (this.scrollOffset = null, 0);
    }, this.getFurthestMeasurement = (t, r) => {
      const l = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
      for (let s = r - 1; s >= 0; s--) {
        const a = t[s];
        if (l.has(a.lane))
          continue;
        const i = o.get(
          a.lane
        );
        if (i == null || a.end > i.end ? o.set(a.lane, a) : a.end < i.end && l.set(a.lane, !0), l.size === this.options.lanes)
          break;
      }
      return o.size === this.options.lanes ? Array.from(o.values()).sort((s, a) => s.end === a.end ? s.index - a.index : s.end - a.end)[0] : void 0;
    }, this.getMeasurementOptions = je(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (t, r, l, o, s) => (this.pendingMeasuredCacheIndexes = [], {
        count: t,
        paddingStart: r,
        scrollMargin: l,
        getItemKey: o,
        enabled: s
      }),
      {
        key: !1
      }
    ), this.getMeasurements = je(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: t, paddingStart: r, scrollMargin: l, getItemKey: o, enabled: s }, a) => {
        if (!s)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((d) => {
          this.itemSizeCache.set(d.key, d.size);
        }));
        const i = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const p = this.measurementsCache.slice(0, i);
        for (let d = i; d < t; d++) {
          const v = o(d), f = this.options.lanes === 1 ? p[d - 1] : this.getFurthestMeasurement(p, d), h = f ? f.end + this.options.gap : r + l, g = a.get(v), w = typeof g == "number" ? g : this.options.estimateSize(d), T = h + w, N = f ? f.lane : d % this.options.lanes;
          p[d] = {
            index: d,
            start: h,
            size: w,
            end: T,
            key: v,
            lane: N
          };
        }
        return this.measurementsCache = p, p;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = je(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (t, r, l) => this.range = t.length > 0 && r > 0 ? uo({
        measurements: t,
        outerSize: r,
        scrollOffset: l
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getIndexes = je(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (t, r, l, o) => r === null ? [] : t({
        startIndex: r.startIndex,
        endIndex: r.endIndex,
        overscan: l,
        count: o
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (t) => {
      const r = this.options.indexAttribute, l = t.getAttribute(r);
      return l ? parseInt(l, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (t, r) => {
      const l = this.indexFromElement(t), o = this.measurementsCache[l];
      if (!o)
        return;
      const s = o.key, a = this.elementsCache.get(s);
      a !== t && (a && this.observer.unobserve(a), this.observer.observe(t), this.elementsCache.set(s, t)), t.isConnected && this.resizeItem(l, this.options.measureElement(t, r, this));
    }, this.resizeItem = (t, r) => {
      var a;
      const l = this.measurementsCache[t];
      if (!l)
        return;
      const o = (a = this.itemSizeCache.get(l.key)) != null ? a : l.size, s = r - o;
      s !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(l, s, this) : l.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", s), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += s,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(l.index), this.itemSizeCache = new Map(this.itemSizeCache.set(l.key, r)), this.notify(!1));
    }, this.measureElement = (t) => {
      if (!t) {
        this.elementsCache.forEach((r, l) => {
          r.isConnected || (this.observer.unobserve(r), this.elementsCache.delete(l));
        });
        return;
      }
      this._measureElement(t, void 0);
    }, this.getVirtualItems = je(
      () => [this.getIndexes(), this.getMeasurements()],
      (t, r) => {
        const l = [];
        for (let o = 0, s = t.length; o < s; o++) {
          const a = t[o], i = r[a];
          l.push(i);
        }
        return l;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (t) => {
      const r = this.getMeasurements();
      if (r.length !== 0)
        return bt(
          r[En(
            0,
            r.length - 1,
            (l) => bt(r[l]).start,
            t
          )]
        );
    }, this.getOffsetForAlignment = (t, r) => {
      const l = this.getSize(), o = this.getScrollOffset();
      r === "auto" && (t <= o ? r = "start" : t >= o + l ? r = "end" : r = "start"), r === "start" ? t = t : r === "end" ? t = t - l : r === "center" && (t = t - l / 2);
      const s = this.options.horizontal ? "scrollWidth" : "scrollHeight", i = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[s] : this.scrollElement[s] : 0) - l;
      return Math.max(Math.min(i, t), 0);
    }, this.getOffsetForIndex = (t, r = "auto") => {
      t = Math.max(0, Math.min(t, this.options.count - 1));
      const l = this.measurementsCache[t];
      if (!l)
        return;
      const o = this.getSize(), s = this.getScrollOffset();
      if (r === "auto")
        if (l.end >= s + o - this.options.scrollPaddingEnd)
          r = "end";
        else if (l.start <= s + this.options.scrollPaddingStart)
          r = "start";
        else
          return [s, r];
      const a = r === "end" ? l.end + this.options.scrollPaddingEnd : l.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(a, r), r];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (t, { align: r = "start", behavior: l } = {}) => {
      this.cancelScrollToIndex(), l === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(t, r), {
        adjustments: void 0,
        behavior: l
      });
    }, this.scrollToIndex = (t, { align: r = "auto", behavior: l } = {}) => {
      t = Math.max(0, Math.min(t, this.options.count - 1)), this.cancelScrollToIndex(), l === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const o = this.getOffsetForIndex(t, r);
      if (!o)
        return;
      const [s, a] = o;
      this._scrollToOffset(s, { adjustments: void 0, behavior: l }), l !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(t)
        )) {
          const [p] = bt(
            this.getOffsetForIndex(t, a)
          );
          Jr(p, this.getScrollOffset()) || this.scrollToIndex(t, { align: a, behavior: l });
        } else
          this.scrollToIndex(t, { align: a, behavior: l });
      }));
    }, this.scrollBy = (t, { behavior: r } = {}) => {
      this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + t, {
        adjustments: void 0,
        behavior: r
      });
    }, this.getTotalSize = () => {
      var o;
      var t;
      const r = this.getMeasurements();
      let l;
      return r.length === 0 ? l = this.options.paddingStart : l = this.options.lanes === 1 ? (o = (t = r[r.length - 1]) == null ? void 0 : t.end) != null ? o : 0 : Math.max(
        ...r.slice(-this.options.lanes).map((s) => s.end)
      ), Math.max(
        l - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (t, {
      adjustments: r,
      behavior: l
    }) => {
      this.options.scrollToFn(t, { behavior: l, adjustments: r }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(n);
  }
}
const En = (e, n, t, r) => {
  for (; e <= n; ) {
    const l = (e + n) / 2 | 0, o = t(l);
    if (o < r)
      e = l + 1;
    else if (o > r)
      n = l - 1;
    else
      return l;
  }
  return e > 0 ? e - 1 : 0;
};
function uo({
  measurements: e,
  outerSize: n,
  scrollOffset: t
}) {
  const r = e.length - 1, o = En(0, r, (a) => e[a].start, t);
  let s = o;
  for (; s < r && e[s].end < t + n; )
    s++;
  return { startIndex: o, endIndex: s };
}
function co(e) {
  const n = new io($(e)), t = wn(n), r = n._didMount();
  return te(
    () => $(e).getScrollElement(),
    (l) => {
      l && n._willUpdate();
    },
    {
      immediate: !0
    }
  ), te(
    () => $(e),
    (l) => {
      n.setOptions({
        ...l,
        onChange: (o, s) => {
          var a;
          Xt(t), (a = l.onChange) == null || a.call(l, o, s);
        }
      }), n._willUpdate(), Xt(t);
    },
    {
      immediate: !0
    }
  ), xn(r), t;
}
function po(e) {
  return co(
    y(() => ({
      observeElementRect: lo,
      observeElementOffset: oo,
      scrollToFn: so,
      ...$(e)
    }))
  );
}
function fo(e, n, t) {
  let r = _(t == null ? void 0 : t.value), l = y(() => e.value !== void 0);
  return [y(() => l.value ? e.value : r.value), function(o) {
    return l.value || (r.value = o), n == null ? void 0 : n(o);
  }];
}
function Nt(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((n) => setTimeout(() => {
    throw n;
  }));
}
function Re() {
  let e = [], n = { addEventListener(t, r, l, o) {
    return t.addEventListener(r, l, o), n.add(() => t.removeEventListener(r, l, o));
  }, requestAnimationFrame(...t) {
    let r = requestAnimationFrame(...t);
    n.add(() => cancelAnimationFrame(r));
  }, nextFrame(...t) {
    n.requestAnimationFrame(() => {
      n.requestAnimationFrame(...t);
    });
  }, setTimeout(...t) {
    let r = setTimeout(...t);
    n.add(() => clearTimeout(r));
  }, microTask(...t) {
    let r = { current: !0 };
    return Nt(() => {
      r.current && t[0]();
    }), n.add(() => {
      r.current = !1;
    });
  }, style(t, r, l) {
    let o = t.style.getPropertyValue(r);
    return Object.assign(t.style, { [r]: l }), this.add(() => {
      Object.assign(t.style, { [r]: o });
    });
  }, group(t) {
    let r = Re();
    return t(r), this.add(() => r.dispose());
  }, add(t) {
    return e.push(t), () => {
      let r = e.indexOf(t);
      if (r >= 0)
        for (let l of e.splice(r, 1))
          l();
    };
  }, dispose() {
    for (let t of e.splice(0))
      t();
  } };
  return n;
}
function vo() {
  let e = Re();
  return he(() => e.dispose()), e;
}
function mo() {
  let e = vo();
  return (n) => {
    e.dispose(), e.nextFrame(n);
  };
}
var rn;
let ho = Symbol("headlessui.useid"), go = 0;
const be = (rn = Yt.useId) != null ? rn : function() {
  return Yt.inject(ho, () => `${++go}`)();
};
function P(e) {
  var n;
  if (e == null || e.value == null)
    return null;
  let t = (n = e.value.$el) != null ? n : e.value;
  return t instanceof Node ? t : null;
}
function fe(e, n, ...t) {
  if (e in n) {
    let l = n[e];
    return typeof l == "function" ? l(...t) : l;
  }
  let r = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((l) => `"${l}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(r, fe), r;
}
var bo = Object.defineProperty, yo = (e, n, t) => n in e ? bo(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, on = (e, n, t) => (yo(e, typeof n != "symbol" ? n + "" : n, t), t);
class wo {
  constructor() {
    on(this, "current", this.detect()), on(this, "currentId", 0);
  }
  set(n) {
    this.current !== n && (this.currentId = 0, this.current = n);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}
let et = new wo();
function Te(e) {
  if (et.isServer)
    return null;
  if (e instanceof Node)
    return e.ownerDocument;
  if (e != null && e.hasOwnProperty("value")) {
    let n = P(e);
    if (n)
      return n.ownerDocument;
  }
  return document;
}
let Et = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var Ee = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(Ee || {}), Cn = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(Cn || {}), xo = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(xo || {});
function In(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(Et)).sort((n, t) => Math.sign((n.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var jt = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(jt || {});
function zt(e, n = 0) {
  var t;
  return e === ((t = Te(e)) == null ? void 0 : t.body) ? !1 : fe(n, { [0]() {
    return e.matches(Et);
  }, [1]() {
    let r = e;
    for (; r !== null; ) {
      if (r.matches(Et))
        return !0;
      r = r.parentElement;
    }
    return !1;
  } });
}
function Tn(e) {
  let n = Te(e);
  me(() => {
    n && !zt(n.activeElement, 0) && Be(e);
  });
}
var _o = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(_o || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function Be(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let $o = ["textarea", "input"].join(",");
function So(e) {
  var n, t;
  return (t = (n = e == null ? void 0 : e.matches) == null ? void 0 : n.call(e, $o)) != null ? t : !1;
}
function Ut(e, n = (t) => t) {
  return e.slice().sort((t, r) => {
    let l = n(t), o = n(r);
    if (l === null || o === null)
      return 0;
    let s = l.compareDocumentPosition(o);
    return s & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : s & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function ko(e, n) {
  return Ge(In(), n, { relativeTo: e });
}
function Ge(e, n, { sorted: t = !0, relativeTo: r = null, skipElements: l = [] } = {}) {
  var o;
  let s = (o = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e == null ? void 0 : e.ownerDocument) != null ? o : document, a = Array.isArray(e) ? t ? Ut(e) : e : In(e);
  l.length > 0 && a.length > 1 && (a = a.filter((g) => !l.includes(g))), r = r != null ? r : s.activeElement;
  let i = (() => {
    if (n & 5)
      return 1;
    if (n & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), p = (() => {
    if (n & 1)
      return 0;
    if (n & 2)
      return Math.max(0, a.indexOf(r)) - 1;
    if (n & 4)
      return Math.max(0, a.indexOf(r)) + 1;
    if (n & 8)
      return a.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), d = n & 32 ? { preventScroll: !0 } : {}, v = 0, f = a.length, h;
  do {
    if (v >= f || v + f <= 0)
      return 0;
    let g = p + v;
    if (n & 16)
      g = (g + f) % f;
    else {
      if (g < 0)
        return 3;
      if (g >= f)
        return 1;
    }
    h = a[g], h == null || h.focus(d), v += i;
  } while (h !== s.activeElement);
  return n & 6 && So(h) && h.select(), 2;
}
function Pn() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function Oo() {
  return /Android/gi.test(window.navigator.userAgent);
}
function Bn() {
  return Pn() || Oo();
}
function at(e, n, t) {
  et.isServer || pe((r) => {
    document.addEventListener(e, n, t), r(() => document.removeEventListener(e, n, t));
  });
}
function Rn(e, n, t) {
  et.isServer || pe((r) => {
    window.addEventListener(e, n, t), r(() => window.removeEventListener(e, n, t));
  });
}
function Ht(e, n, t = y(() => !0)) {
  function r(o, s) {
    if (!t.value || o.defaultPrevented)
      return;
    let a = s(o);
    if (a === null || !a.getRootNode().contains(a))
      return;
    let i = function p(d) {
      return typeof d == "function" ? p(d()) : Array.isArray(d) || d instanceof Set ? d : [d];
    }(e);
    for (let p of i) {
      if (p === null)
        continue;
      let d = p instanceof HTMLElement ? p : P(p);
      if (d != null && d.contains(a) || o.composed && o.composedPath().includes(d))
        return;
    }
    return !zt(a, jt.Loose) && a.tabIndex !== -1 && o.preventDefault(), n(o, a);
  }
  let l = _(null);
  at("pointerdown", (o) => {
    var s, a;
    t.value && (l.value = ((a = (s = o.composedPath) == null ? void 0 : s.call(o)) == null ? void 0 : a[0]) || o.target);
  }, !0), at("mousedown", (o) => {
    var s, a;
    t.value && (l.value = ((a = (s = o.composedPath) == null ? void 0 : s.call(o)) == null ? void 0 : a[0]) || o.target);
  }, !0), at("click", (o) => {
    Bn() || l.value && (r(o, () => l.value), l.value = null);
  }, !0), at("touchend", (o) => r(o, () => o.target instanceof HTMLElement ? o.target : null), !0), Rn("blur", (o) => r(o, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function an(e, n) {
  if (e)
    return e;
  let t = n != null ? n : "button";
  if (typeof t == "string" && t.toLowerCase() === "button")
    return "button";
}
function Mn(e, n) {
  let t = _(an(e.value.type, e.value.as));
  return re(() => {
    t.value = an(e.value.type, e.value.as);
  }), pe(() => {
    var r;
    t.value || P(n) && P(n) instanceof HTMLButtonElement && !((r = P(n)) != null && r.hasAttribute("type")) && (t.value = "button");
  }), t;
}
function sn(e) {
  return [e.screenX, e.screenY];
}
function An() {
  let e = _([-1, -1]);
  return { wasMoved(n) {
    let t = sn(n);
    return e.value[0] === t[0] && e.value[1] === t[1] ? !1 : (e.value = t, !0);
  }, update(n) {
    e.value = sn(n);
  } };
}
function Vn({ container: e, accept: n, walk: t, enabled: r }) {
  pe(() => {
    let l = e.value;
    if (!l || r !== void 0 && !r.value)
      return;
    let o = Te(e);
    if (!o)
      return;
    let s = Object.assign((i) => n(i), { acceptNode: n }), a = o.createTreeWalker(l, NodeFilter.SHOW_ELEMENT, s, !1);
    for (; a.nextNode(); )
      t(a.currentNode);
  });
}
var Ce = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(Ce || {}), Pe = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(Pe || {});
function oe({ visible: e = !0, features: n = 0, ourProps: t, theirProps: r, ...l }) {
  var o;
  let s = Fn(r, t), a = Object.assign(l, { props: s });
  if (e || n & 2 && s.static)
    return yt(a);
  if (n & 1) {
    let i = (o = s.unmount) == null || o ? 0 : 1;
    return fe(i, { [0]() {
      return null;
    }, [1]() {
      return yt({ ...l, props: { ...s, hidden: !0, style: { display: "none" } } });
    } });
  }
  return yt(a);
}
function yt({ props: e, attrs: n, slots: t, slot: r, name: l }) {
  var o, s;
  let { as: a, ...i } = tt(e, ["unmount", "static"]), p = (o = t.default) == null ? void 0 : o.call(t, r), d = {};
  if (r) {
    let v = !1, f = [];
    for (let [h, g] of Object.entries(r))
      typeof g == "boolean" && (v = !0), g === !0 && f.push(h);
    v && (d["data-headlessui-state"] = f.join(" "));
  }
  if (a === "template") {
    if (p = Dn(p != null ? p : []), Object.keys(i).length > 0 || Object.keys(n).length > 0) {
      let [v, ...f] = p != null ? p : [];
      if (!Co(v) || f.length > 0)
        throw new Error(['Passing props on "template"!', "", `The current component <${l} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(i).concat(Object.keys(n)).map((w) => w.trim()).filter((w, T, N) => N.indexOf(w) === T).sort((w, T) => w.localeCompare(T)).map((w) => `  - ${w}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((w) => `  - ${w}`).join(`
`)].join(`
`));
      let h = Fn((s = v.props) != null ? s : {}, i, d), g = _n(v, h, !0);
      for (let w in h)
        w.startsWith("on") && (g.props || (g.props = {}), g.props[w] = h[w]);
      return g;
    }
    return Array.isArray(p) && p.length === 1 ? p[0] : p;
  }
  return se(a, Object.assign({}, i, d), { default: () => p });
}
function Dn(e) {
  return e.flatMap((n) => n.type === le ? Dn(n.children) : [n]);
}
function Fn(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let n = {}, t = {};
  for (let r of e)
    for (let l in r)
      l.startsWith("on") && typeof r[l] == "function" ? (t[l] != null || (t[l] = []), t[l].push(r[l])) : n[l] = r[l];
  if (n.disabled || n["aria-disabled"])
    return Object.assign(n, Object.fromEntries(Object.keys(t).map((r) => [r, void 0])));
  for (let r in t)
    Object.assign(n, { [r](l, ...o) {
      let s = t[r];
      for (let a of s) {
        if (l instanceof Event && l.defaultPrevented)
          return;
        a(l, ...o);
      }
    } });
  return n;
}
function Eo(e) {
  let n = Object.assign({}, e);
  for (let t in n)
    n[t] === void 0 && delete n[t];
  return n;
}
function tt(e, n = []) {
  let t = Object.assign({}, e);
  for (let r of n)
    r in t && delete t[r];
  return t;
}
function Co(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
var Ye = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(Ye || {});
let ct = O({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(e, { slots: n, attrs: t }) {
  return () => {
    var r;
    let { features: l, ...o } = e, s = { "aria-hidden": (l & 2) === 2 ? !0 : (r = o["aria-hidden"]) != null ? r : void 0, hidden: (l & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(l & 4) === 4 && (l & 2) !== 2 && { display: "none" } } };
    return oe({ ourProps: s, theirProps: o, slot: {}, attrs: t, slots: n, name: "Hidden" });
  };
} }), Ln = Symbol("Context");
var ie = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(ie || {});
function Io() {
  return nt() !== null;
}
function nt() {
  return ge(Ln, null);
}
function Wt(e) {
  we(Ln, e);
}
var J = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(J || {}), Nn = ((e) => (e[e.Left = 0] = "Left", e[e.Right = 2] = "Right", e))(Nn || {});
function To(e) {
  function n() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", n));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", n), n());
}
let Ie = [];
To(() => {
  function e(n) {
    n.target instanceof HTMLElement && n.target !== document.body && Ie[0] !== n.target && (Ie.unshift(n.target), Ie = Ie.filter((t) => t != null && t.isConnected), Ie.splice(10));
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function Po(e) {
  throw new Error("Unexpected object: " + e);
}
var ee = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(ee || {});
function Ct(e, n) {
  let t = n.resolveItems();
  if (t.length <= 0)
    return null;
  let r = n.resolveActiveIndex(), l = r != null ? r : -1;
  switch (e.focus) {
    case 0: {
      for (let o = 0; o < t.length; ++o)
        if (!n.resolveDisabled(t[o], o, t))
          return o;
      return r;
    }
    case 1: {
      l === -1 && (l = t.length);
      for (let o = l - 1; o >= 0; --o)
        if (!n.resolveDisabled(t[o], o, t))
          return o;
      return r;
    }
    case 2: {
      for (let o = l + 1; o < t.length; ++o)
        if (!n.resolveDisabled(t[o], o, t))
          return o;
      return r;
    }
    case 3: {
      for (let o = t.length - 1; o >= 0; --o)
        if (!n.resolveDisabled(t[o], o, t))
          return o;
      return r;
    }
    case 4: {
      for (let o = 0; o < t.length; ++o)
        if (n.resolveId(t[o], o, t) === e.id)
          return o;
      return r;
    }
    case 5:
      return null;
    default:
      Po(e);
  }
}
function jn(e = {}, n = null, t = []) {
  for (let [r, l] of Object.entries(e))
    Un(t, zn(n, r), l);
  return t;
}
function zn(e, n) {
  return e ? e + "[" + n + "]" : n;
}
function Un(e, n, t) {
  if (Array.isArray(t))
    for (let [r, l] of t.entries())
      Un(e, zn(n, r.toString()), l);
  else
    t instanceof Date ? e.push([n, t.toISOString()]) : typeof t == "boolean" ? e.push([n, t ? "1" : "0"]) : typeof t == "string" ? e.push([n, t]) : typeof t == "number" ? e.push([n, `${t}`]) : t == null ? e.push([n, ""]) : jn(t, n, e);
}
function Bo(e, n) {
  return e === n;
}
var Ro = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Ro || {}), Mo = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(Mo || {}), Ao = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Focus = 1] = "Focus", e[e.Other = 2] = "Other", e))(Ao || {});
let Hn = Symbol("ComboboxContext");
function Ne(e) {
  let n = ge(Hn, null);
  if (n === null) {
    let t = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, Ne), t;
  }
  return n;
}
let Wn = Symbol("VirtualContext"), Vo = O({ name: "VirtualProvider", setup(e, { slots: n }) {
  let t = Ne("VirtualProvider"), r = y(() => {
    let a = P(t.optionsRef);
    if (!a)
      return { start: 0, end: 0 };
    let i = window.getComputedStyle(a);
    return { start: parseFloat(i.paddingBlockStart || i.paddingTop), end: parseFloat(i.paddingBlockEnd || i.paddingBottom) };
  }), l = po(y(() => ({ scrollPaddingStart: r.value.start, scrollPaddingEnd: r.value.end, count: t.virtual.value.options.length, estimateSize() {
    return 40;
  }, getScrollElement() {
    return P(t.optionsRef);
  }, overscan: 12 }))), o = y(() => {
    var a;
    return (a = t.virtual.value) == null ? void 0 : a.options;
  }), s = _(0);
  return te([o], () => {
    s.value += 1;
  }), we(Wn, t.virtual.value ? l : null), () => [se("div", { style: { position: "relative", width: "100%", height: `${l.value.getTotalSize()}px` }, ref: (a) => {
    if (a) {
      if (typeof process < "u" && process.env.JEST_WORKER_ID !== void 0 || t.activationTrigger.value === 0)
        return;
      t.activeOptionIndex.value !== null && t.virtual.value.options.length > t.activeOptionIndex.value && l.value.scrollToIndex(t.activeOptionIndex.value);
    }
  } }, l.value.getVirtualItems().map((a) => _n(n.default({ option: t.virtual.value.options[a.index], open: t.comboboxState.value === 0 })[0], { key: `${s.value}-${a.index}`, "data-index": a.index, "aria-setsize": t.virtual.value.options.length, "aria-posinset": a.index + 1, style: { position: "absolute", top: 0, left: 0, transform: `translateY(${a.start}px)`, overflowAnchor: "none" } })))];
} }), Do = O({ name: "Combobox", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], nullable: !0, default: null }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, nullable: { type: Boolean, default: !1 }, multiple: { type: [Boolean], default: !1 }, immediate: { type: [Boolean], default: !1 }, virtual: { type: Object, default: null } }, inheritAttrs: !1, setup(e, { slots: n, attrs: t, emit: r }) {
  let l = _(1), o = _(null), s = _(null), a = _(null), i = _(null), p = _({ static: !1, hold: !1 }), d = _([]), v = _(null), f = _(2), h = _(!1);
  function g(S = (R) => R) {
    let R = v.value !== null ? d.value[v.value] : null, U = S(d.value.slice()), z = U.length > 0 && U[0].dataRef.order.value !== null ? U.sort((q, ae) => q.dataRef.order.value - ae.dataRef.order.value) : Ut(U, (q) => P(q.dataRef.domRef)), Q = R ? z.indexOf(R) : null;
    return Q === -1 && (Q = null), { options: z, activeOptionIndex: Q };
  }
  let w = y(() => e.multiple ? 1 : 0), T = y(() => e.nullable), [N, B] = fo(y(() => e.modelValue), (S) => r("update:modelValue", S), y(() => e.defaultValue)), j = y(() => N.value === void 0 ? fe(w.value, { [1]: [], [0]: void 0 }) : N.value), ue = null, A = null;
  function Z(S) {
    return fe(w.value, { [0]() {
      return B == null ? void 0 : B(S);
    }, [1]: () => {
      let R = $e(E.value.value).slice(), U = $e(S), z = R.findIndex((Q) => E.compare(U, $e(Q)));
      return z === -1 ? R.push(U) : R.splice(z, 1), B == null ? void 0 : B(R);
    } });
  }
  let Y = y(() => {
  });
  te([Y], ([S], [R]) => {
    if (E.virtual.value && S && R && v.value !== null) {
      let U = S.indexOf(R[v.value]);
      U !== -1 ? v.value = U : v.value = null;
    }
  });
  let E = { comboboxState: l, value: j, mode: w, compare(S, R) {
    if (typeof e.by == "string") {
      let U = e.by;
      return (S == null ? void 0 : S[U]) === (R == null ? void 0 : R[U]);
    }
    return e.by === null ? Bo(S, R) : e.by(S, R);
  }, calculateIndex(S) {
    return E.virtual.value ? e.by === null ? E.virtual.value.options.indexOf(S) : E.virtual.value.options.findIndex((R) => E.compare(R, S)) : d.value.findIndex((R) => E.compare(R.dataRef.value, S));
  }, defaultValue: y(() => e.defaultValue), nullable: T, immediate: y(() => !1), virtual: y(() => null), inputRef: s, labelRef: o, buttonRef: a, optionsRef: i, disabled: y(() => e.disabled), options: d, change(S) {
    B(S);
  }, activeOptionIndex: y(() => {
    if (h.value && v.value === null && (E.virtual.value ? E.virtual.value.options.length > 0 : d.value.length > 0)) {
      if (E.virtual.value) {
        let R = E.virtual.value.options.findIndex((U) => {
          var z;
          return !((z = E.virtual.value) != null && z.disabled(U));
        });
        if (R !== -1)
          return R;
      }
      let S = d.value.findIndex((R) => !R.dataRef.disabled);
      if (S !== -1)
        return S;
    }
    return v.value;
  }), activationTrigger: f, optionsPropsRef: p, closeCombobox() {
    h.value = !1, !e.disabled && l.value !== 1 && (l.value = 1, v.value = null);
  }, openCombobox() {
    if (h.value = !0, !e.disabled && l.value !== 0) {
      if (E.value.value) {
        let S = E.calculateIndex(E.value.value);
        S !== -1 && (v.value = S);
      }
      l.value = 0;
    }
  }, setActivationTrigger(S) {
    f.value = S;
  }, goToOption(S, R, U) {
    h.value = !1, ue !== null && cancelAnimationFrame(ue), ue = requestAnimationFrame(() => {
      if (e.disabled || i.value && !p.value.static && l.value === 1)
        return;
      if (E.virtual.value) {
        v.value = S === ee.Specific ? R : Ct({ focus: S }, { resolveItems: () => E.virtual.value.options, resolveActiveIndex: () => {
          var q, ae;
          return (ae = (q = E.activeOptionIndex.value) != null ? q : E.virtual.value.options.findIndex((ve) => {
            var b;
            return !((b = E.virtual.value) != null && b.disabled(ve));
          })) != null ? ae : null;
        }, resolveDisabled: (q) => E.virtual.value.disabled(q), resolveId() {
          throw new Error("Function not implemented.");
        } }), f.value = U != null ? U : 2;
        return;
      }
      let z = g();
      if (z.activeOptionIndex === null) {
        let q = z.options.findIndex((ae) => !ae.dataRef.disabled);
        q !== -1 && (z.activeOptionIndex = q);
      }
      let Q = S === ee.Specific ? R : Ct({ focus: S }, { resolveItems: () => z.options, resolveActiveIndex: () => z.activeOptionIndex, resolveId: (q) => q.id, resolveDisabled: (q) => q.dataRef.disabled });
      v.value = Q, f.value = U != null ? U : 2, d.value = z.options;
    });
  }, selectOption(S) {
    let R = d.value.find((z) => z.id === S);
    if (!R)
      return;
    let { dataRef: U } = R;
    Z(U.value);
  }, selectActiveOption() {
    if (E.activeOptionIndex.value !== null) {
      if (E.virtual.value)
        Z(E.virtual.value.options[E.activeOptionIndex.value]);
      else {
        let { dataRef: S } = d.value[E.activeOptionIndex.value];
        Z(S.value);
      }
      E.goToOption(ee.Specific, E.activeOptionIndex.value);
    }
  }, registerOption(S, R) {
    let U = $n({ id: S, dataRef: R });
    if (E.virtual.value) {
      d.value.push(U);
      return;
    }
    A && cancelAnimationFrame(A);
    let z = g((Q) => (Q.push(U), Q));
    v.value === null && E.isSelected(R.value.value) && (z.activeOptionIndex = z.options.indexOf(U)), d.value = z.options, v.value = z.activeOptionIndex, f.value = 2, z.options.some((Q) => !P(Q.dataRef.domRef)) && (A = requestAnimationFrame(() => {
      let Q = g();
      d.value = Q.options, v.value = Q.activeOptionIndex;
    }));
  }, unregisterOption(S, R) {
    if (ue !== null && cancelAnimationFrame(ue), R && (h.value = !0), E.virtual.value) {
      d.value = d.value.filter((z) => z.id !== S);
      return;
    }
    let U = g((z) => {
      let Q = z.findIndex((q) => q.id === S);
      return Q !== -1 && z.splice(Q, 1), z;
    });
    d.value = U.options, v.value = U.activeOptionIndex, f.value = 2;
  }, isSelected(S) {
    return fe(w.value, { [0]: () => E.compare($e(E.value.value), $e(S)), [1]: () => $e(E.value.value).some((R) => E.compare($e(R), $e(S))) });
  }, isActive(S) {
    return v.value === E.calculateIndex(S);
  } };
  Ht([s, a, i], () => E.closeCombobox(), y(() => l.value === 0)), we(Hn, E), Wt(y(() => fe(l.value, { [0]: ie.Open, [1]: ie.Closed })));
  let G = y(() => {
    var S;
    return (S = P(s)) == null ? void 0 : S.closest("form");
  });
  return re(() => {
    te([G], () => {
      if (!G.value || e.defaultValue === void 0)
        return;
      function S() {
        E.change(e.defaultValue);
      }
      return G.value.addEventListener("reset", S), () => {
        var R;
        (R = G.value) == null || R.removeEventListener("reset", S);
      };
    }, { immediate: !0 });
  }), () => {
    var S, R, U;
    let { name: z, disabled: Q, form: q, ...ae } = e, ve = { open: l.value === 0, disabled: Q, activeIndex: E.activeOptionIndex.value, activeOption: E.activeOptionIndex.value === null ? null : E.virtual.value ? E.virtual.value.options[(S = E.activeOptionIndex.value) != null ? S : 0] : (U = (R = E.options.value[E.activeOptionIndex.value]) == null ? void 0 : R.dataRef.value) != null ? U : null, value: j.value };
    return se(le, [...z != null && j.value != null ? jn({ [z]: j.value }).map(([b, C]) => se(ct, Eo({ features: Ye.Hidden, key: b, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: q, disabled: Q, name: b, value: C }))) : [], oe({ theirProps: { ...t, ...tt(ae, ["by", "defaultValue", "immediate", "modelValue", "multiple", "nullable", "onUpdate:modelValue", "virtual"]) }, ourProps: {}, slot: ve, slots: n, attrs: t, name: "Combobox" })]);
  };
} });
O({ name: "ComboboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: null } }, setup(e, { attrs: n, slots: t }) {
  var r;
  let l = (r = e.id) != null ? r : `headlessui-combobox-label-${be()}`, o = Ne("ComboboxLabel");
  function s() {
    var a;
    (a = P(o.inputRef)) == null || a.focus({ preventScroll: !0 });
  }
  return () => {
    let a = { open: o.comboboxState.value === 0, disabled: o.disabled.value }, { ...i } = e, p = { id: l, ref: o.labelRef, onClick: s };
    return oe({ ourProps: p, theirProps: i, slot: a, attrs: n, slots: t, name: "ComboboxLabel" });
  };
} });
let Fo = O({ name: "ComboboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(e, { attrs: n, slots: t, expose: r }) {
  var l;
  let o = (l = e.id) != null ? l : `headlessui-combobox-button-${be()}`, s = Ne("ComboboxButton");
  r({ el: s.buttonRef, $el: s.buttonRef });
  function a(d) {
    s.disabled.value || (s.comboboxState.value === 0 ? s.closeCombobox() : (d.preventDefault(), s.openCombobox()), me(() => {
      var v;
      return (v = P(s.inputRef)) == null ? void 0 : v.focus({ preventScroll: !0 });
    }));
  }
  function i(d) {
    switch (d.key) {
      case J.ArrowDown:
        d.preventDefault(), d.stopPropagation(), s.comboboxState.value === 1 && s.openCombobox(), me(() => {
          var v;
          return (v = s.inputRef.value) == null ? void 0 : v.focus({ preventScroll: !0 });
        });
        return;
      case J.ArrowUp:
        d.preventDefault(), d.stopPropagation(), s.comboboxState.value === 1 && (s.openCombobox(), me(() => {
          s.value.value || s.goToOption(ee.Last);
        })), me(() => {
          var v;
          return (v = s.inputRef.value) == null ? void 0 : v.focus({ preventScroll: !0 });
        });
        return;
      case J.Escape:
        if (s.comboboxState.value !== 0)
          return;
        d.preventDefault(), s.optionsRef.value && !s.optionsPropsRef.value.static && d.stopPropagation(), s.closeCombobox(), me(() => {
          var v;
          return (v = s.inputRef.value) == null ? void 0 : v.focus({ preventScroll: !0 });
        });
        return;
    }
  }
  let p = Mn(y(() => ({ as: e.as, type: n.type })), s.buttonRef);
  return () => {
    var d, v;
    let f = { open: s.comboboxState.value === 0, disabled: s.disabled.value, value: s.value.value }, { ...h } = e, g = { ref: s.buttonRef, id: o, type: p.value, tabindex: "-1", "aria-haspopup": "listbox", "aria-controls": (d = P(s.optionsRef)) == null ? void 0 : d.id, "aria-expanded": s.comboboxState.value === 0, "aria-labelledby": s.labelRef.value ? [(v = P(s.labelRef)) == null ? void 0 : v.id, o].join(" ") : void 0, disabled: s.disabled.value === !0 ? !0 : void 0, onKeydown: i, onClick: a };
    return oe({ ourProps: g, theirProps: h, slot: f, attrs: n, slots: t, name: "ComboboxButton" });
  };
} }), Lo = O({ name: "ComboboxInput", props: { as: { type: [Object, String], default: "input" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, displayValue: { type: Function }, defaultValue: { type: String, default: void 0 }, id: { type: String, default: null } }, emits: { change: (e) => !0 }, setup(e, { emit: n, attrs: t, slots: r, expose: l }) {
  var o;
  let s = (o = e.id) != null ? o : `headlessui-combobox-input-${be()}`, a = Ne("ComboboxInput"), i = y(() => Te(P(a.inputRef))), p = { value: !1 };
  l({ el: a.inputRef, $el: a.inputRef });
  function d() {
    a.change(null);
    let A = P(a.optionsRef);
    A && (A.scrollTop = 0), a.goToOption(ee.Nothing);
  }
  let v = y(() => {
    var A;
    let Z = a.value.value;
    return P(a.inputRef) ? typeof e.displayValue < "u" && Z !== void 0 ? (A = e.displayValue(Z)) != null ? A : "" : typeof Z == "string" ? Z : "" : "";
  });
  re(() => {
    te([v, a.comboboxState, i], ([A, Z], [Y, E]) => {
      if (p.value)
        return;
      let G = P(a.inputRef);
      G && ((E === 0 && Z === 1 || A !== Y) && (G.value = A), requestAnimationFrame(() => {
        var S;
        if (p.value || !G || ((S = i.value) == null ? void 0 : S.activeElement) !== G)
          return;
        let { selectionStart: R, selectionEnd: U } = G;
        Math.abs((U != null ? U : 0) - (R != null ? R : 0)) === 0 && R === 0 && G.setSelectionRange(G.value.length, G.value.length);
      }));
    }, { immediate: !0 }), te([a.comboboxState], ([A], [Z]) => {
      if (A === 0 && Z === 1) {
        if (p.value)
          return;
        let Y = P(a.inputRef);
        if (!Y)
          return;
        let E = Y.value, { selectionStart: G, selectionEnd: S, selectionDirection: R } = Y;
        Y.value = "", Y.value = E, R !== null ? Y.setSelectionRange(G, S, R) : Y.setSelectionRange(G, S);
      }
    });
  });
  let f = _(!1);
  function h() {
    f.value = !0;
  }
  function g() {
    Re().nextFrame(() => {
      f.value = !1;
    });
  }
  let w = mo();
  function T(A) {
    switch (p.value = !0, w(() => {
      p.value = !1;
    }), A.key) {
      case J.Enter:
        if (p.value = !1, a.comboboxState.value !== 0 || f.value)
          return;
        if (A.preventDefault(), A.stopPropagation(), a.activeOptionIndex.value === null) {
          a.closeCombobox();
          return;
        }
        a.selectActiveOption(), a.mode.value === 0 && a.closeCombobox();
        break;
      case J.ArrowDown:
        return p.value = !1, A.preventDefault(), A.stopPropagation(), fe(a.comboboxState.value, { [0]: () => a.goToOption(ee.Next), [1]: () => a.openCombobox() });
      case J.ArrowUp:
        return p.value = !1, A.preventDefault(), A.stopPropagation(), fe(a.comboboxState.value, { [0]: () => a.goToOption(ee.Previous), [1]: () => {
          a.openCombobox(), me(() => {
            a.value.value || a.goToOption(ee.Last);
          });
        } });
      case J.Home:
        if (A.shiftKey)
          break;
        return p.value = !1, A.preventDefault(), A.stopPropagation(), a.goToOption(ee.First);
      case J.PageUp:
        return p.value = !1, A.preventDefault(), A.stopPropagation(), a.goToOption(ee.First);
      case J.End:
        if (A.shiftKey)
          break;
        return p.value = !1, A.preventDefault(), A.stopPropagation(), a.goToOption(ee.Last);
      case J.PageDown:
        return p.value = !1, A.preventDefault(), A.stopPropagation(), a.goToOption(ee.Last);
      case J.Escape:
        if (p.value = !1, a.comboboxState.value !== 0)
          return;
        A.preventDefault(), a.optionsRef.value && !a.optionsPropsRef.value.static && A.stopPropagation(), a.nullable.value && a.mode.value === 0 && a.value.value === null && d(), a.closeCombobox();
        break;
      case J.Tab:
        if (p.value = !1, a.comboboxState.value !== 0)
          return;
        a.mode.value === 0 && a.activationTrigger.value !== 1 && a.selectActiveOption(), a.closeCombobox();
        break;
    }
  }
  function N(A) {
    n("change", A), a.nullable.value && a.mode.value === 0 && A.target.value === "" && d(), a.openCombobox();
  }
  function B(A) {
    var Z, Y, E;
    let G = (Z = A.relatedTarget) != null ? Z : Ie.find((S) => S !== A.currentTarget);
    if (p.value = !1, !((Y = P(a.optionsRef)) != null && Y.contains(G)) && !((E = P(a.buttonRef)) != null && E.contains(G)) && a.comboboxState.value === 0)
      return A.preventDefault(), a.mode.value === 0 && (a.nullable.value && a.value.value === null ? d() : a.activationTrigger.value !== 1 && a.selectActiveOption()), a.closeCombobox();
  }
  function j(A) {
    var Z, Y, E;
    let G = (Z = A.relatedTarget) != null ? Z : Ie.find((S) => S !== A.currentTarget);
    (Y = P(a.buttonRef)) != null && Y.contains(G) || (E = P(a.optionsRef)) != null && E.contains(G) || a.disabled.value || a.immediate.value && a.comboboxState.value !== 0 && (a.openCombobox(), Re().nextFrame(() => {
      a.setActivationTrigger(1);
    }));
  }
  let ue = y(() => {
    var A, Z, Y, E;
    return (E = (Y = (Z = e.defaultValue) != null ? Z : a.defaultValue.value !== void 0 ? (A = e.displayValue) == null ? void 0 : A.call(e, a.defaultValue.value) : null) != null ? Y : a.defaultValue.value) != null ? E : "";
  });
  return () => {
    var A, Z, Y, E, G, S, R;
    let U = { open: a.comboboxState.value === 0 }, { displayValue: z, onChange: Q, ...q } = e, ae = { "aria-controls": (A = a.optionsRef.value) == null ? void 0 : A.id, "aria-expanded": a.comboboxState.value === 0, "aria-activedescendant": a.activeOptionIndex.value === null ? void 0 : a.virtual.value ? (Z = a.options.value.find((ve) => !a.virtual.value.disabled(ve.dataRef.value) && a.compare(ve.dataRef.value, a.virtual.value.options[a.activeOptionIndex.value]))) == null ? void 0 : Z.id : (Y = a.options.value[a.activeOptionIndex.value]) == null ? void 0 : Y.id, "aria-labelledby": (S = (E = P(a.labelRef)) == null ? void 0 : E.id) != null ? S : (G = P(a.buttonRef)) == null ? void 0 : G.id, "aria-autocomplete": "list", id: s, onCompositionstart: h, onCompositionend: g, onKeydown: T, onInput: N, onFocus: j, onBlur: B, role: "combobox", type: (R = t.type) != null ? R : "text", tabIndex: 0, ref: a.inputRef, defaultValue: ue.value, disabled: a.disabled.value === !0 ? !0 : void 0 };
    return oe({ ourProps: ae, theirProps: q, slot: U, attrs: t, slots: r, features: Ce.RenderStrategy | Ce.Static, name: "ComboboxInput" });
  };
} }), No = O({ name: "ComboboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, hold: { type: [Boolean], default: !1 } }, setup(e, { attrs: n, slots: t, expose: r }) {
  let l = Ne("ComboboxOptions"), o = `headlessui-combobox-options-${be()}`;
  r({ el: l.optionsRef, $el: l.optionsRef }), pe(() => {
    l.optionsPropsRef.value.static = e.static;
  }), pe(() => {
    l.optionsPropsRef.value.hold = e.hold;
  });
  let s = nt(), a = y(() => s !== null ? (s.value & ie.Open) === ie.Open : l.comboboxState.value === 0);
  Vn({ container: y(() => P(l.optionsRef)), enabled: y(() => l.comboboxState.value === 0), accept(p) {
    return p.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : p.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(p) {
    p.setAttribute("role", "none");
  } });
  function i(p) {
    p.preventDefault();
  }
  return () => {
    var p, d, v;
    let f = { open: l.comboboxState.value === 0 }, h = { "aria-labelledby": (v = (p = P(l.labelRef)) == null ? void 0 : p.id) != null ? v : (d = P(l.buttonRef)) == null ? void 0 : d.id, id: o, ref: l.optionsRef, role: "listbox", "aria-multiselectable": l.mode.value === 1 ? !0 : void 0, onMousedown: i }, g = tt(e, ["hold"]);
    return oe({ ourProps: h, theirProps: g, slot: f, attrs: n, slots: l.virtual.value && l.comboboxState.value === 0 ? { ...t, default: () => [se(Vo, {}, t.default)] } : t, features: Ce.RenderStrategy | Ce.Static, visible: a.value, name: "ComboboxOptions" });
  };
} }), jo = O({ name: "ComboboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, order: { type: [Number], default: null } }, setup(e, { slots: n, attrs: t, expose: r }) {
  let l = Ne("ComboboxOption"), o = `headlessui-combobox-option-${be()}`, s = _(null), a = y(() => e.disabled);
  r({ el: s, $el: s });
  let i = y(() => {
    var B;
    return l.virtual.value ? l.activeOptionIndex.value === l.calculateIndex(e.value) : l.activeOptionIndex.value === null ? !1 : ((B = l.options.value[l.activeOptionIndex.value]) == null ? void 0 : B.id) === o;
  }), p = y(() => l.isSelected(e.value)), d = ge(Wn, null), v = y(() => ({ disabled: e.disabled, value: e.value, domRef: s, order: y(() => e.order) }));
  re(() => l.registerOption(o, v)), he(() => l.unregisterOption(o, i.value)), pe(() => {
    let B = P(s);
    B && (d == null || d.value.measureElement(B));
  }), pe(() => {
    l.comboboxState.value === 0 && i.value && (l.virtual.value || l.activationTrigger.value !== 0 && me(() => {
      var B, j;
      return (j = (B = P(s)) == null ? void 0 : B.scrollIntoView) == null ? void 0 : j.call(B, { block: "nearest" });
    }));
  });
  function f(B) {
    B.preventDefault(), B.button === Nn.Left && (a.value || (l.selectOption(o), Bn() || requestAnimationFrame(() => {
      var j;
      return (j = P(l.inputRef)) == null ? void 0 : j.focus({ preventScroll: !0 });
    }), l.mode.value === 0 && l.closeCombobox()));
  }
  function h() {
    var B;
    if (e.disabled || (B = l.virtual.value) != null && B.disabled(e.value))
      return l.goToOption(ee.Nothing);
    let j = l.calculateIndex(e.value);
    l.goToOption(ee.Specific, j);
  }
  let g = An();
  function w(B) {
    g.update(B);
  }
  function T(B) {
    var j;
    if (!g.wasMoved(B) || e.disabled || (j = l.virtual.value) != null && j.disabled(e.value) || i.value)
      return;
    let ue = l.calculateIndex(e.value);
    l.goToOption(ee.Specific, ue, 0);
  }
  function N(B) {
    var j;
    g.wasMoved(B) && (e.disabled || (j = l.virtual.value) != null && j.disabled(e.value) || i.value && (l.optionsPropsRef.value.hold || l.goToOption(ee.Nothing)));
  }
  return () => {
    let { disabled: B } = e, j = { active: i.value, selected: p.value, disabled: B }, ue = { id: o, ref: s, role: "option", tabIndex: B === !0 ? void 0 : -1, "aria-disabled": B === !0 ? !0 : void 0, "aria-selected": p.value, disabled: void 0, onMousedown: f, onFocus: h, onPointerenter: w, onMouseenter: w, onPointermove: T, onMousemove: T, onPointerleave: N, onMouseleave: N }, A = tt(e, ["order", "value"]);
    return oe({ ourProps: ue, theirProps: A, slot: j, attrs: t, slots: n, name: "ComboboxOption" });
  };
} });
function Kn(e, n, t, r) {
  et.isServer || pe((l) => {
    e = e != null ? e : window, e.addEventListener(n, t, r), l(() => e.removeEventListener(n, t, r));
  });
}
var Ze = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(Ze || {});
function zo() {
  let e = _(0);
  return Rn("keydown", (n) => {
    n.key === "Tab" && (e.value = n.shiftKey ? 1 : 0);
  }), e;
}
function Zn(e) {
  if (!e)
    return /* @__PURE__ */ new Set();
  if (typeof e == "function")
    return new Set(e());
  let n = /* @__PURE__ */ new Set();
  for (let t of e.value) {
    let r = P(t);
    r instanceof HTMLElement && n.add(r);
  }
  return n;
}
var qn = ((e) => (e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.All = 30] = "All", e))(qn || {});
let We = Object.assign(O({ name: "FocusTrap", props: { as: { type: [Object, String], default: "div" }, initialFocus: { type: Object, default: null }, features: { type: Number, default: 30 }, containers: { type: [Object, Function], default: _(/* @__PURE__ */ new Set()) } }, inheritAttrs: !1, setup(e, { attrs: n, slots: t, expose: r }) {
  let l = _(null);
  r({ el: l, $el: l });
  let o = y(() => Te(l)), s = _(!1);
  re(() => s.value = !0), he(() => s.value = !1), Ho({ ownerDocument: o }, y(() => s.value && Boolean(e.features & 16)));
  let a = Wo({ ownerDocument: o, container: l, initialFocus: y(() => e.initialFocus) }, y(() => s.value && Boolean(e.features & 2)));
  Ko({ ownerDocument: o, container: l, containers: e.containers, previousActiveElement: a }, y(() => s.value && Boolean(e.features & 8)));
  let i = zo();
  function p(h) {
    let g = P(l);
    !g || ((w) => w())(() => {
      fe(i.value, { [Ze.Forwards]: () => {
        Ge(g, Ee.First, { skipElements: [h.relatedTarget] });
      }, [Ze.Backwards]: () => {
        Ge(g, Ee.Last, { skipElements: [h.relatedTarget] });
      } });
    });
  }
  let d = _(!1);
  function v(h) {
    h.key === "Tab" && (d.value = !0, requestAnimationFrame(() => {
      d.value = !1;
    }));
  }
  function f(h) {
    if (!s.value)
      return;
    let g = Zn(e.containers);
    P(l) instanceof HTMLElement && g.add(P(l));
    let w = h.relatedTarget;
    w instanceof HTMLElement && w.dataset.headlessuiFocusGuard !== "true" && (Gn(g, w) || (d.value ? Ge(P(l), fe(i.value, { [Ze.Forwards]: () => Ee.Next, [Ze.Backwards]: () => Ee.Previous }) | Ee.WrapAround, { relativeTo: h.target }) : h.target instanceof HTMLElement && Be(h.target)));
  }
  return () => {
    let h = {}, g = { ref: l, onKeydown: v, onFocusout: f }, { features: w, initialFocus: T, containers: N, ...B } = e;
    return se(le, [Boolean(w & 4) && se(ct, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: p, features: Ye.Focusable }), oe({ ourProps: g, theirProps: { ...n, ...B }, slot: h, attrs: n, slots: t, name: "FocusTrap" }), Boolean(w & 4) && se(ct, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: p, features: Ye.Focusable })]);
  };
} }), { features: qn });
function Uo(e) {
  let n = _(Ie.slice());
  return te([e], ([t], [r]) => {
    r === !0 && t === !1 ? Nt(() => {
      n.value.splice(0);
    }) : r === !1 && t === !0 && (n.value = Ie.slice());
  }, { flush: "post" }), () => {
    var t;
    return (t = n.value.find((r) => r != null && r.isConnected)) != null ? t : null;
  };
}
function Ho({ ownerDocument: e }, n) {
  let t = Uo(n);
  re(() => {
    pe(() => {
      var r, l;
      n.value || ((r = e.value) == null ? void 0 : r.activeElement) === ((l = e.value) == null ? void 0 : l.body) && Be(t());
    }, { flush: "post" });
  }), he(() => {
    n.value && Be(t());
  });
}
function Wo({ ownerDocument: e, container: n, initialFocus: t }, r) {
  let l = _(null), o = _(!1);
  return re(() => o.value = !0), he(() => o.value = !1), re(() => {
    te([n, t, r], (s, a) => {
      if (s.every((p, d) => (a == null ? void 0 : a[d]) === p) || !r.value)
        return;
      let i = P(n);
      i && Nt(() => {
        var p, d;
        if (!o.value)
          return;
        let v = P(t), f = (p = e.value) == null ? void 0 : p.activeElement;
        if (v) {
          if (v === f) {
            l.value = f;
            return;
          }
        } else if (i.contains(f)) {
          l.value = f;
          return;
        }
        v ? Be(v) : Ge(i, Ee.First | Ee.NoScroll) === Cn.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), l.value = (d = e.value) == null ? void 0 : d.activeElement;
      });
    }, { immediate: !0, flush: "post" });
  }), l;
}
function Ko({ ownerDocument: e, container: n, containers: t, previousActiveElement: r }, l) {
  var o;
  Kn((o = e.value) == null ? void 0 : o.defaultView, "focus", (s) => {
    if (!l.value)
      return;
    let a = Zn(t);
    P(n) instanceof HTMLElement && a.add(P(n));
    let i = r.value;
    if (!i)
      return;
    let p = s.target;
    p && p instanceof HTMLElement ? Gn(a, p) ? (r.value = p, Be(p)) : (s.preventDefault(), s.stopPropagation(), Be(i)) : Be(r.value);
  }, !0);
}
function Gn(e, n) {
  for (let t of e)
    if (t.contains(n))
      return !0;
  return !1;
}
function Zo(e) {
  let n = wn(e.getSnapshot());
  return he(e.subscribe(() => {
    n.value = e.getSnapshot();
  })), n;
}
function qo(e, n) {
  let t = e(), r = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return t;
  }, subscribe(l) {
    return r.add(l), () => r.delete(l);
  }, dispatch(l, ...o) {
    let s = n[l].call(t, ...o);
    s && (t = s, r.forEach((a) => a()));
  } };
}
function Go() {
  let e;
  return { before({ doc: n }) {
    var t;
    let r = n.documentElement;
    e = ((t = n.defaultView) != null ? t : window).innerWidth - r.clientWidth;
  }, after({ doc: n, d: t }) {
    let r = n.documentElement, l = r.clientWidth - r.offsetWidth, o = e - l;
    t.style(r, "paddingRight", `${o}px`);
  } };
}
function Qo() {
  return Pn() ? { before({ doc: e, d: n, meta: t }) {
    function r(l) {
      return t.containers.flatMap((o) => o()).some((o) => o.contains(l));
    }
    n.microTask(() => {
      var l;
      if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
        let a = Re();
        a.style(e.documentElement, "scrollBehavior", "auto"), n.add(() => n.microTask(() => a.dispose()));
      }
      let o = (l = window.scrollY) != null ? l : window.pageYOffset, s = null;
      n.addEventListener(e, "click", (a) => {
        if (a.target instanceof HTMLElement)
          try {
            let i = a.target.closest("a");
            if (!i)
              return;
            let { hash: p } = new URL(i.href), d = e.querySelector(p);
            d && !r(d) && (s = d);
          } catch {
          }
      }, !0), n.addEventListener(e, "touchstart", (a) => {
        if (a.target instanceof HTMLElement)
          if (r(a.target)) {
            let i = a.target;
            for (; i.parentElement && r(i.parentElement); )
              i = i.parentElement;
            n.style(i, "overscrollBehavior", "contain");
          } else
            n.style(a.target, "touchAction", "none");
      }), n.addEventListener(e, "touchmove", (a) => {
        if (a.target instanceof HTMLElement) {
          if (a.target.tagName === "INPUT")
            return;
          if (r(a.target)) {
            let i = a.target;
            for (; i.parentElement && i.dataset.headlessuiPortal !== "" && !(i.scrollHeight > i.clientHeight || i.scrollWidth > i.clientWidth); )
              i = i.parentElement;
            i.dataset.headlessuiPortal === "" && a.preventDefault();
          } else
            a.preventDefault();
        }
      }, { passive: !1 }), n.add(() => {
        var a;
        let i = (a = window.scrollY) != null ? a : window.pageYOffset;
        o !== i && window.scrollTo(0, o), s && s.isConnected && (s.scrollIntoView({ block: "nearest" }), s = null);
      });
    });
  } } : {};
}
function Yo() {
  return { before({ doc: e, d: n }) {
    n.style(e.documentElement, "overflow", "hidden");
  } };
}
function Xo(e) {
  let n = {};
  for (let t of e)
    Object.assign(n, t(n));
  return n;
}
let Ae = qo(() => /* @__PURE__ */ new Map(), { PUSH(e, n) {
  var t;
  let r = (t = this.get(e)) != null ? t : { doc: e, count: 0, d: Re(), meta: /* @__PURE__ */ new Set() };
  return r.count++, r.meta.add(n), this.set(e, r), this;
}, POP(e, n) {
  let t = this.get(e);
  return t && (t.count--, t.meta.delete(n)), this;
}, SCROLL_PREVENT({ doc: e, d: n, meta: t }) {
  let r = { doc: e, d: n, meta: Xo(t) }, l = [Qo(), Go(), Yo()];
  l.forEach(({ before: o }) => o == null ? void 0 : o(r)), l.forEach(({ after: o }) => o == null ? void 0 : o(r));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
Ae.subscribe(() => {
  let e = Ae.getSnapshot(), n = /* @__PURE__ */ new Map();
  for (let [t] of e)
    n.set(t, t.documentElement.style.overflow);
  for (let t of e.values()) {
    let r = n.get(t.doc) === "hidden", l = t.count !== 0;
    (l && !r || !l && r) && Ae.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && Ae.dispatch("TEARDOWN", t);
  }
});
function Jo(e, n, t) {
  let r = Zo(Ae), l = y(() => {
    let o = e.value ? r.value.get(e.value) : void 0;
    return o ? o.count > 0 : !1;
  });
  return te([e, n], ([o, s], [a], i) => {
    if (!o || !s)
      return;
    Ae.dispatch("PUSH", o, t);
    let p = !1;
    i(() => {
      p || (Ae.dispatch("POP", a != null ? a : o, t), p = !0);
    });
  }, { immediate: !0 }), l;
}
let wt = /* @__PURE__ */ new Map(), Ke = /* @__PURE__ */ new Map();
function un(e, n = _(!0)) {
  pe((t) => {
    var r;
    if (!n.value)
      return;
    let l = P(e);
    if (!l)
      return;
    t(function() {
      var s;
      if (!l)
        return;
      let a = (s = Ke.get(l)) != null ? s : 1;
      if (a === 1 ? Ke.delete(l) : Ke.set(l, a - 1), a !== 1)
        return;
      let i = wt.get(l);
      i && (i["aria-hidden"] === null ? l.removeAttribute("aria-hidden") : l.setAttribute("aria-hidden", i["aria-hidden"]), l.inert = i.inert, wt.delete(l));
    });
    let o = (r = Ke.get(l)) != null ? r : 0;
    Ke.set(l, o + 1), o === 0 && (wt.set(l, { "aria-hidden": l.getAttribute("aria-hidden"), inert: l.inert }), l.setAttribute("aria-hidden", "true"), l.inert = !0);
  });
}
function ea({ defaultContainers: e = [], portals: n, mainTreeNodeRef: t } = {}) {
  let r = _(null), l = Te(r);
  function o() {
    var s, a, i;
    let p = [];
    for (let d of e)
      d !== null && (d instanceof HTMLElement ? p.push(d) : "value" in d && d.value instanceof HTMLElement && p.push(d.value));
    if (n != null && n.value)
      for (let d of n.value)
        p.push(d);
    for (let d of (s = l == null ? void 0 : l.querySelectorAll("html > *, body > *")) != null ? s : [])
      d !== document.body && d !== document.head && d instanceof HTMLElement && d.id !== "headlessui-portal-root" && (d.contains(P(r)) || d.contains((i = (a = P(r)) == null ? void 0 : a.getRootNode()) == null ? void 0 : i.host) || p.some((v) => d.contains(v)) || p.push(d));
    return p;
  }
  return { resolveContainers: o, contains(s) {
    return o().some((a) => a.contains(s));
  }, mainTreeNodeRef: r, MainTreeNode() {
    return t != null ? null : se(ct, { features: Ye.Hidden, ref: r });
  } };
}
let Qn = Symbol("ForcePortalRootContext");
function ta() {
  return ge(Qn, !1);
}
let It = O({ name: "ForcePortalRoot", props: { as: { type: [Object, String], default: "template" }, force: { type: Boolean, default: !1 } }, setup(e, { slots: n, attrs: t }) {
  return we(Qn, e.force), () => {
    let { force: r, ...l } = e;
    return oe({ theirProps: l, ourProps: {}, slot: {}, slots: n, attrs: t, name: "ForcePortalRoot" });
  };
} }), Yn = Symbol("StackContext");
var Tt = ((e) => (e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(Tt || {});
function na() {
  return ge(Yn, () => {
  });
}
function la({ type: e, enabled: n, element: t, onUpdate: r }) {
  let l = na();
  function o(...s) {
    r == null || r(...s), l(...s);
  }
  re(() => {
    te(n, (s, a) => {
      s ? o(0, e, t) : a === !0 && o(1, e, t);
    }, { immediate: !0, flush: "sync" });
  }), he(() => {
    n.value && o(1, e, t);
  }), we(Yn, o);
}
let Xn = Symbol("DescriptionContext");
function ra() {
  let e = ge(Xn, null);
  if (e === null)
    throw new Error("Missing parent");
  return e;
}
function oa({ slot: e = _({}), name: n = "Description", props: t = {} } = {}) {
  let r = _([]);
  function l(o) {
    return r.value.push(o), () => {
      let s = r.value.indexOf(o);
      s !== -1 && r.value.splice(s, 1);
    };
  }
  return we(Xn, { register: l, slot: e, name: n, props: t }), y(() => r.value.length > 0 ? r.value.join(" ") : void 0);
}
let vd = O({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: null } }, setup(e, { attrs: n, slots: t }) {
  var r;
  let l = (r = e.id) != null ? r : `headlessui-description-${be()}`, o = ra();
  return re(() => he(o.register(l))), () => {
    let { name: s = "Description", slot: a = _({}), props: i = {} } = o, { ...p } = e, d = { ...Object.entries(i).reduce((v, [f, h]) => Object.assign(v, { [f]: $(h) }), {}), id: l };
    return oe({ ourProps: d, theirProps: p, slot: a.value, attrs: n, slots: t, name: s });
  };
} });
function aa(e) {
  let n = Te(e);
  if (!n) {
    if (e === null)
      return null;
    throw new Error(`[Headless UI]: Cannot find ownerDocument for contextElement: ${e}`);
  }
  let t = n.getElementById("headlessui-portal-root");
  if (t)
    return t;
  let r = n.createElement("div");
  return r.setAttribute("id", "headlessui-portal-root"), n.body.appendChild(r);
}
const Pt = /* @__PURE__ */ new WeakMap();
function sa(e) {
  var n;
  return (n = Pt.get(e)) != null ? n : 0;
}
function dn(e, n) {
  let t = n(sa(e));
  return t <= 0 ? Pt.delete(e) : Pt.set(e, t), t;
}
let Jn = O({ name: "Portal", props: { as: { type: [Object, String], default: "div" } }, setup(e, { slots: n, attrs: t }) {
  let r = _(null), l = y(() => Te(r)), o = ta(), s = ge(el, null), a = _(o === !0 || s == null ? aa(r.value) : s.resolveTarget());
  a.value && dn(a.value, (f) => f + 1);
  let i = _(!1);
  re(() => {
    i.value = !0;
  }), pe(() => {
    o || s != null && (a.value = s.resolveTarget());
  });
  let p = ge(Bt, null), d = !1, v = Sn();
  return te(r, () => {
    if (d || !p)
      return;
    let f = P(r);
    f && (he(p.register(f), v), d = !0);
  }), he(() => {
    var f, h;
    let g = (f = l.value) == null ? void 0 : f.getElementById("headlessui-portal-root");
    !g || a.value !== g || dn(a.value, (w) => w - 1) || a.value.children.length > 0 || (h = a.value.parentElement) == null || h.removeChild(a.value);
  }), () => {
    if (!i.value || a.value === null)
      return null;
    let f = { ref: r, "data-headlessui-portal": "" };
    return se(kn, { to: a.value }, oe({ ourProps: f, theirProps: e, slot: {}, attrs: t, slots: n, name: "Portal" }));
  };
} }), Bt = Symbol("PortalParentContext");
function ia() {
  let e = ge(Bt, null), n = _([]);
  function t(o) {
    return n.value.push(o), e && e.register(o), () => r(o);
  }
  function r(o) {
    let s = n.value.indexOf(o);
    s !== -1 && n.value.splice(s, 1), e && e.unregister(o);
  }
  let l = { register: t, unregister: r, portals: n };
  return [n, O({ name: "PortalWrapper", setup(o, { slots: s }) {
    return we(Bt, l), () => {
      var a;
      return (a = s.default) == null ? void 0 : a.call(s);
    };
  } })];
}
let el = Symbol("PortalGroupContext"), ua = O({ name: "PortalGroup", props: { as: { type: [Object, String], default: "template" }, target: { type: Object, default: null } }, setup(e, { attrs: n, slots: t }) {
  let r = $n({ resolveTarget() {
    return e.target;
  } });
  return we(el, r), () => {
    let { target: l, ...o } = e;
    return oe({ theirProps: o, ourProps: {}, slot: {}, attrs: n, slots: t, name: "PortalGroup" });
  };
} });
var da = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(da || {});
let Rt = Symbol("DialogContext");
function lt(e) {
  let n = ge(Rt, null);
  if (n === null) {
    let t = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, lt), t;
  }
  return n;
}
let st = "DC8F892D-2EBD-447C-A4C8-A03058436FF4", tl = O({ name: "Dialog", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, open: { type: [Boolean, String], default: st }, initialFocus: { type: Object, default: null }, id: { type: String, default: null }, role: { type: String, default: "dialog" } }, emits: { close: (e) => !0 }, setup(e, { emit: n, attrs: t, slots: r, expose: l }) {
  var o, s;
  let a = (o = e.id) != null ? o : `headlessui-dialog-${be()}`, i = _(!1);
  re(() => {
    i.value = !0;
  });
  let p = !1, d = y(() => e.role === "dialog" || e.role === "alertdialog" ? e.role : (p || (p = !0, console.warn(`Invalid role [${d}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog")), v = _(0), f = nt(), h = y(() => e.open === st && f !== null ? (f.value & ie.Open) === ie.Open : e.open), g = _(null), w = y(() => Te(g));
  if (l({ el: g, $el: g }), !(e.open !== st || f !== null))
    throw new Error("You forgot to provide an `open` prop to the `Dialog`.");
  if (typeof h.value != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${h.value === st ? void 0 : e.open}`);
  let T = y(() => i.value && h.value ? 0 : 1), N = y(() => T.value === 0), B = y(() => v.value > 1), j = ge(Rt, null) !== null, [ue, A] = ia(), { resolveContainers: Z, mainTreeNodeRef: Y, MainTreeNode: E } = ea({ portals: ue, defaultContainers: [y(() => {
    var I;
    return (I = ve.panelRef.value) != null ? I : g.value;
  })] }), G = y(() => B.value ? "parent" : "leaf"), S = y(() => f !== null ? (f.value & ie.Closing) === ie.Closing : !1), R = y(() => j || S.value ? !1 : N.value), U = y(() => {
    var I, X, xe;
    return (xe = Array.from((X = (I = w.value) == null ? void 0 : I.querySelectorAll("body > *")) != null ? X : []).find((_e) => _e.id === "headlessui-portal-root" ? !1 : _e.contains(P(Y)) && _e instanceof HTMLElement)) != null ? xe : null;
  });
  un(U, R);
  let z = y(() => B.value ? !0 : N.value), Q = y(() => {
    var I, X, xe;
    return (xe = Array.from((X = (I = w.value) == null ? void 0 : I.querySelectorAll("[data-headlessui-portal]")) != null ? X : []).find((_e) => _e.contains(P(Y)) && _e instanceof HTMLElement)) != null ? xe : null;
  });
  un(Q, z), la({ type: "Dialog", enabled: y(() => T.value === 0), element: g, onUpdate: (I, X) => {
    if (X === "Dialog")
      return fe(I, { [Tt.Add]: () => v.value += 1, [Tt.Remove]: () => v.value -= 1 });
  } });
  let q = oa({ name: "DialogDescription", slot: y(() => ({ open: h.value })) }), ae = _(null), ve = { titleId: ae, panelRef: _(null), dialogState: T, setTitleId(I) {
    ae.value !== I && (ae.value = I);
  }, close() {
    n("close", !1);
  } };
  we(Rt, ve);
  let b = y(() => !(!N.value || B.value));
  Ht(Z, (I, X) => {
    I.preventDefault(), ve.close(), me(() => X == null ? void 0 : X.focus());
  }, b);
  let C = y(() => !(B.value || T.value !== 0));
  Kn((s = w.value) == null ? void 0 : s.defaultView, "keydown", (I) => {
    C.value && (I.defaultPrevented || I.key === J.Escape && (I.preventDefault(), I.stopPropagation(), ve.close()));
  });
  let x = y(() => !(S.value || T.value !== 0 || j));
  return Jo(w, x, (I) => {
    var X;
    return { containers: [...(X = I.containers) != null ? X : [], Z] };
  }), pe((I) => {
    if (T.value !== 0)
      return;
    let X = P(g);
    if (!X)
      return;
    let xe = new ResizeObserver((_e) => {
      for (let ht of _e) {
        let ot = ht.target.getBoundingClientRect();
        ot.x === 0 && ot.y === 0 && ot.width === 0 && ot.height === 0 && ve.close();
      }
    });
    xe.observe(X), I(() => xe.disconnect());
  }), () => {
    let { open: I, initialFocus: X, ...xe } = e, _e = { ...t, ref: g, id: a, role: d.value, "aria-modal": T.value === 0 ? !0 : void 0, "aria-labelledby": ae.value, "aria-describedby": q.value }, ht = { open: T.value === 0 };
    return se(It, { force: !0 }, () => [se(Jn, () => se(ua, { target: g.value }, () => se(It, { force: !1 }, () => se(We, { initialFocus: X, containers: Z, features: N.value ? fe(G.value, { parent: We.features.RestoreFocus, leaf: We.features.All & ~We.features.FocusLock }) : We.features.None }, () => se(A, {}, () => oe({ ourProps: _e, theirProps: { ...xe, ...t }, slot: ht, attrs: t, slots: r, visible: T.value === 0, features: Ce.RenderStrategy | Ce.Static, name: "Dialog" })))))), se(E)]);
  };
} }), ca = O({ name: "DialogOverlay", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(e, { attrs: n, slots: t }) {
  var r;
  let l = (r = e.id) != null ? r : `headlessui-dialog-overlay-${be()}`, o = lt("DialogOverlay");
  function s(a) {
    a.target === a.currentTarget && (a.preventDefault(), a.stopPropagation(), o.close());
  }
  return () => {
    let { ...a } = e;
    return oe({ ourProps: { id: l, "aria-hidden": !0, onClick: s }, theirProps: a, slot: { open: o.dialogState.value === 0 }, attrs: n, slots: t, name: "DialogOverlay" });
  };
} });
O({ name: "DialogBackdrop", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { attrs: n, slots: t, expose: r }) {
  var l;
  let o = (l = e.id) != null ? l : `headlessui-dialog-backdrop-${be()}`, s = lt("DialogBackdrop"), a = _(null);
  return r({ el: a, $el: a }), re(() => {
    if (s.panelRef.value === null)
      throw new Error("A <DialogBackdrop /> component is being used, but a <DialogPanel /> component is missing.");
  }), () => {
    let { ...i } = e, p = { id: o, ref: a, "aria-hidden": !0 };
    return se(It, { force: !0 }, () => se(Jn, () => oe({ ourProps: p, theirProps: { ...n, ...i }, slot: { open: s.dialogState.value === 0 }, attrs: n, slots: t, name: "DialogBackdrop" })));
  };
} });
let pa = O({ name: "DialogPanel", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(e, { attrs: n, slots: t, expose: r }) {
  var l;
  let o = (l = e.id) != null ? l : `headlessui-dialog-panel-${be()}`, s = lt("DialogPanel");
  r({ el: s.panelRef, $el: s.panelRef });
  function a(i) {
    i.stopPropagation();
  }
  return () => {
    let { ...i } = e, p = { id: o, ref: s.panelRef, onClick: a };
    return oe({ ourProps: p, theirProps: i, slot: { open: s.dialogState.value === 0 }, attrs: n, slots: t, name: "DialogPanel" });
  };
} });
O({ name: "DialogTitle", props: { as: { type: [Object, String], default: "h2" }, id: { type: String, default: null } }, setup(e, { attrs: n, slots: t }) {
  var r;
  let l = (r = e.id) != null ? r : `headlessui-dialog-title-${be()}`, o = lt("DialogTitle");
  return re(() => {
    o.setTitleId(l), he(() => o.setTitleId(null));
  }), () => {
    let { ...s } = e;
    return oe({ ourProps: { id: l }, theirProps: s, slot: { open: o.dialogState.value === 0 }, attrs: n, slots: t, name: "DialogTitle" });
  };
} });
let cn = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function pn(e) {
  var n, t;
  let r = (n = e.innerText) != null ? n : "", l = e.cloneNode(!0);
  if (!(l instanceof HTMLElement))
    return r;
  let o = !1;
  for (let a of l.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))
    a.remove(), o = !0;
  let s = o ? (t = l.innerText) != null ? t : "" : r;
  return cn.test(s) && (s = s.replace(cn, "")), s;
}
function fa(e) {
  let n = e.getAttribute("aria-label");
  if (typeof n == "string")
    return n.trim();
  let t = e.getAttribute("aria-labelledby");
  if (t) {
    let r = t.split(" ").map((l) => {
      let o = document.getElementById(l);
      if (o) {
        let s = o.getAttribute("aria-label");
        return typeof s == "string" ? s.trim() : pn(o).trim();
      }
      return null;
    }).filter(Boolean);
    if (r.length > 0)
      return r.join(", ");
  }
  return pn(e).trim();
}
function va(e) {
  let n = _(""), t = _("");
  return () => {
    let r = P(e);
    if (!r)
      return "";
    let l = r.innerText;
    if (n.value === l)
      return t.value;
    let o = fa(r).trim().toLowerCase();
    return n.value = l, t.value = o, o;
  };
}
var ma = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(ma || {}), ha = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(ha || {});
function ga(e) {
  requestAnimationFrame(() => requestAnimationFrame(e));
}
let nl = Symbol("MenuContext");
function ft(e) {
  let n = ge(nl, null);
  if (n === null) {
    let t = new Error(`<${e} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, ft), t;
  }
  return n;
}
let ba = O({ name: "Menu", props: { as: { type: [Object, String], default: "template" } }, setup(e, { slots: n, attrs: t }) {
  let r = _(1), l = _(null), o = _(null), s = _([]), a = _(""), i = _(null), p = _(1);
  function d(f = (h) => h) {
    let h = i.value !== null ? s.value[i.value] : null, g = Ut(f(s.value.slice()), (T) => P(T.dataRef.domRef)), w = h ? g.indexOf(h) : null;
    return w === -1 && (w = null), { items: g, activeItemIndex: w };
  }
  let v = { menuState: r, buttonRef: l, itemsRef: o, items: s, searchQuery: a, activeItemIndex: i, activationTrigger: p, closeMenu: () => {
    r.value = 1, i.value = null;
  }, openMenu: () => r.value = 0, goToItem(f, h, g) {
    let w = d(), T = Ct(f === ee.Specific ? { focus: ee.Specific, id: h } : { focus: f }, { resolveItems: () => w.items, resolveActiveIndex: () => w.activeItemIndex, resolveId: (N) => N.id, resolveDisabled: (N) => N.dataRef.disabled });
    a.value = "", i.value = T, p.value = g != null ? g : 1, s.value = w.items;
  }, search(f) {
    let h = a.value !== "" ? 0 : 1;
    a.value += f.toLowerCase();
    let g = (i.value !== null ? s.value.slice(i.value + h).concat(s.value.slice(0, i.value + h)) : s.value).find((T) => T.dataRef.textValue.startsWith(a.value) && !T.dataRef.disabled), w = g ? s.value.indexOf(g) : -1;
    w === -1 || w === i.value || (i.value = w, p.value = 1);
  }, clearSearch() {
    a.value = "";
  }, registerItem(f, h) {
    let g = d((w) => [...w, { id: f, dataRef: h }]);
    s.value = g.items, i.value = g.activeItemIndex, p.value = 1;
  }, unregisterItem(f) {
    let h = d((g) => {
      let w = g.findIndex((T) => T.id === f);
      return w !== -1 && g.splice(w, 1), g;
    });
    s.value = h.items, i.value = h.activeItemIndex, p.value = 1;
  } };
  return Ht([l, o], (f, h) => {
    var g;
    v.closeMenu(), zt(h, jt.Loose) || (f.preventDefault(), (g = P(l)) == null || g.focus());
  }, y(() => r.value === 0)), we(nl, v), Wt(y(() => fe(r.value, { [0]: ie.Open, [1]: ie.Closed }))), () => {
    let f = { open: r.value === 0, close: v.closeMenu };
    return oe({ ourProps: {}, theirProps: e, slot: f, slots: n, attrs: t, name: "Menu" });
  };
} }), ya = O({ name: "MenuButton", props: { disabled: { type: Boolean, default: !1 }, as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(e, { attrs: n, slots: t, expose: r }) {
  var l;
  let o = (l = e.id) != null ? l : `headlessui-menu-button-${be()}`, s = ft("MenuButton");
  r({ el: s.buttonRef, $el: s.buttonRef });
  function a(v) {
    switch (v.key) {
      case J.Space:
      case J.Enter:
      case J.ArrowDown:
        v.preventDefault(), v.stopPropagation(), s.openMenu(), me(() => {
          var f;
          (f = P(s.itemsRef)) == null || f.focus({ preventScroll: !0 }), s.goToItem(ee.First);
        });
        break;
      case J.ArrowUp:
        v.preventDefault(), v.stopPropagation(), s.openMenu(), me(() => {
          var f;
          (f = P(s.itemsRef)) == null || f.focus({ preventScroll: !0 }), s.goToItem(ee.Last);
        });
        break;
    }
  }
  function i(v) {
    switch (v.key) {
      case J.Space:
        v.preventDefault();
        break;
    }
  }
  function p(v) {
    e.disabled || (s.menuState.value === 0 ? (s.closeMenu(), me(() => {
      var f;
      return (f = P(s.buttonRef)) == null ? void 0 : f.focus({ preventScroll: !0 });
    })) : (v.preventDefault(), s.openMenu(), ga(() => {
      var f;
      return (f = P(s.itemsRef)) == null ? void 0 : f.focus({ preventScroll: !0 });
    })));
  }
  let d = Mn(y(() => ({ as: e.as, type: n.type })), s.buttonRef);
  return () => {
    var v;
    let f = { open: s.menuState.value === 0 }, { ...h } = e, g = { ref: s.buttonRef, id: o, type: d.value, "aria-haspopup": "menu", "aria-controls": (v = P(s.itemsRef)) == null ? void 0 : v.id, "aria-expanded": s.menuState.value === 0, onKeydown: a, onKeyup: i, onClick: p };
    return oe({ ourProps: g, theirProps: h, slot: f, attrs: n, slots: t, name: "MenuButton" });
  };
} }), wa = O({ name: "MenuItems", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(e, { attrs: n, slots: t, expose: r }) {
  var l;
  let o = (l = e.id) != null ? l : `headlessui-menu-items-${be()}`, s = ft("MenuItems"), a = _(null);
  r({ el: s.itemsRef, $el: s.itemsRef }), Vn({ container: y(() => P(s.itemsRef)), enabled: y(() => s.menuState.value === 0), accept(f) {
    return f.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : f.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(f) {
    f.setAttribute("role", "none");
  } });
  function i(f) {
    var h;
    switch (a.value && clearTimeout(a.value), f.key) {
      case J.Space:
        if (s.searchQuery.value !== "")
          return f.preventDefault(), f.stopPropagation(), s.search(f.key);
      case J.Enter:
        if (f.preventDefault(), f.stopPropagation(), s.activeItemIndex.value !== null) {
          let g = s.items.value[s.activeItemIndex.value];
          (h = P(g.dataRef.domRef)) == null || h.click();
        }
        s.closeMenu(), Tn(P(s.buttonRef));
        break;
      case J.ArrowDown:
        return f.preventDefault(), f.stopPropagation(), s.goToItem(ee.Next);
      case J.ArrowUp:
        return f.preventDefault(), f.stopPropagation(), s.goToItem(ee.Previous);
      case J.Home:
      case J.PageUp:
        return f.preventDefault(), f.stopPropagation(), s.goToItem(ee.First);
      case J.End:
      case J.PageDown:
        return f.preventDefault(), f.stopPropagation(), s.goToItem(ee.Last);
      case J.Escape:
        f.preventDefault(), f.stopPropagation(), s.closeMenu(), me(() => {
          var g;
          return (g = P(s.buttonRef)) == null ? void 0 : g.focus({ preventScroll: !0 });
        });
        break;
      case J.Tab:
        f.preventDefault(), f.stopPropagation(), s.closeMenu(), me(() => ko(P(s.buttonRef), f.shiftKey ? Ee.Previous : Ee.Next));
        break;
      default:
        f.key.length === 1 && (s.search(f.key), a.value = setTimeout(() => s.clearSearch(), 350));
        break;
    }
  }
  function p(f) {
    switch (f.key) {
      case J.Space:
        f.preventDefault();
        break;
    }
  }
  let d = nt(), v = y(() => d !== null ? (d.value & ie.Open) === ie.Open : s.menuState.value === 0);
  return () => {
    var f, h;
    let g = { open: s.menuState.value === 0 }, { ...w } = e, T = { "aria-activedescendant": s.activeItemIndex.value === null || (f = s.items.value[s.activeItemIndex.value]) == null ? void 0 : f.id, "aria-labelledby": (h = P(s.buttonRef)) == null ? void 0 : h.id, id: o, onKeydown: i, onKeyup: p, role: "menu", tabIndex: 0, ref: s.itemsRef };
    return oe({ ourProps: T, theirProps: w, slot: g, attrs: n, slots: t, features: Ce.RenderStrategy | Ce.Static, visible: v.value, name: "MenuItems" });
  };
} }), xa = O({ name: "MenuItem", inheritAttrs: !1, props: { as: { type: [Object, String], default: "template" }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(e, { slots: n, attrs: t, expose: r }) {
  var l;
  let o = (l = e.id) != null ? l : `headlessui-menu-item-${be()}`, s = ft("MenuItem"), a = _(null);
  r({ el: a, $el: a });
  let i = y(() => s.activeItemIndex.value !== null ? s.items.value[s.activeItemIndex.value].id === o : !1), p = va(a), d = y(() => ({ disabled: e.disabled, get textValue() {
    return p();
  }, domRef: a }));
  re(() => s.registerItem(o, d)), he(() => s.unregisterItem(o)), pe(() => {
    s.menuState.value === 0 && i.value && s.activationTrigger.value !== 0 && me(() => {
      var N, B;
      return (B = (N = P(a)) == null ? void 0 : N.scrollIntoView) == null ? void 0 : B.call(N, { block: "nearest" });
    });
  });
  function v(N) {
    if (e.disabled)
      return N.preventDefault();
    s.closeMenu(), Tn(P(s.buttonRef));
  }
  function f() {
    if (e.disabled)
      return s.goToItem(ee.Nothing);
    s.goToItem(ee.Specific, o);
  }
  let h = An();
  function g(N) {
    h.update(N);
  }
  function w(N) {
    h.wasMoved(N) && (e.disabled || i.value || s.goToItem(ee.Specific, o, 0));
  }
  function T(N) {
    h.wasMoved(N) && (e.disabled || i.value && s.goToItem(ee.Nothing));
  }
  return () => {
    let { disabled: N, ...B } = e, j = { active: i.value, disabled: N, close: s.closeMenu };
    return oe({ ourProps: { id: o, ref: a, role: "menuitem", tabIndex: N === !0 ? void 0 : -1, "aria-disabled": N === !0 ? !0 : void 0, onClick: v, onFocus: f, onPointerenter: g, onMouseenter: g, onPointermove: w, onMousemove: w, onPointerleave: T, onMouseleave: T }, theirProps: { ...t, ...B }, slot: j, attrs: t, slots: n, name: "MenuItem" });
  };
} });
function _a(e) {
  let n = { called: !1 };
  return (...t) => {
    if (!n.called)
      return n.called = !0, e(...t);
  };
}
function xt(e, ...n) {
  e && n.length > 0 && e.classList.add(...n);
}
function it(e, ...n) {
  e && n.length > 0 && e.classList.remove(...n);
}
var Mt = ((e) => (e.Finished = "finished", e.Cancelled = "cancelled", e))(Mt || {});
function $a(e, n) {
  let t = Re();
  if (!e)
    return t.dispose;
  let { transitionDuration: r, transitionDelay: l } = getComputedStyle(e), [o, s] = [r, l].map((a) => {
    let [i = 0] = a.split(",").filter(Boolean).map((p) => p.includes("ms") ? parseFloat(p) : parseFloat(p) * 1e3).sort((p, d) => d - p);
    return i;
  });
  return o !== 0 ? t.setTimeout(() => n("finished"), o + s) : n("finished"), t.add(() => n("cancelled")), t.dispose;
}
function fn(e, n, t, r, l, o) {
  let s = Re(), a = o !== void 0 ? _a(o) : () => {
  };
  return it(e, ...l), xt(e, ...n, ...t), s.nextFrame(() => {
    it(e, ...t), xt(e, ...r), s.add($a(e, (i) => (it(e, ...r, ...n), xt(e, ...l), a(i))));
  }), s.add(() => it(e, ...n, ...t, ...r, ...l)), s.add(() => a("cancelled")), s.dispose;
}
function Me(e = "") {
  return e.split(/\s+/).filter((n) => n.length > 1);
}
let Kt = Symbol("TransitionContext");
var Sa = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))(Sa || {});
function ka() {
  return ge(Kt, null) !== null;
}
function Oa() {
  let e = ge(Kt, null);
  if (e === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
function Ea() {
  let e = ge(Zt, null);
  if (e === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
let Zt = Symbol("NestingContext");
function vt(e) {
  return "children" in e ? vt(e.children) : e.value.filter(({ state: n }) => n === "visible").length > 0;
}
function ll(e) {
  let n = _([]), t = _(!1);
  re(() => t.value = !0), he(() => t.value = !1);
  function r(o, s = Pe.Hidden) {
    let a = n.value.findIndex(({ id: i }) => i === o);
    a !== -1 && (fe(s, { [Pe.Unmount]() {
      n.value.splice(a, 1);
    }, [Pe.Hidden]() {
      n.value[a].state = "hidden";
    } }), !vt(n) && t.value && (e == null || e()));
  }
  function l(o) {
    let s = n.value.find(({ id: a }) => a === o);
    return s ? s.state !== "visible" && (s.state = "visible") : n.value.push({ id: o, state: "visible" }), () => r(o, Pe.Unmount);
  }
  return { children: n, register: l, unregister: r };
}
let rl = Ce.RenderStrategy, Xe = O({ props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: n, attrs: t, slots: r, expose: l }) {
  let o = _(0);
  function s() {
    o.value |= ie.Opening, n("beforeEnter");
  }
  function a() {
    o.value &= ~ie.Opening, n("afterEnter");
  }
  function i() {
    o.value |= ie.Closing, n("beforeLeave");
  }
  function p() {
    o.value &= ~ie.Closing, n("afterLeave");
  }
  if (!ka() && Io())
    return () => se(qt, { ...e, onBeforeEnter: s, onAfterEnter: a, onBeforeLeave: i, onAfterLeave: p }, r);
  let d = _(null), v = y(() => e.unmount ? Pe.Unmount : Pe.Hidden);
  l({ el: d, $el: d });
  let { show: f, appear: h } = Oa(), { register: g, unregister: w } = Ea(), T = _(f.value ? "visible" : "hidden"), N = { value: !0 }, B = be(), j = { value: !1 }, ue = ll(() => {
    !j.value && T.value !== "hidden" && (T.value = "hidden", w(B), p());
  });
  re(() => {
    let z = g(B);
    he(z);
  }), pe(() => {
    if (v.value === Pe.Hidden && B) {
      if (f.value && T.value !== "visible") {
        T.value = "visible";
        return;
      }
      fe(T.value, { hidden: () => w(B), visible: () => g(B) });
    }
  });
  let A = Me(e.enter), Z = Me(e.enterFrom), Y = Me(e.enterTo), E = Me(e.entered), G = Me(e.leave), S = Me(e.leaveFrom), R = Me(e.leaveTo);
  re(() => {
    pe(() => {
      if (T.value === "visible") {
        let z = P(d);
        if (z instanceof Comment && z.data === "")
          throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
      }
    });
  });
  function U(z) {
    let Q = N.value && !h.value, q = P(d);
    !q || !(q instanceof HTMLElement) || Q || (j.value = !0, f.value && s(), f.value || i(), z(f.value ? fn(q, A, Z, Y, E, (ae) => {
      j.value = !1, ae === Mt.Finished && a();
    }) : fn(q, G, S, R, E, (ae) => {
      j.value = !1, ae === Mt.Finished && (vt(ue) || (T.value = "hidden", w(B), p()));
    })));
  }
  return re(() => {
    te([f], (z, Q, q) => {
      U(q), N.value = !1;
    }, { immediate: !0 });
  }), we(Zt, ue), Wt(y(() => fe(T.value, { visible: ie.Open, hidden: ie.Closed }) | o.value)), () => {
    let { appear: z, show: Q, enter: q, enterFrom: ae, enterTo: ve, entered: b, leave: C, leaveFrom: x, leaveTo: I, ...X } = e, xe = { ref: d }, _e = { ...X, ...h.value && f.value && et.isServer ? { class: W([t.class, X.class, ...A, ...Z]) } : {} };
    return oe({ theirProps: _e, ourProps: xe, slot: {}, slots: r, attrs: t, features: rl, visible: T.value === "visible", name: "TransitionChild" });
  };
} }), Ca = Xe, qt = O({ inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: n, attrs: t, slots: r }) {
  let l = nt(), o = y(() => e.show === null && l !== null ? (l.value & ie.Open) === ie.Open : e.show);
  pe(() => {
    if (![!0, !1].includes(o.value))
      throw new Error('A <Transition /> is used but it is missing a `:show="true | false"` prop.');
  });
  let s = _(o.value ? "visible" : "hidden"), a = ll(() => {
    s.value = "hidden";
  }), i = _(!0), p = { show: o, appear: y(() => e.appear || !i.value) };
  return re(() => {
    pe(() => {
      i.value = !1, o.value ? s.value = "visible" : vt(a) || (s.value = "hidden");
    });
  }), we(Zt, a), we(Kt, p), () => {
    let d = tt(e, ["show", "appear", "unmount", "onBeforeEnter", "onBeforeLeave", "onAfterEnter", "onAfterLeave"]), v = { unmount: e.unmount };
    return oe({ ourProps: { ...v, as: "template" }, theirProps: {}, slot: {}, slots: { ...r, default: () => [se(Ca, { onBeforeEnter: () => n("beforeEnter"), onAfterEnter: () => n("afterEnter"), onBeforeLeave: () => n("beforeLeave"), onAfterLeave: () => n("afterLeave"), ...t, ...v, ...d }, r.default)] }, attrs: {}, features: rl, visible: s.value === "visible", name: "Transition" });
  };
} });
var vn;
const rt = typeof window < "u", Ia = (e) => typeof e == "string", Ta = () => {
};
rt && ((vn = window == null ? void 0 : window.navigator) == null ? void 0 : vn.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function ol(e) {
  return typeof e == "function" ? e() : $(e);
}
function Pa(e) {
  return e;
}
function al(e) {
  return ml() ? (xn(e), !0) : !1;
}
function sl(e, n = !0) {
  Sn() ? re(e) : n ? e() : me(e);
}
function pt(e) {
  var n;
  const t = ol(e);
  return (n = t == null ? void 0 : t.$el) != null ? n : t;
}
const il = rt ? window : void 0;
rt && window.document;
rt && window.navigator;
rt && window.location;
function mn(...e) {
  let n, t, r, l;
  if (Ia(e[0]) || Array.isArray(e[0]) ? ([t, r, l] = e, n = il) : [n, t, r, l] = e, !n)
    return Ta;
  Array.isArray(t) || (t = [t]), Array.isArray(r) || (r = [r]);
  const o = [], s = () => {
    o.forEach((d) => d()), o.length = 0;
  }, a = (d, v, f, h) => (d.addEventListener(v, f, h), () => d.removeEventListener(v, f, h)), i = te(() => [pt(n), ol(l)], ([d, v]) => {
    s(), d && o.push(...t.flatMap((f) => r.map((h) => a(d, f, h, v))));
  }, { immediate: !0, flush: "post" }), p = () => {
    i(), s();
  };
  return al(p), p;
}
function Ba(e, n = !1) {
  const t = _(), r = () => t.value = Boolean(e());
  return r(), sl(r, n), t;
}
const At = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Vt = "__vueuse_ssr_handlers__";
At[Vt] = At[Vt] || {};
At[Vt];
var hn = Object.getOwnPropertySymbols, Ra = Object.prototype.hasOwnProperty, Ma = Object.prototype.propertyIsEnumerable, Aa = (e, n) => {
  var t = {};
  for (var r in e)
    Ra.call(e, r) && n.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && hn)
    for (var r of hn(e))
      n.indexOf(r) < 0 && Ma.call(e, r) && (t[r] = e[r]);
  return t;
};
function Va(e, n, t = {}) {
  const r = t, { window: l = il } = r, o = Aa(r, ["window"]);
  let s;
  const a = Ba(() => l && "ResizeObserver" in l), i = () => {
    s && (s.disconnect(), s = void 0);
  }, p = te(() => pt(e), (v) => {
    i(), a.value && l && v && (s = new ResizeObserver(n), s.observe(v, o));
  }, { immediate: !0, flush: "post" }), d = () => {
    i(), p();
  };
  return al(d), {
    isSupported: a,
    stop: d
  };
}
function Da(e, n = {}) {
  const {
    reset: t = !0,
    windowResize: r = !0,
    windowScroll: l = !0,
    immediate: o = !0
  } = n, s = _(0), a = _(0), i = _(0), p = _(0), d = _(0), v = _(0), f = _(0), h = _(0);
  function g() {
    const w = pt(e);
    if (!w) {
      t && (s.value = 0, a.value = 0, i.value = 0, p.value = 0, d.value = 0, v.value = 0, f.value = 0, h.value = 0);
      return;
    }
    const T = w.getBoundingClientRect();
    s.value = T.height, a.value = T.bottom, i.value = T.left, p.value = T.right, d.value = T.top, v.value = T.width, f.value = T.x, h.value = T.y;
  }
  return Va(e, g), te(() => pt(e), (w) => !w && g()), l && mn("scroll", g, { capture: !0, passive: !0 }), r && mn("resize", g, { passive: !0 }), sl(() => {
    o && g();
  }), {
    height: s,
    bottom: a,
    left: i,
    right: p,
    top: d,
    width: v,
    x: f,
    y: h,
    update: g
  };
}
var gn;
(function(e) {
  e.UP = "UP", e.RIGHT = "RIGHT", e.DOWN = "DOWN", e.LEFT = "LEFT", e.NONE = "NONE";
})(gn || (gn = {}));
var Fa = Object.defineProperty, bn = Object.getOwnPropertySymbols, La = Object.prototype.hasOwnProperty, Na = Object.prototype.propertyIsEnumerable, yn = (e, n, t) => n in e ? Fa(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, ja = (e, n) => {
  for (var t in n || (n = {}))
    La.call(n, t) && yn(e, t, n[t]);
  if (bn)
    for (var t of bn(n))
      Na.call(n, t) && yn(e, t, n[t]);
  return e;
};
const za = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
ja({
  linear: Pa
}, za);
const Ua = { class: "py-1" }, Ha = { name: "Dropdown" }, Dt = /* @__PURE__ */ O({
  ...Ha,
  props: {
    textClasses: {},
    scrollHeight: { default: "max-h-auto" },
    zIndex: { default: "z-10" },
    position: { default: "top-right" }
  },
  setup(e) {
    const n = _(), t = _(), {
      left: r,
      top: l,
      height: o,
      x: s,
      y: a
    } = Da(t), i = _({ top: "0", left: "0" }), p = _(!1), d = _(!1), v = 224, f = () => {
      var w;
      const h = window.innerHeight, g = window.scrollY;
      if (d.value = r.value > document.body.clientWidth - v, p.value = l.value > h - o.value, i.value = {
        top: l.value + g + o.value + "px",
        left: r.value + "px"
      }, d.value) {
        i.value.top = l.value + g + o.value + "px";
        const T = r.value - v + ((w = n.value) == null ? void 0 : w.$el.clientWidth);
        i.value.left = (T > document.body.clientWidth - v ? document.body.clientWidth - v : T) + "px";
      }
      p.value && (i.value.top = l.value + g - o.value + "px");
    };
    return te(
      () => a.value,
      () => f()
    ), te(
      () => s.value,
      () => f()
    ), re(() => {
      f(), window.addEventListener("resize", f);
    }), he(() => {
      window.removeEventListener("resize", f);
    }), (h, g) => (c(), M($(ba), {
      ref_key: "menu",
      ref: t,
      as: "div",
      class: "relative"
    }, {
      default: k(() => [
        V($(ya), {
          ref_key: "menuButton",
          ref: n,
          class: W([
            "inline-flex w-full items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-gray-100",
            h.textClasses
          ])
        }, {
          default: k(() => [
            D(h.$slots, "text", {}, () => [
              g[0] || (g[0] = ne(" Options ")),
              V($(Lt), {
                class: "-mr-1 ml-2 h-5 w-5",
                "aria-hidden": "true"
              })
            ])
          ]),
          _: 3
        }, 8, ["class"]),
        (c(), M(kn, { to: "body" }, [
          V(Ft, {
            "enter-active-class": "transition ease-out duration-100",
            "enter-from-class": "transform opacity-0 scale-95",
            "enter-to-class": "transform opacity-100 scale-100",
            "leave-active-class": "transition ease-in duration-75",
            "leave-from-class": "transform opacity-100 scale-100",
            "leave-to-class": "transform opacity-0 scale-95"
          }, {
            default: k(() => [
              V($(wa), {
                style: hl(i.value),
                class: W(["absolute mt-2 w-56 divide-y divide-gray-100 overflow-y-auto rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none", [
                  h.zIndex,
                  {
                    "-translate-y-full": p.value
                  },
                  h.scrollHeight
                ]])
              }, {
                default: k(() => [
                  u("div", Ua, [
                    D(h.$slots, "default")
                  ])
                ]),
                _: 3
              }, 8, ["style", "class"])
            ]),
            _: 3
          })
        ]))
      ]),
      _: 3
    }, 512));
  }
}), Wa = ["onClick"], Ka = ["href"], Za = { name: "DropdownItem" }, ut = /* @__PURE__ */ O({
  ...Za,
  props: {
    href: {},
    external: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = (r) => {
      r(), n.href && !n.external && Ot.visit(n.href);
    };
    return (r, l) => (c(), M($(xa), null, {
      default: k(({ active: o, close: s }) => [
        u("div", null, [
          r.href ? r.href && r.external ? (c(), m("a", K({ key: 1 }, r.$attrs, {
            href: r.href,
            class: [
              o ? "bg-gray-100 text-gray-900" : "text-gray-700",
              "block cursor-pointer px-4 py-2 text-sm"
            ]
          }), [
            D(r.$slots, "default")
          ], 16, Ka)) : (c(), M($(ye), K({ key: 2 }, r.$attrs, {
            href: r.href,
            class: [
              o ? "bg-gray-100 text-gray-900" : "text-gray-700",
              "block cursor-pointer px-4 py-2 text-sm"
            ],
            onClick: De((a) => t(s), ["prevent"])
          }), {
            default: k(() => [
              D(r.$slots, "default")
            ]),
            _: 2
          }, 1040, ["href", "class", "onClick"])) : (c(), m("button", K({ key: 0 }, r.$attrs, {
            class: [
              o ? "bg-gray-100 text-gray-900" : "text-gray-700",
              "block w-full cursor-pointer px-4 py-2 text-left text-sm"
            ],
            onClick: De((a) => t(s), ["prevent"])
          }), [
            D(r.$slots, "default")
          ], 16, Wa))
        ])
      ]),
      _: 3
    }));
  }
}), qa = { class: "flex items-center justify-between border-t border-gray-200 px-4 py-3 sm:px-6" }, Ga = { class: "flex flex-1 justify-between md:hidden" }, Qa = { class: "hidden md:flex md:flex-1 md:items-center md:justify-between" }, Ya = { class: "text-sm text-gray-700" }, Xa = { class: "font-medium" }, Ja = { class: "font-medium" }, es = { class: "font-medium" }, ts = {
  class: "isolate inline-flex -space-x-px rounded-md shadow-sm",
  "aria-label": "Pagination"
}, ns = {
  key: 1,
  class: "relative inline-flex items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-300"
}, ls = {
  key: 1,
  class: "relative inline-flex items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700"
}, rs = {
  key: 3,
  class: "relative inline-flex items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-300"
}, os = /* @__PURE__ */ O({
  __name: "Pagination",
  props: {
    collection: {}
  },
  setup(e) {
    const t = e.collection.links;
    return t.shift(), t.pop(), (r, l) => (c(), m("div", qa, [
      u("div", Ga, [
        V($(ye), {
          href: r.collection.prev_page_url ? r.collection.prev_page_url : "#",
          rel: "prev",
          class: "relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
        }, {
          default: k(() => l[0] || (l[0] = [
            ne(" Previous ")
          ])),
          _: 1
        }, 8, ["href"]),
        V($(ye), {
          href: r.collection.next_page_url ? r.collection.next_page_url : "#",
          rel: "next",
          class: "relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
        }, {
          default: k(() => l[1] || (l[1] = [
            ne(" Next ")
          ])),
          _: 1
        }, 8, ["href"])
      ]),
      u("div", Qa, [
        u("div", null, [
          u("p", Ya, [
            l[2] || (l[2] = ne(" Showing " + F(" ") + " ")),
            u("span", Xa, F(r.collection.from), 1),
            l[3] || (l[3] = ne(" " + F(" ") + " to " + F(" ") + " ")),
            u("span", Ja, F(r.collection.to), 1),
            l[4] || (l[4] = ne(" " + F(" ") + " of " + F(" ") + " ")),
            u("span", es, F(r.collection.total), 1),
            l[5] || (l[5] = ne(" " + F(" ") + " results "))
          ])
        ]),
        u("div", null, [
          u("nav", ts, [
            r.collection.prev_page_url ? (c(), M($(ye), {
              key: 0,
              href: r.collection.prev_page_url ? r.collection.prev_page_url : "#",
              rel: "prev",
              class: "relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50"
            }, {
              default: k(() => [
                l[6] || (l[6] = u("span", { class: "sr-only" }, "Previous", -1)),
                V($(Jt), {
                  class: "h-5 w-5",
                  "aria-hidden": "true"
                })
              ]),
              _: 1
            }, 8, ["href"])) : (c(), m("span", ns, [
              l[7] || (l[7] = u("span", { class: "sr-only" }, "Previous", -1)),
              V($(Jt), {
                class: "h-5 w-5",
                "aria-hidden": "true"
              })
            ])),
            (c(!0), m(le, null, de(r.collection.links, (o) => (c(), m(le, {
              key: o.id
            }, [
              o.url ? (c(), M($(ye), {
                key: 0,
                href: o.url,
                "aria-current": o.active ? "page" : null,
                class: W(["relative inline-flex items-center border px-4 py-2", {
                  "border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50": !o.active,
                  "z-10 border-primary-500 bg-primary-50 text-primary-600": o.active
                }])
              }, {
                default: k(() => [
                  ne(F(o.label), 1)
                ]),
                _: 2
              }, 1032, ["href", "aria-current", "class"])) : r.collection.last_page > 1 ? (c(), m("span", ls, " ... ")) : L("", !0)
            ], 64))), 128)),
            r.collection.next_page_url ? (c(), M($(ye), {
              key: 2,
              href: r.collection.next_page_url ? r.collection.next_page_url : "#",
              rel: "next",
              class: "relative inline-flex items-center rounded-r-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50"
            }, {
              default: k(() => [
                l[8] || (l[8] = u("span", { class: "sr-only" }, "Next", -1)),
                V($(dt), {
                  class: "h-5 w-5",
                  "aria-hidden": "true"
                })
              ]),
              _: 1
            }, 8, ["href"])) : (c(), m("span", rs, [
              l[9] || (l[9] = u("span", { class: "sr-only" }, "Next", -1)),
              V($(dt), {
                class: "h-5 w-5",
                "aria-hidden": "true"
              })
            ]))
          ])
        ])
      ])
    ]));
  }
});
function ke(e, n) {
  return y({
    get: () => e.modelValue,
    set: (t) => n("update:modelValue", t)
  });
}
const as = {
  key: 0,
  class: "mt-1 text-sm text-red-400"
}, ss = { name: "Error" }, Gt = /* @__PURE__ */ O({
  ...ss,
  props: {
    error: {}
  },
  setup(e) {
    return (n, t) => n.error ? (c(), m("div", as, [
      D(n.$slots, "default", {}, () => [
        ne(F(n.error), 1)
      ])
    ])) : L("", !0);
  }
}), is = { class: "w-full" }, us = {
  key: 0,
  class: "mt-2 text-xs text-gray-500"
}, ds = {
  name: "Base",
  inheritAttrs: !1
}, Oe = /* @__PURE__ */ O({
  ...ds,
  props: {
    description: {},
    error: {},
    shadow: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (n, t) => (c(), m("div", is, [
      u("div", {
        class: W(["mt-1 w-full rounded-md", { "shadow-sm": n.shadow }])
      }, [
        D(n.$slots, "default")
      ], 2),
      n.description ? (c(), m("p", us, F(n.description), 1)) : L("", !0),
      n.error ? (c(), M(Gt, {
        key: 1,
        error: n.error
      }, null, 8, ["error"])) : L("", !0)
    ]));
  }
}), cs = ["id", "type", "placeholder", "disabled", "readonly"], ps = { name: "Text" }, mt = /* @__PURE__ */ O({
  ...ps,
  props: {
    id: {},
    placeholder: {},
    modelValue: {},
    description: {},
    error: {},
    type: { default: "text" },
    readonly: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const l = ke(e, n);
    return (o, s) => (c(), M(Oe, Ue(He(o.$props)), {
      default: k(() => [
        ce(u("input", K({
          id: o.id,
          "onUpdate:modelValue": s[0] || (s[0] = (a) => Se(l) ? l.value = a : null),
          type: o.type,
          placeholder: o.placeholder,
          class: ["mt-1 block w-full rounded-md border px-3 py-2 transition duration-150 ease-in-out focus:border-primary-300 focus:ring-primary-200/50 focus-visible:outline-none sm:text-sm", o.error ? "border-red-400" : "border-gray-300"],
          disabled: o.disabled,
          readonly: o.readonly
        }, o.$attrs), null, 16, cs), [
          [St, $(l)]
        ])
      ]),
      _: 1
    }, 16));
  }
}), fs = { name: "Date" }, vs = /* @__PURE__ */ O({
  ...fs,
  props: {
    id: {},
    modelValue: {},
    description: {},
    error: {},
    type: { default: "date" },
    readonly: { type: Boolean },
    disabled: { type: Boolean },
    min: {},
    max: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const l = ke(e, n);
    return (o, s) => (c(), M(mt, K({
      modelValue: $(l),
      "onUpdate:modelValue": s[0] || (s[0] = (a) => Se(l) ? l.value = a : null)
    }, { ...o.$props, ...o.$attrs }), null, 16, ["modelValue"]));
  }
}), ms = ["id", "disabled", "readonly"], hs = {
  key: 0,
  value: null
}, gs = ["value"], bs = { name: "Select" }, ys = /* @__PURE__ */ O({
  ...bs,
  props: {
    id: {},
    modelValue: {},
    description: {},
    error: {},
    options: {},
    blank: {},
    readonly: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const l = ke(e, n);
    return (o, s) => (c(), M(Oe, Ue(He(o.$props)), {
      default: k(() => [
        ce(u("select", K({
          id: o.id,
          "onUpdate:modelValue": s[0] || (s[0] = (a) => Se(l) ? l.value = a : null),
          class: ["form-select block w-full rounded-md border px-3 py-2 transition duration-150 ease-in-out focus:border-primary-300 focus:ring-primary-200/50 sm:text-sm", {
            "border-red-400": o.error,
            "border-gray-300": !o.error
          }],
          disabled: o.disabled,
          readonly: o.readonly
        }, o.$attrs), [
          o.blank ? (c(), m("option", hs, F(o.blank), 1)) : L("", !0),
          D(o.$slots, "default", {}, () => [
            (c(!0), m(le, null, de(o.options, (a) => (c(), m("option", {
              key: a.id,
              value: a.id
            }, F(a.name), 9, gs))), 128))
          ])
        ], 16, ms), [
          [gl, $(l)]
        ])
      ]),
      _: 3
    }, 16));
  }
}), ws = { class: "fixed inset-0 z-30 overflow-y-auto" }, xs = { class: "flex items-center justify-between" }, _s = /* @__PURE__ */ O({
  __name: "Modal",
  props: {
    open: { type: Boolean, default: !1 },
    background: { default: "bg-white" },
    autoWidth: { type: Boolean, default: !1 },
    fullscreen: { type: Boolean, default: !1 }
  },
  emits: ["close"],
  setup(e, { emit: n }) {
    const t = n;
    return (r, l) => (c(), M($(qt), {
      as: "template",
      show: r.open
    }, {
      default: k(() => [
        V($(tl), {
          as: "div",
          class: "relative z-30",
          onClose: l[1] || (l[1] = (o) => t("close"))
        }, {
          default: k(() => [
            V($(Xe), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: k(() => l[2] || (l[2] = [
                u("div", { class: "fixed inset-0 bg-gray-500/75 transition-opacity" }, null, -1)
              ])),
              _: 1
            }),
            u("div", ws, [
              u("div", {
                class: W(["flex min-h-full text-center sm:justify-center", {
                  "items-center p-4": !r.fullscreen,
                  "sm:items-center sm:justify-center sm:p-4": r.fullscreen
                }])
              }, [
                V($(Xe), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: k(() => [
                    V($(pa), {
                      class: W(["relative w-full space-y-4 overflow-hidden px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:p-6", {
                        "sm:w-fit sm:min-w-[32rem]": r.autoWidth,
                        [r.background]: r.background,
                        "sm:w-full sm:max-w-lg": !r.autoWidth,
                        "rounded-lg": !r.fullscreen,
                        "sm:rounded-lg": r.fullscreen
                      }])
                    }, {
                      default: k(() => [
                        u("div", xs, [
                          D(r.$slots, "header"),
                          V(ze, {
                            as: "button",
                            class: "!border-none !p-1",
                            onClick: l[0] || (l[0] = (o) => t("close"))
                          }, {
                            default: k(() => [
                              V($(Qe), {
                                class: "h-4 w-4 cursor-pointer text-gray-800",
                                "aria-hidden": "true"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        D(r.$slots, "default"),
                        D(r.$slots, "footer")
                      ]),
                      _: 3
                    }, 8, ["class"])
                  ]),
                  _: 3
                })
              ], 2)
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), ul = "en-AU", $s = "AUD", Ss = (e) => e.toLocaleString(ul), ks = (e, n = 2) => new Intl.NumberFormat(ul, {
  style: "currency",
  currencyDisplay: "symbol",
  currency: $s,
  minimumFractionDigits: n,
  maximumFractionDigits: n
}).format(Number(e)), Os = { class: "max-h-96 space-y-4 overflow-y-auto sm:max-h-[600px]" }, Es = { class: "font-bold text-gray-900" }, Cs = { class: "flex w-full items-center justify-between" }, Is = { class: "mr-1 capitalize" }, Ts = { class: "capitalize" }, Ps = {
  key: 1,
  class: "flex items-center"
}, Bs = ["onClick"], Rs = { class: "font-bold text-gray-900" }, Ms = { class: "flex justify-end space-x-2" }, As = {
  key: 0,
  class: "fixed bottom-0 left-0 z-10 w-full p-4 sm:bottom-10"
}, Vs = { class: "mx-auto flex w-fit items-center space-x-4 rounded-lg border border-gray-300 bg-white px-4 py-4 shadow-lg" }, Ds = { class: "whitespace-nowrap text-sm text-gray-400" }, Fs = { class: "flex" }, Ls = {
  key: 0,
  class: "ml-2 inline-flex h-5 w-5 items-center justify-center rounded-full bg-primary-500 text-xs font-semibold text-white"
}, Ns = {
  key: 1,
  class: "flex w-auto items-center gap-2"
}, js = { class: "flex flex-row gap-x-2" }, zs = { class: "mt-8 flex flex-col" }, Us = { class: "-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }, Hs = { class: "inline-block min-w-full py-2 align-middle md:px-6 lg:px-8" }, Ws = { class: "relative overflow-hidden shadow ring-1 ring-black/5 md:rounded-lg" }, Ks = { class: "min-w-full table-fixed divide-y divide-gray-300" }, Zs = { class: "bg-gray-50" }, qs = {
  key: 0,
  scope: "col",
  class: "relative w-12 px-6 sm:w-16 sm:px-8"
}, Gs = ["checked"], Qs = {
  key: 0,
  class: "flex items-center"
}, Ys = {
  key: 1,
  scope: "col",
  class: "relative w-4 py-3.5 pl-3 pr-4 sm:pr-6"
}, Xs = { class: "divide-y divide-gray-200 bg-white" }, Js = {
  key: 0,
  class: "relative w-12 px-6 sm:w-16 sm:px-8"
}, ei = {
  key: 0,
  class: "absolute inset-y-0 left-0 w-0.5 bg-primary-600"
}, ti = ["value"], ni = {
  key: 1,
  class: "whitespace-nowrap py-4 pl-3 pr-4 text-sm font-medium sm:pr-6"
}, li = ["onClick"], ri = { key: 2 }, oi = {
  key: 0,
  class: "bg-white"
}, ai = {
  key: 0,
  scope: "col",
  class: "relative w-12 px-6 sm:w-16 sm:px-8"
}, si = { key: 1 }, ii = {
  name: "DataTable"
}, md = /* @__PURE__ */ O({
  ...ii,
  props: {
    columns: {},
    items: {},
    collection: {},
    actions: { default: () => [] },
    bulkActions: { default: () => [] },
    filters: { default: () => [] },
    search: { default: "" },
    enableSearch: { type: Boolean, default: !1 },
    searchPlaceholder: { default: "Search" },
    customFilters: { default: () => [] },
    only: { default: () => [] }
  },
  emits: ["update:search"],
  setup(e, { emit: n }) {
    var ve;
    const t = e, r = n, l = new Proxy(new URLSearchParams(window.location.search), {
      get: (b, C) => b.get(C)
    }), o = (b, C) => {
      const x = new URL(t.collection.first_page_url), I = new URLSearchParams(x.search);
      return C !== null && C !== "" ? I.set(b, C) : I.delete(b), x.origin + x.pathname + "?" + decodeURIComponent(I.toString());
    }, s = (b) => t.actions.filter((C) => C.enabled ? C.enabled(b) : !0), a = y(() => t.collection ? t.collection.data : t.items), i = y(() => t.columns.map((b) => b.value)), p = y(() => t.columns.some((b) => b.summarise)), d = _([]), v = y(
      () => d.value.length > 0 && d.value.length < a.value.length
    ), f = (b) => {
      d.value = b.target.checked ? a.value.map((C) => C.id) : [];
    }, h = _((ve = t.bulkActions[0]) == null ? void 0 : ve.value), g = t.bulkActions.map((b) => ({
      id: b.value,
      name: b.text
    })), w = y({
      get: () => t.search,
      set: (b) => {
        r("update:search", b);
      }
    }), T = () => {
      Ot.get(o("filter[q]", w.value), {
        only: t.only
      });
    }, N = (b) => o("sort", b), B = _(!1), j = _({}), ue = y(() => {
      const b = new URL(window.location.href), C = new URLSearchParams(b.search);
      return Array.from(C.keys()).filter(
        (x) => x.startsWith("filter[") && (t.filters.some((I) => x.includes(I.key)) || t.customFilters.some((I) => x.includes(I.key)))
      ).length;
    }), A = (b) => {
      var x;
      const C = (x = b.options) == null ? void 0 : x.find((I) => I.value == j.value[b.key]);
      return C ? C.label : "All";
    }, Z = (b, C = "") => {
      j.value[b] = C.toString();
    }, Y = () => {
      const b = new URL(t.collection.first_page_url), C = new URLSearchParams(b.search);
      return Object.keys(j.value).forEach((x) => {
        j.value[x] !== null && j.value[x] !== "" ? C.set(`filter[${x}]`, j.value[x]) : C.delete(`filter[${x}]`);
      }), b.origin + b.pathname + "?" + C.toString();
    }, E = () => {
      Ot.get(Y(), {
        only: t.only
      }), B.value = !1;
    }, G = () => {
      let b = new URLSearchParams(window.location.search);
      [...t.filters, ...t.customFilters].forEach((x) => {
        j.value[x.key] = b.get(`filter[${x.key}]`);
      });
    }, S = () => {
      G(), B.value = !0;
    }, R = () => {
      B.value = !1;
    }, U = () => {
      const b = [...t.filters, ...t.customFilters];
      j.value = b.reduce(
        (C, x) => ({ ...C, [x.key]: null }),
        {}
      ), E();
    }, z = (b) => b.type === "number" || b.type === "price" ? { "!text-right": !0 } : {}, Q = (b) => b.type === "number" || b.type === "price" ? { "text-right": !0 } : {}, q = (b, C) => b.type === "number" ? Ss(C) : b.type === "price" ? ks(C) : C, ae = (b) => {
      if (!b.summarise || !["sum", "average"].includes(b.summarise))
        return;
      let C;
      return b.summarise === "sum" && (C = a.value.reduce((x, I) => x + Number(I[b.value]), 0)), b.summarise === "average" && (C = a.value.reduce((x, I) => x + Number(I[b.value]), 0) / a.value.length), q(b, C);
    };
    return re(() => {
      G();
      let b = new URLSearchParams(window.location.search);
      w.value = b.get("filter[q]");
    }), (b, C) => (c(), m("div", null, [
      V(_s, {
        open: B.value,
        onClose: R
      }, {
        header: k(() => C[5] || (C[5] = [
          u("h2", { class: "text-xl" }, "Filters", -1)
        ])),
        footer: k(() => [
          u("div", Ms, [
            V(ze, {
              as: "button",
              onClick: U
            }, {
              default: k(() => C[7] || (C[7] = [
                ne(" Reset")
              ])),
              _: 1
            }),
            V(tn, {
              as: "button",
              onClick: E
            }, {
              default: k(() => C[8] || (C[8] = [
                ne(" Apply")
              ])),
              _: 1
            })
          ])
        ]),
        default: k(() => [
          u("div", Os, [
            (c(!0), m(le, null, de(b.filters, (x) => (c(), m("div", {
              key: x.key,
              class: "flex flex-col items-start"
            }, [
              u("span", Es, F(x.label), 1),
              x.component === "dropdown" ? (c(), M(Dt, {
                key: 0,
                class: "mt-1 w-56",
                "z-index": "z-30"
              }, {
                text: k(() => [
                  u("div", Cs, [
                    u("div", null, [
                      u("span", Is, F(A(x)), 1)
                    ]),
                    V($(Lt), { class: "h-5 w-5 shrink-0" })
                  ])
                ]),
                default: k(() => [
                  V(ut, {
                    key: "all",
                    onClick: () => Z(x.key)
                  }, {
                    default: k(() => C[6] || (C[6] = [
                      u("div", { class: "flex items-center" }, [
                        u("span", { class: "capitalize" }, "All")
                      ], -1)
                    ])),
                    _: 2
                  }, 1032, ["onClick"]),
                  (c(!0), m(le, null, de(x.options, (I) => (c(), M(ut, {
                    key: I.value,
                    onClick: () => Z(x.key, I.value)
                  }, {
                    default: k(() => [
                      u("span", Ts, F(I.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))), 128))
                ]),
                _: 2
              }, 1024)) : L("", !0),
              x.component === "date" ? (c(), m("div", Ps, [
                V(vs, {
                  id: "date",
                  value: j.value[x.key],
                  onInput: (I) => Z(x.key, I.target.value)
                }, null, 8, ["value", "onInput"]),
                j.value[x.key] ? (c(), m("button", {
                  key: 0,
                  class: "mt-1 h-full border-transparent px-2 hover:text-gray-400",
                  type: "button",
                  onClick: () => j.value[x.key] = null
                }, [
                  V($(Tl), { class: "h-4 w-4" })
                ], 8, Bs)) : L("", !0)
              ])) : L("", !0)
            ]))), 128)),
            (c(!0), m(le, null, de(b.customFilters, (x) => (c(), m("div", {
              key: x.key,
              class: "flex flex-col items-start gap-2"
            }, [
              u("span", Rs, F(x.label), 1),
              (c(), M(Ve(x.component), K({ ref_for: !0 }, x.props ? x.props : {}, {
                filter: j.value[x.key],
                onFilter: (I) => Z(x.key, I)
              }), null, 16, ["filter", "onFilter"]))
            ]))), 128))
          ])
        ]),
        _: 1
      }, 8, ["open"]),
      V(Ft, {
        "enter-active-class": "transition ease-out duration-100",
        "enter-from-class": "transform opacity-0 scale-95",
        "enter-to-class": "transform opacity-100 scale-100",
        "leave-active-class": "transition ease-in duration-75",
        "leave-from-class": "transform opacity-100 scale-100",
        "leave-to-class": "transform opacity-0 scale-95"
      }, {
        default: k(() => [
          d.value.length > 0 ? (c(), m("div", As, [
            u("div", null, [
              u("div", Vs, [
                u("div", Ds, F(d.value.length) + " selected ", 1),
                V(ys, {
                  modelValue: h.value,
                  "onUpdate:modelValue": C[0] || (C[0] = (x) => h.value = x),
                  class: "-mt-1 pr-8",
                  options: $(g)
                }, null, 8, ["modelValue", "options"]),
                V(tn, {
                  as: "button",
                  onClick: C[1] || (C[1] = (x) => b.$emit(h.value, d.value))
                }, {
                  default: k(() => C[9] || (C[9] = [
                    ne(" Apply ")
                  ])),
                  _: 1
                })
              ])
            ])
          ])) : L("", !0)
        ]),
        _: 1
      }),
      u("div", {
        class: "relative",
        tabindex: "0",
        onKeydown: C[4] || (C[4] = kt((x) => d.value = [], ["esc"]))
      }, [
        b.filters.length > 0 || b.enableSearch ? (c(), m("div", {
          key: 0,
          class: W(["flex", {
            "justify-between": b.filters.length > 0 && b.enableSearch,
            "justify-end": b.filters.length === 0 && b.enableSearch
          }])
        }, [
          b.filters.length > 0 ? (c(), M(ze, {
            key: 0,
            as: "button",
            class: "mr-3 w-fit",
            onClick: S
          }, {
            default: k(() => [
              u("div", Fs, [
                V($(bl), { class: "h-5 w-5" }),
                C[10] || (C[10] = u("div", { class: "hidden pl-1 md:flex" }, "Filters", -1)),
                ue.value > 0 ? (c(), m("span", Ls, F(ue.value), 1)) : L("", !0)
              ])
            ]),
            _: 1
          })) : L("", !0),
          b.enableSearch ? (c(), m("div", Ns, [
            V(mt, {
              modelValue: w.value,
              "onUpdate:modelValue": C[2] || (C[2] = (x) => w.value = x),
              type: "search",
              class: "block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm transition duration-150 ease-in-out focus:border-primary-300 focus:outline-offset-0 focus:ring-primary-200/50 sm:text-sm",
              placeholder: b.searchPlaceholder,
              onKeydown: kt(T, ["enter"]),
              onSearch: T
            }, null, 8, ["modelValue", "placeholder"]),
            V(ze, {
              as: "button",
              only: b.only,
              class: "h-full md:pl-2",
              onClick: De(T, ["prevent"])
            }, {
              default: k(() => [
                u("div", js, [
                  V($(Il), { class: "h-5 w-5" }),
                  C[11] || (C[11] = u("span", { class: "hidden md:flex" }, "Search", -1))
                ])
              ]),
              _: 1
            }, 8, ["only"])
          ])) : L("", !0)
        ], 2)) : L("", !0),
        u("div", zs, [
          u("div", Us, [
            u("div", Hs, [
              u("div", Ws, [
                u("table", Ks, [
                  u("thead", Zs, [
                    u("tr", null, [
                      b.bulkActions.length > 0 ? (c(), m("th", qs, [
                        u("input", {
                          type: "checkbox",
                          class: "absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500 sm:left-6",
                          checked: v.value || d.value.length === a.value.length,
                          onChange: f
                        }, null, 40, Gs)
                      ])) : L("", !0),
                      (c(!0), m(le, null, de(b.columns, (x, I) => ce((c(), m("th", {
                        key: I,
                        scope: "col",
                        class: W(["py-3.5 text-left text-sm font-semibold text-gray-900", {
                          "min-w-48": I === 0 && !x.compact,
                          ...z(x)
                        }])
                      }, [
                        x.sortable ? (c(), m("div", Qs, [
                          $(l).sort === x.value ? (c(), M($(ye), {
                            key: 0,
                            href: N(`-${x.value}`),
                            class: "flex items-center gap-x-2 px-1 py-1"
                          }, {
                            default: k(() => [
                              ne(F(x.text) + " ", 1),
                              V($(wl), { class: "h-4 w-4 shrink-0" })
                            ]),
                            _: 2
                          }, 1032, ["href"])) : $(l).sort === `-${x.value}` ? (c(), M($(ye), {
                            key: 1,
                            href: N(""),
                            class: "flex items-center gap-x-2 px-1 py-1"
                          }, {
                            default: k(() => [
                              ne(F(x.text) + " ", 1),
                              V($(yl), { class: "h-4 w-4 shrink-0" })
                            ]),
                            _: 2
                          }, 1032, ["href"])) : (c(), M($(ye), {
                            key: 2,
                            href: N(x.value),
                            class: "flex items-center gap-x-2 px-1 py-1"
                          }, {
                            default: k(() => [
                              ne(F(x.text) + " ", 1),
                              V($(xl), { class: "h-4 w-4 shrink-0" })
                            ]),
                            _: 2
                          }, 1032, ["href"]))
                        ])) : (c(), m(le, { key: 1 }, [
                          ne(F(x.text), 1)
                        ], 64))
                      ], 2)), [
                        [qe, x.hasOwnProperty("visible") ? x.visible : !0]
                      ])), 128)),
                      b.actions.length > 0 ? (c(), m("th", Ys, C[12] || (C[12] = [
                        u("span", { class: "sr-only" }, "Actions", -1)
                      ]))) : L("", !0)
                    ])
                  ]),
                  u("tbody", Xs, [
                    (c(!0), m(le, null, de(a.value, (x) => (c(), m("tr", {
                      key: x.id,
                      class: W([d.value.includes(x.id) && "bg-gray-50"])
                    }, [
                      b.bulkActions.length > 0 ? (c(), m("td", Js, [
                        d.value.includes(x.id) ? (c(), m("div", ei)) : L("", !0),
                        ce(u("input", {
                          "onUpdate:modelValue": C[3] || (C[3] = (I) => d.value = I),
                          type: "checkbox",
                          class: "absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500 sm:left-6",
                          value: x.id
                        }, null, 8, ti), [
                          [On, d.value]
                        ])
                      ])) : L("", !0),
                      (c(!0), m(le, null, de(i.value, (I, X) => ce((c(), m("td", {
                        key: X,
                        class: W(["whitespace-nowrap py-4 text-sm text-gray-900", {
                          "!text-primary-600": d.value.includes(x.id),
                          "pr-3 font-medium": X === 0,
                          "text-gray-500": X > 0,
                          "px-3": b.bulkActions.length === 0,
                          ...Q(b.columns[X])
                        }])
                      }, [
                        D(b.$slots, `item.${I}`, {
                          value: x[I],
                          item: x
                        }, () => [
                          ne(F(q(b.columns[X], x[I])), 1)
                        ])
                      ], 2)), [
                        [
                          qe,
                          b.columns[X].hasOwnProperty("visible") ? b.columns[X].visible : !0
                        ]
                      ])), 128)),
                      b.actions.length > 0 && s(x).length > 0 ? (c(), m("td", ni, [
                        s(x).length === 1 ? (c(), m("button", {
                          key: 0,
                          type: "button",
                          class: "text-primary-600 hover:text-primary-900",
                          onClick: De((I) => b.$emit(s(x)[0].value, x), ["prevent"])
                        }, F(s(x)[0].text), 9, li)) : (c(), M(Dt, {
                          key: 1,
                          "text-classes": "!w-fit border-none shadow-none",
                          "z-index": "z-30"
                        }, {
                          text: k(() => [
                            V($(kl), { class: "h-4 w-4 text-gray-500" })
                          ]),
                          default: k(() => [
                            (c(!0), m(le, null, de(s(x), (I) => (c(), M(ut, {
                              key: I.value,
                              onClick: (X) => b.$emit(I.value, x)
                            }, {
                              default: k(() => [
                                ne(F(I.text), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))), 128))
                          ]),
                          _: 2
                        }, 1024))
                      ])) : L("", !0),
                      b.actions.length > 0 && s(x).length === 0 ? (c(), m("td", ri, C[13] || (C[13] = [
                        u("span", { class: "sr-only" }, "actions", -1)
                      ]))) : L("", !0)
                    ], 2))), 128))
                  ]),
                  p.value ? (c(), m("tfoot", oi, [
                    u("tr", null, [
                      b.bulkActions.length > 0 ? (c(), m("th", ai, C[14] || (C[14] = [
                        u("span", { class: "sr-only" }, "bulk actions", -1)
                      ]))) : L("", !0),
                      (c(!0), m(le, null, de(b.columns, (x, I) => ce((c(), m("th", {
                        key: I,
                        scope: "row",
                        class: W(["whitespace-nowrap py-4 text-sm text-gray-900", {
                          "pr-3 font-medium": I === 0,
                          "text-gray-500": I > 0,
                          "px-3": b.bulkActions.length === 0,
                          ...Q(b.columns[I])
                        }])
                      }, F(ae(x)), 3)), [
                        [qe, x.hasOwnProperty("visible") ? x.visible : !0]
                      ])), 128)),
                      b.actions.length ? (c(), m("th", si, C[15] || (C[15] = [
                        u("span", { class: "sr-only" }, "bulk actions", -1)
                      ]))) : L("", !0)
                    ])
                  ])) : L("", !0)
                ])
              ])
            ])
          ])
        ]),
        D(b.$slots, "pagination", {}, () => [
          b.collection ? (c(), M(os, {
            key: 0,
            collection: b.collection
          }, null, 8, ["collection"])) : L("", !0)
        ])
      ], 32)
    ]));
  }
}), ui = { class: "overflow-hidden bg-white shadow sm:rounded-t-lg" }, di = { class: "border-b border-gray-200 px-4 py-5 sm:px-6" }, ci = { class: "flex flex-wrap items-center justify-between sm:flex-nowrap" }, pi = { class: "shrink-0" }, fi = { class: "inline-flex items-center gap-x-2" }, vi = { name: "Heading" }, hd = /* @__PURE__ */ O({
  ...vi,
  props: {
    as: { default: "h1" }
  },
  setup(e) {
    return (n, t) => (c(), m("div", null, [
      u("div", ui, [
        u("div", di, [
          u("div", ci, [
            (c(), M(Ve(n.as), { class: "text-2xl font-medium leading-6 text-gray-900" }, {
              default: k(() => [
                D(n.$slots, "default")
              ]),
              _: 3
            })),
            u("div", pi, [
              u("span", fi, [
                D(n.$slots, "actions")
              ])
            ])
          ])
        ])
      ])
    ]));
  }
}), mi = {
  "aria-live": "assertive",
  class: "pointer-events-none fixed inset-0 z-50 flex items-end px-4 py-6 sm:items-start sm:p-6"
}, hi = { class: "flex w-full flex-col items-center space-y-4 sm:items-end" }, gi = {
  key: 0,
  class: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5"
}, bi = { class: "p-4" }, yi = { class: "flex items-start" }, wi = { class: "shrink-0" }, xi = { class: "ml-3 w-0 flex-1 pt-0.5" }, _i = { class: "text-sm font-medium text-gray-900" }, $i = { class: "ml-4 flex shrink-0" }, Si = ["onClick"], ki = { name: "Notifications" }, gd = /* @__PURE__ */ O({
  ...ki,
  props: {
    info: {},
    success: {},
    warning: {},
    errors: {},
    showErrorKeys: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = _([]), r = y(() => t.value.length);
    te(
      () => n.info,
      (o) => {
        o && t.value.push({
          icon: Ur,
          heading: "FYI",
          messages: [n.info],
          iconClasses: "text-blue-400"
        });
      },
      {
        immediate: !0
      }
    ), te(
      () => n.success,
      (o) => {
        o && t.value.push({
          icon: zr,
          heading: "Success",
          messages: [n.success],
          iconClasses: "text-green-400"
        });
      },
      { immediate: !0 }
    ), te(
      () => n.warning,
      (o) => {
        o && t.value.push({
          icon: nn,
          heading: "Warning",
          messages: [n.warning],
          iconClasses: "text-orange-400"
        });
      },
      { immediate: !0 }
    ), te(
      () => n.errors,
      () => {
        Object.keys(n.errors).length > 0 && t.value.push({
          icon: nn,
          heading: "Oh snap! Some errors were encountered.",
          messages: n.showErrorKeys ? Object.keys(n.errors) : Object.values(n.errors),
          iconClasses: "text-red-400"
        });
      }
    ), te(
      r,
      (o, s) => {
        (typeof s > "u" || o >= s) && setTimeout(() => t.value.shift(), 7e3);
      },
      {
        deep: !0,
        immediate: !0
      }
    );
    const l = (o) => t.value.splice(o, 1);
    return (o, s) => (c(), m("div", mi, [
      u("div", hi, [
        (c(!0), m(le, null, de(t.value, (a, i) => (c(), M(Ft, {
          key: i,
          "enter-active-class": "transform ease-out duration-300 transition",
          "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
          "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
          "leave-active-class": "transition ease-in duration-100",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: k(() => [
            a.messages.length > 0 ? (c(), m("div", gi, [
              u("div", bi, [
                u("div", yi, [
                  u("div", wi, [
                    (c(), M(Ve(a.icon), {
                      class: W(["h-6 w-6", a.iconClasses]),
                      "aria-hidden": "true"
                    }, null, 8, ["class"]))
                  ]),
                  u("div", xi, [
                    u("p", _i, F(a.heading), 1),
                    (c(!0), m(le, null, de(a.messages, (p, d) => (c(), m("p", {
                      key: d,
                      class: "mt-1 text-sm text-gray-500"
                    }, F(p), 1))), 128))
                  ]),
                  u("div", $i, [
                    u("button", {
                      type: "button",
                      class: "inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2",
                      onClick: (p) => l(i)
                    }, [
                      s[0] || (s[0] = u("span", { class: "sr-only" }, "Close", -1)),
                      V($(Qe), {
                        class: "h-5 w-5",
                        "aria-hidden": "true"
                      })
                    ], 8, Si)
                  ])
                ])
              ])
            ])) : L("", !0)
          ]),
          _: 2
        }, 1024))), 128))
      ])
    ]));
  }
}), Oi = { class: "absolute inset-0 overflow-hidden" }, Ei = { class: "flex items-center justify-between" }, Ci = { class: "grow overflow-hidden" }, Ii = { class: "h-full overflow-y-auto" }, bd = /* @__PURE__ */ O({
  __name: "Slideover",
  props: {
    open: { type: Boolean, default: !1 },
    background: { default: "bg-white" },
    backdrop: { type: Boolean, default: !0 },
    align: { default: "right" }
  },
  emits: ["close"],
  setup(e, { emit: n }) {
    const t = e, r = n, l = y(() => t.backdrop ? "transition-opacity bg-black/10" : null), o = y(() => t.align === "right" ? "right-0 pl-10" : "left-0 pr-10"), s = y(() => t.backdrop ? {
      enter: "ease-in-out duration-500",
      "enter-from": "opacity-0",
      "enter-to": "opacity-100",
      leave: "ease-in-out duration-500",
      "leave-from": "opacity-100",
      "leave-to": "opacity-0"
    } : {}), a = y(() => t.align === "left" ? {
      enter: "transition ease-in-out duration-500 sm:duration-700",
      "enter-from": "-translate-x-full",
      "enter-to": "translate-x-0",
      leave: "transition ease-in-out duration-500 sm:duration-700",
      "leave-from": "translate-x-0",
      "leave-to": "-translate-x-full"
    } : {
      enter: "transition ease-in-out duration-500 sm:duration-700",
      "enter-from": "translate-x-full",
      "enter-to": "translate-x-0",
      leave: "transition ease-in-out duration-500 sm:duration-700",
      "leave-from": "translate-x-0",
      "leave-to": "translate-x-full"
    });
    return (i, p) => (c(), M($(qt), {
      as: "template",
      show: i.open
    }, {
      default: k(() => [
        V($(tl), {
          as: "div",
          class: "fixed inset-0 z-40 overflow-hidden",
          onClose: p[1] || (p[1] = (d) => r("close"))
        }, {
          default: k(() => [
            u("div", Oi, [
              V($(Xe), K({ as: "template" }, s.value), {
                default: k(() => [
                  V($(ca), {
                    class: W(["absolute inset-0", [l.value]])
                  }, null, 8, ["class"])
                ]),
                _: 1
              }, 16),
              u("div", {
                class: W(["fixed inset-y-0 flex max-w-full", [o.value]])
              }, [
                V($(Xe), K({ as: "template" }, a.value), {
                  default: k(() => [
                    u("div", {
                      class: W(["relative flex h-full w-screen max-w-md flex-col space-y-4 p-4 shadow-xl", i.background])
                    }, [
                      u("div", Ei, [
                        D(i.$slots, "header"),
                        V(ze, {
                          as: "button",
                          class: "!border-none !p-1",
                          onClick: p[0] || (p[0] = (d) => r("close"))
                        }, {
                          default: k(() => [
                            V($(Qe), {
                              class: "h-4 w-4 cursor-pointer text-gray-800",
                              "aria-hidden": "true"
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      u("div", Ci, [
                        u("div", Ii, [
                          D(i.$slots, "default")
                        ])
                      ]),
                      D(i.$slots, "footer")
                    ], 2)
                  ]),
                  _: 3
                }, 16)
              ], 2)
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), Ti = { class: "overflow-hidden bg-white shadow" }, Pi = { class: "m-0" }, Bi = { class: "flex items-center px-4 py-4 sm:px-6" }, Ri = { class: "flex min-w-0 flex-1 items-center" }, Mi = { class: "shrink-0" }, Ai = {
  key: 0,
  class: "flex items-center"
}, Vi = { class: "mx-auto" }, Di = { class: "truncate text-sm font-medium leading-5 text-primary-600" }, Fi = { class: "mt-2 flex items-center text-sm leading-5 text-gray-500" }, Li = { class: "truncate" }, Ni = { name: "StackedList" }, yd = /* @__PURE__ */ O({
  ...Ni,
  props: {
    items: {}
  },
  setup(e) {
    const n = (t) => t.split(" ").map((r) => r[0]).join("");
    return (t, r) => (c(), m("div", Ti, [
      u("ul", Pi, [
        (c(!0), m(le, null, de(t.items, (l) => (c(), m("li", {
          key: l.href,
          class: "border-b border-gray-200"
        }, [
          V($(ye), {
            href: l.href,
            class: "block transition duration-150 ease-in-out hover:bg-gray-50 focus:bg-gray-50 focus:outline-none"
          }, {
            default: k(() => [
              u("div", Bi, [
                u("div", Ri, [
                  u("div", Mi, [
                    l.icon !== !1 ? (c(), m("div", Ai, [
                      u("div", {
                        class: W(["mr-2 flex h-12 w-12 items-center rounded-full p-1", l.colour])
                      }, [
                        u("div", Vi, [
                          "icon" in l ? (c(), M(Ve(l.icon), {
                            key: 0,
                            class: "h-6 w-6"
                          })) : (c(), m(le, { key: 1 }, [
                            ne(F(n(l.name)), 1)
                          ], 64))
                        ])
                      ], 2)
                    ])) : L("", !0)
                  ]),
                  u("div", {
                    class: W(["min-w-0 flex-1 md:grid md:grid-cols-2 md:gap-4", l.icon !== !1 ? "px-4" : "px-1"])
                  }, [
                    u("div", null, [
                      u("div", Di, F(l.name), 1),
                      u("div", Fi, [
                        u("span", Li, F(l.description), 1)
                      ])
                    ])
                  ], 2)
                ]),
                u("div", null, [
                  V($(dt), { class: "h-5 w-5 text-gray-400" })
                ])
              ])
            ]),
            _: 2
          }, 1032, ["href"])
        ]))), 128))
      ])
    ]));
  }
}), ji = { class: "flex w-full items-center justify-between" }, zi = { class: "border-b border-gray-200" }, Ui = {
  class: "-mb-px flex space-x-8",
  "aria-label": "Tabs"
}, Hi = ["href", "aria-current"], Wi = { name: "Tabs" }, wd = /* @__PURE__ */ O({
  ...Wi,
  props: {
    tabs: {},
    dropdownThreshold: { type: [Number, Boolean], default: 2 }
  },
  setup(e) {
    const n = e, t = (o) => o.hasOwnProperty("visible") ? o.visible : !0, r = (o) => o.hasOwnProperty("external") ? o.external : !1, l = y(() => n.tabs.find((o) => o.current));
    return (o, s) => (c(), m("div", null, [
      n.dropdownThreshold !== !1 ? (c(), m("div", {
        key: 0,
        class: W(["sm:hidden", { hidden: o.tabs.length <= n.dropdownThreshold }])
      }, [
        s[0] || (s[0] = u("label", {
          for: "tabs",
          class: "sr-only"
        }, "Select a tab", -1)),
        V(Dt, null, {
          text: k(() => [
            u("div", ji, [
              ne(F(l.value ? l.value.name : "Select a tab") + " ", 1),
              V($(Lt), {
                class: "h-5 w-5 text-gray-400 group-hover:text-gray-500",
                "aria-hidden": "true"
              })
            ])
          ]),
          default: k(() => [
            (c(!0), m(le, null, de(o.tabs, (a) => (c(), M(ut, {
              key: a.name,
              href: a.href,
              external: r(a)
            }, {
              default: k(() => [
                ne(F(a.name), 1)
              ]),
              _: 2
            }, 1032, ["href", "external"]))), 128))
          ]),
          _: 1
        })
      ], 2)) : L("", !0),
      u("div", {
        class: W(["sm:block", {
          hidden: o.tabs.length > n.dropdownThreshold && n.dropdownThreshold !== !1
        }])
      }, [
        u("div", zi, [
          u("nav", Ui, [
            (c(!0), m(le, null, de(o.tabs, (a) => (c(), m(le, null, [
              r(a) && t(a) ? (c(), m("a", {
                key: a.name,
                href: a.href,
                class: W([
                  a.current ? "border-primary-500 text-primary-600" : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700",
                  "group inline-flex items-center whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium"
                ]),
                "aria-current": a.current ? "page" : void 0
              }, [
                (c(), M(Ve(a.icon), {
                  class: W([
                    a.current ? "text-primary-500" : "text-gray-400 group-hover:text-gray-500",
                    "-ml-0.5 mr-2 h-5 w-5"
                  ]),
                  "aria-hidden": "true"
                }, null, 8, ["class"])),
                u("span", null, F(a.name), 1)
              ], 10, Hi)) : L("", !0),
              !r(a) && t(a) ? (c(), M($(ye), {
                key: a.name,
                href: a.href,
                class: W([
                  a.current ? "border-primary-500 text-primary-600" : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700",
                  "group inline-flex items-center whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium"
                ]),
                "aria-current": a.current ? "page" : void 0
              }, {
                default: k(() => [
                  (c(), M(Ve(a.icon), {
                    class: W([
                      a.current ? "text-primary-500" : "text-gray-400 group-hover:text-gray-500",
                      "-ml-0.5 mr-2 h-5 w-5"
                    ]),
                    "aria-hidden": "true"
                  }, null, 8, ["class"])),
                  u("span", null, F(a.name), 1)
                ]),
                _: 2
              }, 1032, ["href", "class", "aria-current"])) : L("", !0)
            ], 64))), 256))
          ])
        ])
      ], 2)
    ]));
  }
}), Ki = { class: "group relative" }, Zi = { class: "whitespace-nowrap" }, xd = /* @__PURE__ */ O({
  __name: "Tooltip",
  props: {
    content: {},
    position: { default: "bottom" },
    background: { default: "bg-slate-700" },
    text: { default: "text-white" }
  },
  setup(e) {
    const n = e, t = y(() => n.position === "right" ? "sm:left-[130%] sm:-top-2 top-[130%]" : n.position === "top" ? "bottom-[110%] sm:-left-2" : n.position === "bottom" ? "top-[130%] sm:-left-1/2 " : n.position);
    return (r, l) => (c(), m("div", Ki, [
      u("div", {
        class: W(["invisible absolute z-10 inline-block whitespace-nowrap rounded-lg border border-black p-2 px-3 transition duration-300 ease-in-out group-hover:visible group-hover:scale-110", [t.value, r.background]])
      }, [
        u("div", {
          class: W(["shrink-0 text-sm", [r.text]])
        }, F(r.content), 3)
      ], 2),
      u("span", Zi, [
        D(r.$slots, "default")
      ])
    ]));
  }
}), qi = { name: "Actions" }, Gi = { class: "mt-8 border-t border-gray-200 pt-5" }, Qi = { class: "flex justify-end" }, Yi = { class: "inline-flex" };
function Xi(e, n, t, r, l, o) {
  return c(), m("div", Gi, [
    u("div", Qi, [
      u("span", Yi, [
        D(e.$slots, "default")
      ])
    ])
  ]);
}
const _d = /* @__PURE__ */ Je(qi, [["render", Xi]]), Ji = { class: "relative mt-1" }, eu = {
  key: 0,
  class: "w-full"
}, tu = {
  key: 0,
  class: "flex w-full flex-wrap items-center gap-2"
}, nu = ["onClick"], lu = {
  key: 1,
  class: "w-full"
}, ru = {
  key: 0,
  class: "flex w-full items-center justify-between"
}, ou = { class: "grow" }, $d = /* @__PURE__ */ O({
  __name: "Combobox",
  props: {
    modelValue: {},
    id: {},
    zIndex: { default: "z-10" },
    placeholder: {},
    description: {},
    error: {},
    options: {},
    multiple: { type: Boolean },
    clearQueryOnSelect: { type: Boolean, default: !0 },
    disableFiltering: { type: Boolean },
    nullable: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue", "search"],
  setup(e, { emit: n }) {
    const t = e, r = n, l = y({
      get: () => t.nullable && t.modelValue === null ? null : t.multiple ? t.options.filter(
        (a) => t.modelValue.includes(a.id)
      ) : t.options.find((a) => a.id === t.modelValue),
      set: (a) => {
        if (a !== void 0) {
          if (a === null) {
            r("update:modelValue", null);
            return;
          }
          t.multiple ? Array.isArray(a) && r(
            "update:modelValue",
            a.map((i) => i.id)
          ) : r("update:modelValue", a.id);
        }
      }
    }), o = _("");
    te(l, () => {
      t.clearQueryOnSelect && (o.value = "");
    });
    const s = y(() => t.disableFiltering || o.value === "" ? t.options : t.options.filter((a) => a.name.toLowerCase().includes(o.value.toLowerCase())));
    return te(o, (a) => r("search", a)), (a, i) => (c(), M(Oe, Ue(He(a.$props)), {
      default: k(() => [
        V($(Do), {
          modelValue: l.value,
          "onUpdate:modelValue": i[1] || (i[1] = (p) => l.value = p),
          as: "div",
          by: "id",
          multiple: !!a.multiple,
          nullable: !!a.nullable,
          disabled: !!a.disabled
        }, {
          default: k(({ value: p, open: d }) => [
            u("div", Ji, [
              V($(Fo), {
                as: "div",
                class: "rounded-md focus:outline-none"
              }, {
                default: k(() => [
                  u("div", {
                    class: W(["flex w-full flex-wrap gap-2 rounded-md border bg-white py-2 pl-3 pr-10 focus:border-primary-300 focus:ring-primary-200/50 sm:text-sm", {
                      "border-red-400": a.error,
                      "border-gray-300": !a.error
                    }])
                  }, [
                    d || a.multiple && p.length === 0 || !a.multiple && !p ? (c(), M($(Lo), K({
                      key: 0,
                      class: "flex-1 border-none p-0 text-sm focus:outline-0 focus:ring-0",
                      spellcheck: "false",
                      placeholder: a.placeholder ? a.placeholder : "Search..."
                    }, {
                      "display-value": a.clearQueryOnSelect ? () => o.value : void 0,
                      onBlur: a.clearQueryOnSelect ? () => o.value = "" : void 0
                    }, {
                      onChange: (v) => o.value = v.target.value
                    }), null, 16, ["placeholder", "onChange"])) : L("", !0),
                    D(a.$slots, "display-value", {
                      selected: p,
                      open: d,
                      multiple: a.multiple
                    }, () => [
                      (a.multiple ? p.length > 0 : !d && p) ? (c(), m("div", eu, [
                        a.multiple ? (c(), m("div", tu, [
                          (c(!0), m(le, null, de(p, (v) => (c(), m("div", {
                            key: v.id,
                            class: "flex items-center gap-1 rounded bg-gray-100 px-2 py-0.5 text-xs"
                          }, [
                            D(a.$slots, "display-value-text", { selected: v }, () => [
                              u("div", null, F(v.name), 1)
                            ]),
                            a.disabled ? L("", !0) : (c(), m("button", {
                              key: 0,
                              type: "button",
                              class: "items-center justify-center",
                              onClick: De((f) => l.value = p.filter((h) => h.id !== v.id), ["prevent"])
                            }, [
                              V($(Qe), { class: "h-3.5 w-3.5" })
                            ], 8, nu))
                          ]))), 128))
                        ])) : (c(), m("div", lu, [
                          p ? (c(), m("div", ru, [
                            u("div", ou, [
                              D(a.$slots, "display-value-text", { selected: p }, () => [
                                ne(F(p.name), 1)
                              ])
                            ]),
                            a.nullable && !a.disabled ? (c(), m("button", {
                              key: 0,
                              type: "button",
                              class: "items-center justify-center",
                              onClick: i[0] || (i[0] = De(() => l.value = null, ["prevent"]))
                            }, [
                              V($(Qe), { class: "h-3.5 w-3.5" })
                            ])) : L("", !0)
                          ])) : L("", !0)
                        ]))
                      ])) : L("", !0)
                    ])
                  ], 2),
                  a.disabled ? L("", !0) : (c(), M($(Sl), {
                    key: 0,
                    class: "absolute inset-y-0 right-0 top-2 mr-2.5 h-5 w-5 text-gray-400",
                    "aria-hidden": "true"
                  }))
                ]),
                _: 2
              }, 1024),
              s.value.length > 0 ? (c(), M($(No), {
                key: 0,
                class: W(["absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm", [a.zIndex]])
              }, {
                default: k(() => [
                  (c(!0), m(le, null, de(s.value, (v) => (c(), M($(jo), {
                    key: v.id,
                    value: v,
                    as: "template"
                  }, {
                    default: k(({ active: f, selected: h }) => [
                      D(a.$slots, "option", {
                        option: v,
                        active: f,
                        selected: h
                      }, () => [
                        u("li", {
                          class: W([
                            "relative cursor-default select-none py-2 pl-3 pr-9",
                            f ? "bg-primary-600 text-white" : "text-gray-900"
                          ])
                        }, [
                          u("span", {
                            class: W(["block truncate", h && "font-semibold"])
                          }, F(v.name), 3),
                          h ? (c(), m("span", {
                            key: 0,
                            class: W([
                              "absolute inset-y-0 right-0 flex items-center pr-4",
                              f ? "text-white" : "text-primary-600"
                            ])
                          }, [
                            V($($l), {
                              class: "h-5 w-5",
                              "aria-hidden": "true"
                            })
                          ], 2)) : L("", !0)
                        ], 2)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["value"]))), 128))
                ]),
                _: 3
              }, 8, ["class"])) : L("", !0)
            ])
          ]),
          _: 3
        }, 8, ["modelValue", "multiple", "nullable", "disabled"])
      ]),
      _: 3
    }, 16));
  }
}), au = { class: "relative flex items-start" }, su = { class: "flex h-5 items-center" }, iu = ["id", "value", "disabled", "readonly"], uu = { class: "ml-3" }, du = ["for"], cu = { name: "Checkbox" }, Sd = /* @__PURE__ */ O({
  ...cu,
  props: {
    modelValue: { type: [Array, Boolean] },
    id: {},
    description: {},
    error: {},
    label: {},
    value: {},
    readonly: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const l = ke(e, n);
    return (o, s) => (c(), M(Oe, K(o.$props, { shadow: !1 }), {
      default: k(() => [
        u("div", au, [
          u("div", su, [
            ce(u("input", K({
              id: o.id,
              "onUpdate:modelValue": s[0] || (s[0] = (a) => Se(l) ? l.value = a : null),
              value: o.value,
              type: "checkbox",
              class: "h-4 w-4 rounded border-gray-300 text-primary-600 accent-primary-600 focus:ring-primary-500",
              disabled: o.disabled,
              readonly: o.readonly
            }, o.$attrs), null, 16, iu), [
              [On, $(l)]
            ]),
            u("div", uu, [
              u("label", {
                for: o.id,
                class: "block text-sm font-medium leading-5 text-gray-700"
              }, F(o.label), 9, du)
            ])
          ])
        ])
      ]),
      _: 1
    }, 16));
  }
}), pu = { class: "mt-1 flex space-x-2" }, fu = ["id", "type", "min", "max", "placeholder"], vu = ["id", "type", "min", "max", "placeholder"], mu = { name: "DateRange" }, kd = /* @__PURE__ */ O({
  ...mu,
  props: {
    id: {},
    placeholder: {},
    modelValue: {},
    from: {},
    to: {},
    min: {},
    max: {},
    description: {},
    error: {},
    type: { default: "date" }
  },
  emits: ["update:modelValue", "update:from", "update:to"],
  setup(e, { emit: n }) {
    const t = e, r = n, l = _(t.modelValue ? t.modelValue[0] : t.from ? t.from : null), o = _(t.modelValue ? t.modelValue[1] : t.to ? t.to : null);
    return te(l, (s) => {
      r("update:modelValue", [s, o.value]), r("update:from", s);
    }), te(o, (s) => {
      r("update:modelValue", [l.value, s]), r("update:to", s);
    }), (s, a) => (c(), M(Oe, K(s.$props, { shadow: !1 }), {
      default: k(() => [
        u("div", pu, [
          ce(u("input", K({
            id: `${s.id}-start-date`,
            "onUpdate:modelValue": a[0] || (a[0] = (i) => l.value = i),
            type: s.type,
            min: s.min,
            max: s.max,
            placeholder: s.placeholder,
            class: ["mt-1 block w-full rounded-md border px-3 py-2 shadow-sm transition duration-150 ease-in-out focus:border-primary-300 focus:ring-primary-200/50 focus-visible:outline-none sm:text-sm", {
              "border-red-400": s.error,
              "border-gray-300": !s.error
            }]
          }, s.$attrs), null, 16, fu), [
            [St, l.value]
          ]),
          ce(u("input", K({
            id: `${s.id}-end-date`,
            "onUpdate:modelValue": a[1] || (a[1] = (i) => o.value = i),
            type: s.type,
            min: s.min,
            max: s.max,
            placeholder: s.placeholder,
            class: ["mt-1 block w-full rounded-md border px-3 py-2 shadow-sm transition duration-150 ease-in-out focus:border-primary-300 focus:ring-primary-200/50 focus-visible:outline-none sm:text-sm", {
              "border-red-400": s.error,
              "border-gray-300": !s.error
            }]
          }, s.$attrs), null, 16, vu), [
            [St, o.value]
          ])
        ])
      ]),
      _: 1
    }, 16));
  }
}), hu = { name: "Email" }, Od = /* @__PURE__ */ O({
  ...hu,
  props: {
    id: {},
    placeholder: {},
    modelValue: {},
    description: {},
    error: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const l = ke(e, n);
    return (o, s) => (c(), M(mt, K({
      modelValue: $(l),
      "onUpdate:modelValue": s[0] || (s[0] = (a) => Se(l) ? l.value = a : null),
      type: "email"
    }, { ...o.$props, ...o.$attrs }), null, 16, ["modelValue"]));
  }
}), gu = { class: "flex items-center space-x-2" }, bu = ["src", "alt"], yu = { name: "Image" }, Ed = /* @__PURE__ */ O({
  ...yu,
  props: {
    id: {},
    placeholder: {},
    modelValue: {},
    description: {},
    error: {},
    currentImage: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, r = n, l = _(), o = y({
      get: () => t.modelValue,
      set: (i) => r("update:modelValue", i)
    }), s = y(() => o.value ? URL.createObjectURL(o.value) : null), a = (i) => {
      o.value = i.target.files[0];
    };
    return (i, p) => (c(), M(Oe, K(i.$props, { shadow: !1 }), {
      default: k(() => {
        var d;
        return [
          u("div", gu, [
            u("img", {
              src: (d = s.value) != null ? d : i.currentImage,
              class: "h-24 w-24 rounded-full",
              alt: i.id
            }, null, 8, bu),
            u("input", {
              ref_key: "image",
              ref: l,
              type: "file",
              accept: "image/gif, image/jpeg, image/png",
              hidden: "",
              onInput: a
            }, null, 544),
            V(ze, {
              as: "button",
              type: "button",
              onClick: p[0] || (p[0] = (v) => l.value.click())
            }, {
              default: k(() => p[1] || (p[1] = [
                ne("Change")
              ])),
              _: 1
            })
          ])
        ];
      }),
      _: 1
    }, 16));
  }
}), wu = ["id"], xu = { name: "Hidden" }, Cd = /* @__PURE__ */ O({
  ...xu,
  props: {
    id: {},
    placeholder: {},
    modelValue: {},
    error: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const l = ke(e, n);
    return (o, s) => (c(), m("div", null, [
      ce(u("input", K({
        id: o.id,
        "onUpdate:modelValue": s[0] || (s[0] = (a) => Se(l) ? l.value = a : null),
        type: "hidden"
      }, o.$attrs), null, 16, wu), [
        [Fe, $(l)]
      ]),
      o.error ? (c(), M(Gt, {
        key: 0,
        error: o.error
      }, null, 8, ["error"])) : L("", !0)
    ]));
  }
}), _u = ["for"], $u = { name: "Label" }, Id = /* @__PURE__ */ O({
  ...$u,
  props: {
    for: {}
  },
  setup(e) {
    const n = e;
    return (t, r) => (c(), m("label", {
      for: n.for,
      class: "block text-sm font-medium capitalize leading-5 text-gray-700"
    }, [
      D(t.$slots, "default")
    ], 8, _u));
  }
}), Su = { class: "relative mt-1 rounded-md" }, ku = ["id", "placeholder", "step", "disabled", "readonly"], Ou = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
}, Eu = { class: "text-gray-500 sm:text-sm sm:leading-5" }, Cu = { name: "Number" }, Td = /* @__PURE__ */ O({
  ...Cu,
  props: {
    modelValue: {},
    id: {},
    placeholder: {},
    description: {},
    error: {},
    step: { default: 1 },
    numberType: {},
    readonly: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const l = ke(e, n);
    return (o, s) => (c(), M(Oe, Ue(He(o.$props)), {
      default: k(() => [
        u("div", Su, [
          ce(u("input", K({
            id: o.id,
            "onUpdate:modelValue": s[0] || (s[0] = (a) => Se(l) ? l.value = a : null),
            type: "number",
            placeholder: o.placeholder,
            step: o.step,
            min: "0",
            class: ["mt-1 block w-full rounded-md border px-3 py-2 transition duration-150 ease-in-out focus:border-primary-300 focus:ring-primary-200/50 focus-visible:outline-none sm:text-sm", {
              "pr-10": o.numberType,
              "border-red-400": o.error,
              "border-gray-300": !o.error
            }],
            disabled: o.disabled,
            readonly: o.readonly
          }, o.$attrs), null, 16, ku), [
            [Fe, $(l)]
          ]),
          o.numberType ? (c(), m("div", Ou, [
            u("span", Eu, F(o.numberType), 1)
          ])) : L("", !0)
        ])
      ]),
      _: 1
    }, 16));
  }
}), Iu = { class: "mt-1 flex space-x-2" }, Tu = ["id", "step", "min", "max", "placeholder"], Pu = ["id", "step", "min", "max", "placeholder"], Bu = { name: "NumberRange" }, Pd = /* @__PURE__ */ O({
  ...Bu,
  props: {
    id: {},
    modelValue: {},
    from: {},
    to: {},
    min: {},
    max: {},
    step: { default: "1" },
    description: {},
    minPlaceholder: {},
    maxPlaceholder: {},
    error: {}
  },
  emits: ["update:modelValue", "update:from", "update:to"],
  setup(e, { emit: n }) {
    const t = e, r = n, l = _(t.modelValue ? t.modelValue[0] : t.from ? t.from : null), o = _(t.modelValue ? t.modelValue[1] : t.to ? t.to : null);
    return te(l, (s) => {
      r("update:modelValue", [s, o.value]), r("update:from", s);
    }), te(o, (s) => {
      r("update:modelValue", [l.value, s]), r("update:to", s);
    }), (s, a) => (c(), M(Oe, K(s.$props, { shadow: !1 }), {
      default: k(() => [
        u("div", Iu, [
          ce(u("input", K({
            id: s.id,
            "onUpdate:modelValue": a[0] || (a[0] = (i) => l.value = i),
            type: "number",
            step: s.step,
            min: s.min,
            max: s.max,
            placeholder: s.minPlaceholder,
            class: "mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm transition duration-150 ease-in-out focus:border-primary-300 focus:ring-primary-200/50 focus-visible:outline-none sm:text-sm"
          }, s.$attrs), null, 16, Tu), [
            [Fe, l.value]
          ]),
          ce(u("input", K({
            id: s.id,
            "onUpdate:modelValue": a[1] || (a[1] = (i) => o.value = i),
            type: "number",
            step: s.step,
            min: s.min,
            max: s.max,
            placeholder: s.maxPlaceholder,
            class: "mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm transition duration-150 ease-in-out focus:border-primary-300 focus:ring-primary-200/50 focus-visible:outline-none sm:text-sm"
          }, s.$attrs), null, 16, Pu), [
            [Fe, o.value]
          ])
        ])
      ]),
      _: 1
    }, 16));
  }
}), Ru = { name: "Password" }, Bd = /* @__PURE__ */ O({
  ...Ru,
  props: {
    modelValue: {},
    id: {},
    placeholder: {},
    description: {},
    error: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const l = ke(e, n);
    return (o, s) => (c(), M(mt, K({
      modelValue: $(l),
      "onUpdate:modelValue": s[0] || (s[0] = (a) => Se(l) ? l.value = a : null),
      type: "password"
    }, { ...o.$props, ...o.$attrs }), null, 16, ["modelValue"]));
  }
}), Mu = { class: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" }, Au = { class: "text-gray-500 sm:text-sm sm:leading-5" }, Vu = ["id", "placeholder", "disabled", "readonly"], Du = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3" }, Fu = { class: "text-gray-500 sm:text-sm sm:leading-5" }, Lu = {
  key: 0,
  class: "mt-2 text-xs text-gray-500"
}, Nu = { name: "Price" }, Rd = /* @__PURE__ */ O({
  ...Nu,
  props: {
    modelValue: {},
    id: {},
    placeholder: {},
    description: {},
    error: {},
    symbol: { default: "$" },
    code: { default: "AUD" },
    readonly: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const l = ke(e, n);
    return (o, s) => (c(), m("div", null, [
      u("div", {
        class: W(["relative mt-1 rounded-md", {
          "border-red-400": o.error,
          "border-gray-300": !o.error
        }])
      }, [
        u("div", Mu, [
          u("span", Au, F(o.symbol), 1)
        ]),
        ce(u("input", K({
          id: o.id,
          "onUpdate:modelValue": s[0] || (s[0] = (a) => Se(l) ? l.value = a : null),
          type: "number",
          placeholder: o.placeholder,
          min: "0",
          step: "0.01",
          class: "block w-full rounded-md border border-gray-300 py-2 pl-7 pr-12 shadow-sm focus:border-primary-300 focus:ring-primary-200/50 focus-visible:outline-none sm:text-sm",
          "aria-describedby": "price-currency",
          disabled: o.disabled,
          readonly: o.readonly
        }, o.$attrs), null, 16, Vu), [
          [Fe, $(l)]
        ]),
        u("div", Du, [
          u("span", Fu, F(o.code), 1)
        ])
      ], 2),
      o.description ? (c(), m("p", Lu, F(o.description), 1)) : L("", !0),
      o.error ? (c(), M(Gt, {
        key: 1,
        error: o.error
      }, null, 8, ["error"])) : L("", !0)
    ]));
  }
}), ju = ["id", "min", "max", "step", "disabled", "readonly"], zu = { name: "RangeSlider" }, Md = /* @__PURE__ */ O({
  ...zu,
  props: {
    modelValue: {},
    id: {},
    description: {},
    error: {},
    min: { default: 1 },
    max: { default: 100 },
    step: { default: 1 },
    readonly: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const l = ke(e, n);
    return (o, s) => (c(), M(Oe, Ue(He(o.$props)), {
      default: k(() => [
        ce(u("input", K({
          id: o.id,
          "onUpdate:modelValue": s[0] || (s[0] = (a) => Se(l) ? l.value = a : null),
          type: "range",
          min: o.min,
          max: o.max,
          step: o.step,
          class: ["mt-1 block h-2 w-full cursor-pointer appearance-none rounded-md bg-gray-200 accent-primary-600", {
            "border-red-400": o.error,
            "border-gray-300": !o.error
          }],
          disabled: o.disabled,
          readonly: o.readonly
        }, o.$attrs), null, 16, ju), [
          [Fe, $(l)]
        ])
      ]),
      _: 1
    }, 16));
  }
}), Uu = ["id", "placeholder", "disabled", "readonly"], Hu = { name: "Textarea" }, Ad = /* @__PURE__ */ O({
  ...Hu,
  props: {
    modelValue: {},
    id: {},
    placeholder: {},
    description: {},
    error: {},
    readonly: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const l = ke(e, n);
    return (o, s) => (c(), M(Oe, Ue(He(o.$props)), {
      default: k(() => [
        ce(u("textarea", K({
          id: o.id,
          "onUpdate:modelValue": s[0] || (s[0] = (a) => Se(l) ? l.value = a : null),
          rows: "3",
          placeholder: o.placeholder,
          class: ["mt-1 block w-full rounded-md border px-3 py-2 transition duration-150 ease-in-out focus:border-primary-300 focus:ring-primary-200/50 sm:text-sm", {
            "border-red-400": o.error,
            "border-gray-300": !o.error
          }],
          disabled: o.disabled,
          readonly: o.readonly
        }, o.$attrs), null, 16, Uu), [
          [Fe, $(l)]
        ])
      ]),
      _: 1
    }, 16));
  }
}), Wu = ["aria-checked", "onKeydown"], Ku = { name: "Toggle" }, Vd = /* @__PURE__ */ O({
  ...Ku,
  props: {
    id: {},
    modelValue: { type: [Boolean, Array, null] },
    value: {},
    valueKey: { default: "id" },
    description: {},
    error: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, r = n, l = y({
      get: () => t.modelValue,
      set: (v) => {
        r("update:modelValue", v);
      }
    });
    function o() {
      let v = t.modelValue;
      const f = t.valueKey, h = t.value, g = h[f];
      v.some((w) => w[f] === g) ? l.value = v.filter((w) => w[f] !== g) : l.value = [...v, h];
    }
    function s() {
      let v = t.modelValue;
      const f = t.value;
      v.includes(f) ? l.value = v.filter((h) => h !== f) : l.value = [...v, f];
    }
    const a = () => {
      typeof t.value == "object" ? o() : s();
    }, i = () => {
      if (Array.isArray(t.modelValue)) {
        if (t.value === void 0)
          throw new Error("Toggle component requires a 'value' prop when using an array with v-model.");
        a();
      } else
        l.value = !l.value;
    }, p = y(() => {
      const v = gt(t.modelValue) ? $e(t.modelValue) : t.modelValue, f = gt(t.value) ? $e(t.value) : t.value, h = gt(t.valueKey) ? $e(t.valueKey) : t.valueKey;
      return !Array.isArray(v) || f === null ? !1 : typeof f == "object" ? v.some((g) => g[h] === f[h]) : v.includes(f);
    }), d = y(() => p.value || t.modelValue === !0);
    return (v, f) => (c(), M(Oe, K(v.$props, { shadow: !1 }), {
      default: k(() => [
        u("button", {
          type: "button",
          class: "group relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2",
          role: "checkbox",
          tabindex: "0",
          "aria-checked": d.value,
          onClick: i,
          onKeydown: kt(De(i, ["prevent"]), ["space"])
        }, [
          f[0] || (f[0] = u("span", {
            "aria-hidden": "true",
            class: "pointer-events-none absolute h-full w-full rounded-md bg-white"
          }, null, -1)),
          u("span", {
            "aria-hidden": "true",
            class: W(["pointer-events-none absolute mx-auto h-4 w-9 rounded-full bg-gray-200 transition-colors duration-200 ease-in-out", { "bg-indigo-600": d.value, "bg-gray-200": !d.value }])
          }, null, 2),
          u("span", {
            "aria-hidden": "true",
            class: W(["pointer-events-none absolute left-0 inline-block h-5 w-5 translate-x-0 rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out", { "translate-x-5": d.value, "translate-x-0": !d.value }])
          }, null, 2)
        ], 40, Wu)
      ]),
      _: 1
    }, 16));
  }
});
var dl = {}, cl = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function n(r, l) {
    return {
      handler: r,
      config: l
    };
  }
  n.withOptions = function(r, l = () => ({})) {
    const o = function(s) {
      return {
        __options: s,
        handler: r(s),
        config: l(s)
      };
    };
    return o.__isOptionsFunction = !0, o.__pluginFunction = r, o.__configFunction = l, o;
  };
  const t = n;
})(cl);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return r;
    }
  });
  const n = /* @__PURE__ */ t(cl);
  function t(l) {
    return l && l.__esModule ? l : {
      default: l
    };
  }
  const r = n.default;
})(dl);
let _t = dl;
var Zu = (_t.__esModule ? _t : { default: _t }).default, pl = {}, fl = {}, Qt = { exports: {} }, H = String, vl = function() {
  return { isColorSupported: !1, reset: H, bold: H, dim: H, italic: H, underline: H, inverse: H, hidden: H, strikethrough: H, black: H, red: H, green: H, yellow: H, blue: H, magenta: H, cyan: H, white: H, gray: H, bgBlack: H, bgRed: H, bgGreen: H, bgYellow: H, bgBlue: H, bgMagenta: H, bgCyan: H, bgWhite: H, blackBright: H, redBright: H, greenBright: H, yellowBright: H, blueBright: H, magentaBright: H, cyanBright: H, whiteBright: H, bgBlackBright: H, bgRedBright: H, bgGreenBright: H, bgYellowBright: H, bgBlueBright: H, bgMagentaBright: H, bgCyanBright: H, bgWhiteBright: H };
};
Qt.exports = vl();
Qt.exports.createColors = vl;
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function n(i, p) {
    for (var d in p)
      Object.defineProperty(i, d, {
        enumerable: !0,
        get: p[d]
      });
  }
  n(e, {
    dim: function() {
      return s;
    },
    default: function() {
      return a;
    }
  });
  const t = /* @__PURE__ */ r(Qt.exports);
  function r(i) {
    return i && i.__esModule ? i : {
      default: i
    };
  }
  let l = /* @__PURE__ */ new Set();
  function o(i, p, d) {
    typeof process < "u" && process.env.JEST_WORKER_ID || d && l.has(d) || (d && l.add(d), console.warn(""), p.forEach((v) => console.warn(i, "-", v)));
  }
  function s(i) {
    return t.default.dim(i);
  }
  const a = {
    info(i, p) {
      o(t.default.bold(t.default.cyan("info")), ...Array.isArray(i) ? [
        i
      ] : [
        p,
        i
      ]);
    },
    warn(i, p) {
      o(t.default.bold(t.default.yellow("warn")), ...Array.isArray(i) ? [
        i
      ] : [
        p,
        i
      ]);
    },
    risk(i, p) {
      o(t.default.bold(t.default.magenta("risk")), ...Array.isArray(i) ? [
        i
      ] : [
        p,
        i
      ]);
    }
  };
})(fl);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return l;
    }
  });
  const n = /* @__PURE__ */ t(fl);
  function t(o) {
    return o && o.__esModule ? o : {
      default: o
    };
  }
  function r({ version: o, from: s, to: a }) {
    n.default.warn(`${s}-color-renamed`, [
      `As of Tailwind CSS ${o}, \`${s}\` has been renamed to \`${a}\`.`,
      "Update your configuration file to silence this warning."
    ]);
  }
  const l = {
    inherit: "inherit",
    current: "currentColor",
    transparent: "transparent",
    black: "#000",
    white: "#fff",
    slate: {
      50: "#f8fafc",
      100: "#f1f5f9",
      200: "#e2e8f0",
      300: "#cbd5e1",
      400: "#94a3b8",
      500: "#64748b",
      600: "#475569",
      700: "#334155",
      800: "#1e293b",
      900: "#0f172a",
      950: "#020617"
    },
    gray: {
      50: "#f9fafb",
      100: "#f3f4f6",
      200: "#e5e7eb",
      300: "#d1d5db",
      400: "#9ca3af",
      500: "#6b7280",
      600: "#4b5563",
      700: "#374151",
      800: "#1f2937",
      900: "#111827",
      950: "#030712"
    },
    zinc: {
      50: "#fafafa",
      100: "#f4f4f5",
      200: "#e4e4e7",
      300: "#d4d4d8",
      400: "#a1a1aa",
      500: "#71717a",
      600: "#52525b",
      700: "#3f3f46",
      800: "#27272a",
      900: "#18181b",
      950: "#09090b"
    },
    neutral: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#e5e5e5",
      300: "#d4d4d4",
      400: "#a3a3a3",
      500: "#737373",
      600: "#525252",
      700: "#404040",
      800: "#262626",
      900: "#171717",
      950: "#0a0a0a"
    },
    stone: {
      50: "#fafaf9",
      100: "#f5f5f4",
      200: "#e7e5e4",
      300: "#d6d3d1",
      400: "#a8a29e",
      500: "#78716c",
      600: "#57534e",
      700: "#44403c",
      800: "#292524",
      900: "#1c1917",
      950: "#0c0a09"
    },
    red: {
      50: "#fef2f2",
      100: "#fee2e2",
      200: "#fecaca",
      300: "#fca5a5",
      400: "#f87171",
      500: "#ef4444",
      600: "#dc2626",
      700: "#b91c1c",
      800: "#991b1b",
      900: "#7f1d1d",
      950: "#450a0a"
    },
    orange: {
      50: "#fff7ed",
      100: "#ffedd5",
      200: "#fed7aa",
      300: "#fdba74",
      400: "#fb923c",
      500: "#f97316",
      600: "#ea580c",
      700: "#c2410c",
      800: "#9a3412",
      900: "#7c2d12",
      950: "#431407"
    },
    amber: {
      50: "#fffbeb",
      100: "#fef3c7",
      200: "#fde68a",
      300: "#fcd34d",
      400: "#fbbf24",
      500: "#f59e0b",
      600: "#d97706",
      700: "#b45309",
      800: "#92400e",
      900: "#78350f",
      950: "#451a03"
    },
    yellow: {
      50: "#fefce8",
      100: "#fef9c3",
      200: "#fef08a",
      300: "#fde047",
      400: "#facc15",
      500: "#eab308",
      600: "#ca8a04",
      700: "#a16207",
      800: "#854d0e",
      900: "#713f12",
      950: "#422006"
    },
    lime: {
      50: "#f7fee7",
      100: "#ecfccb",
      200: "#d9f99d",
      300: "#bef264",
      400: "#a3e635",
      500: "#84cc16",
      600: "#65a30d",
      700: "#4d7c0f",
      800: "#3f6212",
      900: "#365314",
      950: "#1a2e05"
    },
    green: {
      50: "#f0fdf4",
      100: "#dcfce7",
      200: "#bbf7d0",
      300: "#86efac",
      400: "#4ade80",
      500: "#22c55e",
      600: "#16a34a",
      700: "#15803d",
      800: "#166534",
      900: "#14532d",
      950: "#052e16"
    },
    emerald: {
      50: "#ecfdf5",
      100: "#d1fae5",
      200: "#a7f3d0",
      300: "#6ee7b7",
      400: "#34d399",
      500: "#10b981",
      600: "#059669",
      700: "#047857",
      800: "#065f46",
      900: "#064e3b",
      950: "#022c22"
    },
    teal: {
      50: "#f0fdfa",
      100: "#ccfbf1",
      200: "#99f6e4",
      300: "#5eead4",
      400: "#2dd4bf",
      500: "#14b8a6",
      600: "#0d9488",
      700: "#0f766e",
      800: "#115e59",
      900: "#134e4a",
      950: "#042f2e"
    },
    cyan: {
      50: "#ecfeff",
      100: "#cffafe",
      200: "#a5f3fc",
      300: "#67e8f9",
      400: "#22d3ee",
      500: "#06b6d4",
      600: "#0891b2",
      700: "#0e7490",
      800: "#155e75",
      900: "#164e63",
      950: "#083344"
    },
    sky: {
      50: "#f0f9ff",
      100: "#e0f2fe",
      200: "#bae6fd",
      300: "#7dd3fc",
      400: "#38bdf8",
      500: "#0ea5e9",
      600: "#0284c7",
      700: "#0369a1",
      800: "#075985",
      900: "#0c4a6e",
      950: "#082f49"
    },
    blue: {
      50: "#eff6ff",
      100: "#dbeafe",
      200: "#bfdbfe",
      300: "#93c5fd",
      400: "#60a5fa",
      500: "#3b82f6",
      600: "#2563eb",
      700: "#1d4ed8",
      800: "#1e40af",
      900: "#1e3a8a",
      950: "#172554"
    },
    indigo: {
      50: "#eef2ff",
      100: "#e0e7ff",
      200: "#c7d2fe",
      300: "#a5b4fc",
      400: "#818cf8",
      500: "#6366f1",
      600: "#4f46e5",
      700: "#4338ca",
      800: "#3730a3",
      900: "#312e81",
      950: "#1e1b4b"
    },
    violet: {
      50: "#f5f3ff",
      100: "#ede9fe",
      200: "#ddd6fe",
      300: "#c4b5fd",
      400: "#a78bfa",
      500: "#8b5cf6",
      600: "#7c3aed",
      700: "#6d28d9",
      800: "#5b21b6",
      900: "#4c1d95",
      950: "#2e1065"
    },
    purple: {
      50: "#faf5ff",
      100: "#f3e8ff",
      200: "#e9d5ff",
      300: "#d8b4fe",
      400: "#c084fc",
      500: "#a855f7",
      600: "#9333ea",
      700: "#7e22ce",
      800: "#6b21a8",
      900: "#581c87",
      950: "#3b0764"
    },
    fuchsia: {
      50: "#fdf4ff",
      100: "#fae8ff",
      200: "#f5d0fe",
      300: "#f0abfc",
      400: "#e879f9",
      500: "#d946ef",
      600: "#c026d3",
      700: "#a21caf",
      800: "#86198f",
      900: "#701a75",
      950: "#4a044e"
    },
    pink: {
      50: "#fdf2f8",
      100: "#fce7f3",
      200: "#fbcfe8",
      300: "#f9a8d4",
      400: "#f472b6",
      500: "#ec4899",
      600: "#db2777",
      700: "#be185d",
      800: "#9d174d",
      900: "#831843",
      950: "#500724"
    },
    rose: {
      50: "#fff1f2",
      100: "#ffe4e6",
      200: "#fecdd3",
      300: "#fda4af",
      400: "#fb7185",
      500: "#f43f5e",
      600: "#e11d48",
      700: "#be123c",
      800: "#9f1239",
      900: "#881337",
      950: "#4c0519"
    },
    get lightBlue() {
      return r({
        version: "v2.2",
        from: "lightBlue",
        to: "sky"
      }), this.sky;
    },
    get warmGray() {
      return r({
        version: "v3.0",
        from: "warmGray",
        to: "stone"
      }), this.stone;
    },
    get trueGray() {
      return r({
        version: "v3.0",
        from: "trueGray",
        to: "neutral"
      }), this.neutral;
    },
    get coolGray() {
      return r({
        version: "v3.0",
        from: "coolGray",
        to: "gray"
      }), this.gray;
    },
    get blueGray() {
      return r({
        version: "v3.0",
        from: "blueGray",
        to: "slate"
      }), this.slate;
    }
  };
})(pl);
let $t = pl;
var qu = ($t.__esModule ? $t : { default: $t }).default;
const Dd = Zu.withOptions(
  function() {
    return function() {
    };
  },
  function(e = {}) {
    var n;
    return {
      theme: {
        extend: {
          colors: {
            primary: {
              ...qu.indigo,
              ...(n = e == null ? void 0 : e.colors) == null ? void 0 : n.primary
            }
          }
        }
      }
    };
  }
);
export {
  _d as Actions,
  od as Badge,
  pd as Breadcrumbs,
  Sd as Checkbox,
  $d as Combobox,
  fd as Container,
  Yu as DangerAlert,
  Xu as DangerAlertButton,
  ad as DangerBadge,
  ud as DangerButton,
  md as DataTable,
  vs as Date,
  kd as DateRange,
  Dt as Dropdown,
  ut as DropdownItem,
  Od as Email,
  Gt as Error,
  hd as Heading,
  Cd as Hidden,
  Ed as Image,
  Ju as InfoAlert,
  ed as InfoAlertButton,
  dd as KpiCard,
  cd as KpiElement,
  Id as Label,
  _s as Modal,
  gd as Notifications,
  Td as Number,
  Pd as NumberRange,
  os as Pagination,
  Bd as Password,
  Rd as Price,
  tn as PrimaryButton,
  Md as RangeSlider,
  ze as SecondaryButton,
  ys as Select,
  bd as Slideover,
  yd as StackedList,
  td as SuccessAlert,
  nd as SuccessAlertButton,
  sd as SuccessBadge,
  wd as Tabs,
  mt as Text,
  Ad as Textarea,
  Vd as Toggle,
  xd as Tooltip,
  ld as WarningAlert,
  rd as WarningAlertButton,
  id as WarningBadge,
  Dd as theme
};
